/**
 * Generated by orval v7.14.0 🍺
 * Do not edit manually.
 * RealEstateChatBot | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface AnalysisKeywordsResult {
  key?: ChatBotHistoryKey;
  keywords?: string[];
}

export interface AnalysisKeywordsResultGroup {
  results?: AnalysisKeywordsResult[];
  center?: AnalysisKeywordsResult;
}

export type ApplyBotConfigRequestBotConfig = null | JsonElement;

export interface ApplyBotConfigRequest {
  botConfig?: ApplyBotConfigRequestBotConfig;
}

export type AppriseNotificationFormat = typeof AppriseNotificationFormat[keyof typeof AppriseNotificationFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppriseNotificationFormat = {
  Text: 'Text',
  Markdown: 'Markdown',
  Html: 'Html',
} as const;

export type AppriseNotificationSettingsDataType = null | AppriseNotificationType;

export type AppriseNotificationSettingsDataFormat = null | AppriseNotificationFormat;

export interface AppriseNotificationSettingsData {
  urls?: string;
  title?: string;
  type?: AppriseNotificationSettingsDataType;
  format?: AppriseNotificationSettingsDataFormat;
}

export type AppriseNotificationType = typeof AppriseNotificationType[keyof typeof AppriseNotificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppriseNotificationType = {
  Info: 'Info',
  Success: 'Success',
  Warning: 'Warning',
  Failure: 'Failure',
} as const;

export interface AssetBundleItem {
  bundleName?: string;
  files?: string[];
  totalSize?: number;
}

export interface AuthState {
  provider?: UserProvider;
  userName?: string;
  displayName?: string;
  role?: AuthStateRole;
}

export type AuthStateRole = typeof AuthStateRole[keyof typeof AuthStateRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthStateRole = {
  user: 'user',
  admin: 'admin',
} as const;

export interface AuthViewModel {
  userName?: string;
  password?: string;
}

export type BotConfigWaitingResponseMessage = null | string;

export type BotConfigErrorMessage = null | string;

export interface BotConfig {
  waitingResponseTime?: number;
  waitingResponseMessage?: BotConfigWaitingResponseMessage;
  errorMessage?: BotConfigErrorMessage;
}

export interface BotMessage {
  message?: string;
}

export type BotProviderName = null | string;

export type BotProviderChatBotDataId = null | string;

export type BotProviderMetadata = {[key: string]: string};

export interface BotProvider {
  providerData?: BsonDocument;
  name?: BotProviderName;
  chatBotDataId?: BotProviderChatBotDataId;
  textProcessConfig?: TextProcessConfig;
  botConfig?: BotConfig;
  userChatHandlerConfigs?: ChatHandlerConfig[];
  type?: BotProviderType;
  metadata?: BotProviderMetadata;
  workspaceId?: string;
  id?: string;
}

export interface BotProviderChatHandlerAction {
  tags?: string[];
  disableReply?: boolean;
}

export interface BotProviderDataScheme {
  line?: LineBotProviderData;
  web?: WebBotProviderData;
}

export interface BotProviderImportModel {
  importData?: BotProvider;
}

export type BotProviderStatisticsTokenUsage = {[key: string]: TokenUsageData};

export type BotProviderStatisticsChatCounts = {[key: string]: number};

export interface BotProviderStatistics {
  botProviderId?: string;
  tokenUsage?: BotProviderStatisticsTokenUsage;
  chatCounts?: BotProviderStatisticsChatCounts;
  workspaceId?: string;
  id?: string;
}

export type BotProviderType = typeof BotProviderType[keyof typeof BotProviderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BotProviderType = {
  None: 'None',
  Line: 'Line',
  Web: 'Web',
} as const;

export type BotProviderUserSettingsName = null | string;

export interface BotProviderUserSettings {
  name?: BotProviderUserSettingsName;
  botProviderId?: string;
  userId?: string;
  disableReply?: boolean;
  historyStartTimestamp?: number;
  tags?: string[];
  workspaceId?: string;
  id?: string;
}

export interface BsonDocument {}

export type CakeChatBotConfigOverrideText = null | WebBotTextConfig;

export type CakeChatBotConfigOverrideTheme = null | WebBotThemeConfig;

export type CakeChatBotConfigOverrideBackground = null | WebBotBackgroundConfig;

export type CakeChatBotConfigOverrideHeader = null | WebBotHeaderFooterConfig;

export type CakeChatBotConfigOverrideFooter = null | WebBotHeaderFooterConfig;

export type CakeChatBotConfigOverrideUserBubble = null | WebBotBubbleConfig;

export type CakeChatBotConfigOverrideBotBubble = null | WebBotBubbleConfig;

export type CakeChatBotConfigOverrideMessageMeta = null | WebBotMessageMetaConfig;

export type CakeChatBotConfigOverrideLayout = null | WebBotLayoutConfig;

export type CakeChatBotConfigOverrideResponsive = null | WebBotResponsiveConfig;

export type CakeChatBotConfigOverrideFeatures = null | WebBotFeaturesConfig;

export type CakeChatBotConfigOverrideExtensions = null | ExtensionSlotConfig[];

export type CakeChatBotConfigOverrideCustomUi = null | WebBotCustomUiConfig;

export interface CakeChatBotConfigOverride {
  text?: CakeChatBotConfigOverrideText;
  theme?: CakeChatBotConfigOverrideTheme;
  background?: CakeChatBotConfigOverrideBackground;
  header?: CakeChatBotConfigOverrideHeader;
  footer?: CakeChatBotConfigOverrideFooter;
  userBubble?: CakeChatBotConfigOverrideUserBubble;
  botBubble?: CakeChatBotConfigOverrideBotBubble;
  messageMeta?: CakeChatBotConfigOverrideMessageMeta;
  layout?: CakeChatBotConfigOverrideLayout;
  responsive?: CakeChatBotConfigOverrideResponsive;
  features?: CakeChatBotConfigOverrideFeatures;
  extensions?: CakeChatBotConfigOverrideExtensions;
  customUi?: CakeChatBotConfigOverrideCustomUi;
}

export interface ChangePasswordModel {
  oldPassword?: string;
  newPassword?: string;
}

export type ChatBotDataEmbeddingCollectionConfigs = null | EmbeddingCollectionConfig[];

export interface ChatBotData {
  chatConfig?: ChatConfig;
  tagsConfig?: TagsConfig;
  embeddingCollectionConfigs?: ChatBotDataEmbeddingCollectionConfigs;
  testConfig?: TestConfig;
  name?: string;
  workspaceId?: string;
  id?: string;
}

export interface ChatBotDataImportModel {
  importData?: ChatBotData;
}

export type ChatBotFeedbackRatingProperty = null | ChatBotFeedbackRating;

export type ChatBotFeedbackComment = null | string;

export interface ChatBotFeedback {
  rating?: ChatBotFeedbackRatingProperty;
  comment?: ChatBotFeedbackComment;
  timestamp?: number;
}

export type ChatBotFeedbackRating = typeof ChatBotFeedbackRating[keyof typeof ChatBotFeedbackRating];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatBotFeedbackRating = {
  Good: 'Good',
  Bad: 'Bad',
} as const;

export type ChatBotHistoryClientInfo = null | UserClientInfo;

export type ChatBotHistoryFeedback = null | ChatBotFeedback;

export interface ChatBotHistory {
  botProviderId?: string;
  userId?: string;
  clientInfo?: ChatBotHistoryClientInfo;
  provider?: BotProviderType;
  chatBotDataId?: string;
  botId?: string;
  createdTimestamp?: number;
  records?: ChatBotRecord[];
  toolRecords?: ChatBotToolRecord[];
  mediaUrls?: MediaUrl[];
  tokenUsage?: TokenUsageDataWithModel[];
  tags?: string[];
  feedback?: ChatBotHistoryFeedback;
  id?: string;
}

export type ChatBotHistoryExportRequestTimeZone = null | string;

export type ChatBotHistoryExportRequestUserName = null | string;

export type ChatBotHistoryExportRequestDisableReply = null | boolean;

export type ChatBotHistoryExportRequestBotProviderId = null | string;

export type ChatBotHistoryExportRequestUserId = null | string;

export type ChatBotHistoryExportRequestChatBotDataId = null | string;

export type ChatBotHistoryExportRequestBotId = null | string;

export type ChatBotHistoryExportRequestHasFeedback = null | boolean;

export type ChatBotHistoryExportRequestFeedbackRating = null | ChatBotFeedbackRating;

export interface ChatBotHistoryExportRequest {
  timeZone?: ChatBotHistoryExportRequestTimeZone;
  recordsPerUser?: number;
  includeTime?: boolean;
  includeMediaUrls?: boolean;
  includeTags?: boolean;
  includeFeedback?: boolean;
  includeClientInfo?: boolean;
  includeTokenUsage?: boolean;
  includeToolRecords?: boolean;
  userSettingTags?: string[];
  userName?: ChatBotHistoryExportRequestUserName;
  disableReply?: ChatBotHistoryExportRequestDisableReply;
  botProviderId?: ChatBotHistoryExportRequestBotProviderId;
  userId?: ChatBotHistoryExportRequestUserId;
  chatBotDataId?: ChatBotHistoryExportRequestChatBotDataId;
  provider?: BotProviderType;
  botId?: ChatBotHistoryExportRequestBotId;
  tags?: string[];
  startTimestamp?: number;
  endTimestamp?: number;
  hasFeedback?: ChatBotHistoryExportRequestHasFeedback;
  feedbackRating?: ChatBotHistoryExportRequestFeedbackRating;
}

export interface ChatBotHistoryGroupWithUserSettings {
  userSettings?: BotProviderUserSettings;
  key?: ChatBotHistoryKey;
  items?: ChatBotHistory[];
}

export interface ChatBotHistoryKey {
  botProviderId?: string;
  userId?: string;
}

export type ChatBotHistorySearchBotProviderId = null | string;

export type ChatBotHistorySearchUserId = null | string;

export type ChatBotHistorySearchChatBotDataId = null | string;

export type ChatBotHistorySearchBotId = null | string;

export type ChatBotHistorySearchHasFeedback = null | boolean;

export type ChatBotHistorySearchFeedbackRating = null | ChatBotFeedbackRating;

export interface ChatBotHistorySearch {
  botProviderId?: ChatBotHistorySearchBotProviderId;
  userId?: ChatBotHistorySearchUserId;
  chatBotDataId?: ChatBotHistorySearchChatBotDataId;
  provider?: BotProviderType;
  botId?: ChatBotHistorySearchBotId;
  tags?: string[];
  startTimestamp?: number;
  endTimestamp?: number;
  hasFeedback?: ChatBotHistorySearchHasFeedback;
  feedbackRating?: ChatBotHistorySearchFeedbackRating;
}

export type ChatBotHistoryUserSettingSearchUserName = null | string;

export type ChatBotHistoryUserSettingSearchDisableReply = null | boolean;

export type ChatBotHistoryUserSettingSearchBotProviderId = null | string;

export type ChatBotHistoryUserSettingSearchUserId = null | string;

export type ChatBotHistoryUserSettingSearchChatBotDataId = null | string;

export type ChatBotHistoryUserSettingSearchBotId = null | string;

export type ChatBotHistoryUserSettingSearchHasFeedback = null | boolean;

export type ChatBotHistoryUserSettingSearchFeedbackRating = null | ChatBotFeedbackRating;

export interface ChatBotHistoryUserSettingSearch {
  userSettingTags?: string[];
  userName?: ChatBotHistoryUserSettingSearchUserName;
  disableReply?: ChatBotHistoryUserSettingSearchDisableReply;
  botProviderId?: ChatBotHistoryUserSettingSearchBotProviderId;
  userId?: ChatBotHistoryUserSettingSearchUserId;
  chatBotDataId?: ChatBotHistoryUserSettingSearchChatBotDataId;
  provider?: BotProviderType;
  botId?: ChatBotHistoryUserSettingSearchBotId;
  tags?: string[];
  startTimestamp?: number;
  endTimestamp?: number;
  hasFeedback?: ChatBotHistoryUserSettingSearchHasFeedback;
  feedbackRating?: ChatBotHistoryUserSettingSearchFeedbackRating;
}

export type ChatBotHistoryWithUserSettingsUserSettings = null | BotProviderUserSettings;

export type ChatBotHistoryWithUserSettingsClientInfo = null | UserClientInfo;

export type ChatBotHistoryWithUserSettingsFeedback = null | ChatBotFeedback;

export interface ChatBotHistoryWithUserSettings {
  userSettings?: ChatBotHistoryWithUserSettingsUserSettings;
  botProviderId?: string;
  userId?: string;
  clientInfo?: ChatBotHistoryWithUserSettingsClientInfo;
  provider?: BotProviderType;
  chatBotDataId?: string;
  botId?: string;
  createdTimestamp?: number;
  records?: ChatBotRecord[];
  toolRecords?: ChatBotToolRecord[];
  mediaUrls?: MediaUrl[];
  tokenUsage?: TokenUsageDataWithModel[];
  tags?: string[];
  feedback?: ChatBotHistoryWithUserSettingsFeedback;
  id?: string;
}

export type ChatBotMessageMessage = null | string;

export interface ChatBotMessage {
  role?: ChatBotRecordRole;
  message?: ChatBotMessageMessage;
}

export type ChatBotRecordMessage = null | string;

export interface ChatBotRecord {
  timestamp?: number;
  role?: ChatBotRecordRole;
  message?: ChatBotRecordMessage;
}

export type ChatBotRecordRole = typeof ChatBotRecordRole[keyof typeof ChatBotRecordRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatBotRecordRole = {
  System: 'System',
  User: 'User',
  Tool: 'Tool',
  Assistant: 'Assistant',
} as const;

export type ChatBotToolRecordMessage = null | string;

export interface ChatBotToolRecord {
  pluginName?: string;
  functionName?: string;
  arguments?: string;
  timestamp?: number;
  role?: ChatBotRecordRole;
  message?: ChatBotToolRecordMessage;
}

export type ChatConfigModelId = null | string;

export type ChatConfigSystemName = null | string;

export interface ChatConfig {
  modelId?: ChatConfigModelId;
  systemName?: ChatConfigSystemName;
  systemPrompt?: string;
  additionalPrompts?: ChatBotMessage[];
  maxHistoryRecordsCount?: number;
  historyExpiredTime?: number;
  maxSearchContextTokens?: number;
  embeddingThreshold?: number;
  temperature?: number;
  topP?: number;
  denseWeight?: number;
  sparseWeight?: number;
  keepToolRecords?: boolean;
  allowParallelCalls?: boolean;
  seed?: number;
}

export interface ChatCreditKey {
  userId?: string;
  credit?: number;
  totalCredit?: number;
  description?: string;
  createdTimestamp?: number;
  startTimestamp?: number;
  endTimestamp?: number;
  id?: string;
}

export interface ChatEvaluationTest {
  results?: ChatEvaluationTestResult[];
  testSetId?: string;
  name?: string;
  createdTimestamp?: number;
  workspaceId?: string;
  id?: string;
}

export interface ChatEvaluationTestBase {
  testSetId?: string;
  name?: string;
  createdTimestamp?: number;
  workspaceId?: string;
  id?: string;
}

export type ChatEvaluationTestExecutionResultMetrics = {[key: string]: ChatEvaluationTestMetric};

export interface ChatEvaluationTestExecutionResult {
  response?: string;
  retrievedContexts?: string[];
  metrics?: ChatEvaluationTestExecutionResultMetrics;
  chatTokenUsage?: TokenUsageDataWithModel[];
  evaluationTokenUsage?: TokenUsageDataWithModel[];
  chatDurationMs?: number;
  evaluationDurationMs?: number;
}

export interface ChatEvaluationTestMetric {
  score?: number;
}

export interface ChatEvaluationTestResult {
  sample?: ChatEvaluationTestResultSample;
  executionResults?: ChatEvaluationTestExecutionResult[];
}

export interface ChatEvaluationTestResultSample {
  userInput?: string;
  reference?: string;
}

export type ChatEvaluationTestSetName = null | string;

export interface ChatEvaluationTestSet {
  samples?: ChatEvaluationTestSetSample[];
  name?: ChatEvaluationTestSetName;
  workspaceId?: string;
  id?: string;
}

export type ChatEvaluationTestSetBaseName = null | string;

export interface ChatEvaluationTestSetBase {
  name?: ChatEvaluationTestSetBaseName;
  workspaceId?: string;
  id?: string;
}

export interface ChatEvaluationTestSetSample {
  sampleId?: string;
  userInput?: string;
  reference?: string;
}

export interface ChatHandlerAction {
  replyMessage?: BotMessage;
}

export interface ChatHandlerActionConfig {
  botProviderAction?: BotProviderChatHandlerAction;
  chatAction?: ChatHandlerAction;
  notificationActions?: NotificationChatHandlerAction[];
}

export interface ChatHandlerConditionConfig {
  regexConditions?: RegexChatHandlerCondition[];
}

export interface ChatHandlerConfig {
  name?: string;
  condition?: ChatHandlerConditionConfig;
  action?: ChatHandlerActionConfig;
}

export type ChatInputPublicAccessKey = null | string;

export interface ChatInput {
  publicAccessKey?: ChatInputPublicAccessKey;
  textProcessConfig?: TextProcessConfig;
  message?: string;
  toolRecords?: ChatBotToolRecord[];
  records?: ChatBotRecord[];
}

export type ChatMessageHistoryId = null | string;

export interface ChatMessage {
  historyId?: ChatMessageHistoryId;
  type?: ChatMessageType;
  texts?: string[];
  mediaUrls?: MediaUrl[];
}

export type ChatMessageType = typeof ChatMessageType[keyof typeof ChatMessageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageType = {
  Text: 'Text',
  WaitingResponse: 'WaitingResponse',
} as const;

export type ContextDataSearchText = null | string;

export interface ContextData {
  collectionId?: string;
  dataId?: string;
  searchText?: ContextDataSearchText;
  text?: string;
  score?: number;
}

export interface CreateBundleRequest {
  bundleName?: string;
}

export interface CreateCustomUiFolderRequest {
  folderPath?: string;
}

export interface CreateEvaluateTestSetJobViewModel {
  chatBotDataId?: string;
  testSetId?: string;
  /**
   * @minimum 1
   * @maximum 10
   */
  repeatCount?: number;
}

export interface CreateFolderRequest {
  bundleName?: string;
  folderPath?: string;
}

export type CreateGenerateTestSetJobViewModelTestSetId = null | string;

export type CreateGenerateTestSetJobViewModelSelectedDataIds = null | string[];

export type CreateGenerateTestSetJobViewModelSynthesizerDistributionAnyOf = {[key: string]: number};

export type CreateGenerateTestSetJobViewModelSynthesizerDistribution = null | CreateGenerateTestSetJobViewModelSynthesizerDistributionAnyOf;

export interface CreateGenerateTestSetJobViewModel {
  testSetId?: CreateGenerateTestSetJobViewModelTestSetId;
  testSetSize?: number;
  generationMode?: TestSetGenerationMode;
  targetTotalSize?: number;
  densityRatio?: number;
  selectedDataIds?: CreateGenerateTestSetJobViewModelSelectedDataIds;
  persona?: GenerateTestSetPersona;
  embeddingCollectionIds?: string[];
  synthesizerDistribution?: CreateGenerateTestSetJobViewModelSynthesizerDistribution;
}

export type CustomUiFileItemLastModified = null | string;

export interface CustomUiFileItem {
  filePath?: string;
  size?: number;
  lastModified?: CustomUiFileItemLastModified;
}

export type CustomUiUploadResultThemeName = null | string;

export type CustomUiUploadResultRecommendedBotConfig = null | CakeChatBotConfigOverride;

export type CustomUiUploadResultRawBotConfig = null | JsonElement;

export interface CustomUiUploadResult {
  configFound?: boolean;
  themeName?: CustomUiUploadResultThemeName;
  recommendedBotConfig?: CustomUiUploadResultRecommendedBotConfig;
  rawBotConfig?: CustomUiUploadResultRawBotConfig;
  config?: WebBotCustomUiConfig;
  files?: CustomUiFileItem[];
  totalSize?: number;
}

export interface DebugChatResult {
  modelId?: string;
  tokenUsage?: TokenUsageDataWithModel[];
  contexts?: ContextData[];
  chatHistoryJson?: string;
  newRecords?: ChatBotRecord[];
  newToolRecords?: ChatBotToolRecord[];
  text?: string;
  mediaUrls?: MediaUrl[];
}

export interface DuplicateBundleRequest {
  sourceBundleName?: string;
  targetBundleName?: string;
}

export interface DuplicateCustomUiFileRequest {
  sourceFilePath?: string;
  targetFileName?: string;
}

export interface DuplicateCustomUiFolderRequest {
  sourceFolderPath?: string;
  targetFolderName?: string;
}

export interface DuplicateFileRequest {
  bundleName?: string;
  sourceFilePath?: string;
  targetFileName?: string;
}

export interface DuplicateFolderRequest {
  bundleName?: string;
  sourceFolderPath?: string;
  targetFolderName?: string;
}

export interface EmbeddingAddTextViewModel {
  texts?: EmbeddingTextData[];
  description?: string;
  tags?: string[];
}

export interface EmbeddingCollection {
  name?: string;
  vectorCollectionId?: string;
  embeddings?: EmbeddingData[];
  workspaceId?: string;
  id?: string;
}

export interface EmbeddingCollectionConfig {
  vectorCollectionId?: string;
  embeddingCollectionId?: string;
}

export interface EmbeddingData {
  dataId?: string;
  description?: string;
  tags?: string[];
}

export interface EmbeddingDataItem {
  dataId?: string;
  description?: string;
  tags?: string[];
  collectionId?: string;
  collectionName?: string;
}

export type EmbeddingDataPointTemplate = null | string;

export interface EmbeddingDataPoint {
  pointId?: string;
  text?: string;
  template?: EmbeddingDataPointTemplate;
}

export type EmbeddingTextDataTemplate = null | string;

export interface EmbeddingTextData {
  text?: string;
  template?: EmbeddingTextDataTemplate;
}

export interface EvaluateTestSetJob {
  chatBotDataId?: string;
  testSetId?: string;
  testId?: string;
  processedCount?: number;
  totalCount?: number;
  repeatCount?: number;
  chatTokenUsage?: TokenUsageDataWithModel[];
  evaluationTokenUsage?: TokenUsageDataWithModel[];
  workspaceId?: string;
  processJobId?: string;
  status?: JobStatus;
  message?: string;
  createdTime?: string;
  updatedTime?: string;
  id?: string;
}

export type ExtensionAlignment = typeof ExtensionAlignment[keyof typeof ExtensionAlignment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtensionAlignment = {
  Start: 'Start',
  Center: 'Center',
  End: 'End',
  Stretch: 'Stretch',
} as const;

export type ExtensionDisplayMode = typeof ExtensionDisplayMode[keyof typeof ExtensionDisplayMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtensionDisplayMode = {
  Docked: 'Docked',
  Persistent: 'Persistent',
} as const;

export type ExtensionLayoutConfigWidth = null | string;

export type ExtensionLayoutConfigHeight = null | string;

export interface ExtensionLayoutConfig {
  enabled?: boolean;
  position?: ExtensionPosition;
  layoutMode?: ExtensionLayoutMode;
  width?: ExtensionLayoutConfigWidth;
  height?: ExtensionLayoutConfigHeight;
  alignment?: ExtensionAlignment;
}

export type ExtensionLayoutMode = typeof ExtensionLayoutMode[keyof typeof ExtensionLayoutMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtensionLayoutMode = {
  FloatingDock: 'FloatingDock',
  WindowPanel: 'WindowPanel',
} as const;

export type ExtensionPosition = typeof ExtensionPosition[keyof typeof ExtensionPosition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtensionPosition = {
  Left: 'Left',
  Right: 'Right',
  Top: 'Top',
  Bottom: 'Bottom',
} as const;

export type ExtensionResponsiveMode = typeof ExtensionResponsiveMode[keyof typeof ExtensionResponsiveMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtensionResponsiveMode = {
  Hide: 'Hide',
  Stack: 'Stack',
} as const;

export type ExtensionSlotConfigName = null | string;

export type ExtensionSlotConfigBundlePath = null | string;

export type ExtensionSlotConfigFullscreen = null | ExtensionLayoutConfig;

export interface ExtensionSlotConfig {
  id?: string;
  name?: ExtensionSlotConfigName;
  bundlePath?: ExtensionSlotConfigBundlePath;
  displayMode?: ExtensionDisplayMode;
  responsiveMode?: ExtensionResponsiveMode;
  order?: number;
  standard?: ExtensionLayoutConfig;
  fullscreen?: ExtensionSlotConfigFullscreen;
}

export type GenerateTestSetJobSelectedDataIds = null | string[];

export type GenerateTestSetJobSynthesizerDistributionAnyOf = {[key: string]: number};

export type GenerateTestSetJobSynthesizerDistribution = null | GenerateTestSetJobSynthesizerDistributionAnyOf;

export interface GenerateTestSetJob {
  testSetId?: string;
  testSetSize?: number;
  generationMode?: TestSetGenerationMode;
  targetTotalSize?: number;
  densityRatio?: number;
  selectedDataIds?: GenerateTestSetJobSelectedDataIds;
  embeddingCollectionIds?: string[];
  persona?: GenerateTestSetPersona;
  synthesizerDistribution?: GenerateTestSetJobSynthesizerDistribution;
  processedRecord?: GenerateTestSetJobProcessedRecord[];
  workspaceId?: string;
  processJobId?: string;
  status?: JobStatus;
  message?: string;
  createdTime?: string;
  updatedTime?: string;
  id?: string;
}

export type GenerateTestSetJobPreviewViewModelSynthesizerBreakdown = {[key: string]: number};

export interface GenerateTestSetJobPreviewViewModel {
  estimatedTotalQuestions?: number;
  totalChunks?: number;
  synthesizerBreakdown?: GenerateTestSetJobPreviewViewModelSynthesizerBreakdown;
}

export type GenerateTestSetJobProcessedRecordEmbeddingCollectionName = null | string;

export type GenerateTestSetJobProcessedRecordDataName = null | string;

export type GenerateTestSetJobProcessedRecordErrorMessage = null | string;

export interface GenerateTestSetJobProcessedRecord {
  embeddingCollectionId?: string;
  embeddingCollectionName?: GenerateTestSetJobProcessedRecordEmbeddingCollectionName;
  dataId?: string;
  dataName?: GenerateTestSetJobProcessedRecordDataName;
  totalCount?: number;
  processedCount?: number;
  isCompleted?: boolean;
  errorMessage?: GenerateTestSetJobProcessedRecordErrorMessage;
  tokenUsage?: TokenUsageDataWithModel[];
}

export interface GenerateTestSetPersona {
  name?: string;
  role_description?: string;
}

export type IFormFile = Blob;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatus = {
  None: 'None',
  Waiting: 'Waiting',
  Processing: 'Processing',
  Completed: 'Completed',
  Error: 'Error',
} as const;

export interface JsonElement {}

export interface LineBotProviderData {
  channelId?: string;
  channelSecret?: string;
  channelAccessToken?: string;
}

export interface LineNotificationSettingsData {
  token?: string;
  to?: string;
}

export interface MediaUrl {
  url: string;
  type: MediaUrlType;
}

export type MediaUrlType = typeof MediaUrlType[keyof typeof MediaUrlType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaUrlType = {
  image: 'image',
  video: 'video',
} as const;

export interface NotificationChatHandlerAction {
  notificationSettingsId?: string;
  message?: string;
}

export type NotificationSettingsName = null | string;

export interface NotificationSettings {
  name?: NotificationSettingsName;
  type?: NotificationType;
  notificationData?: BsonDocument;
  workspaceId?: string;
  id?: string;
}

export interface NotificationSettingsDataScheme {
  line?: LineNotificationSettingsData;
  apprise?: AppriseNotificationSettingsData;
}

export interface NotificationSettingsImportModel {
  importData?: NotificationSettings;
}

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationType = {
  None: 'None',
  Line: 'Line',
  Apprise: 'Apprise',
} as const;

export interface ProcessingTextItem {
  text?: string;
  seconds?: number;
}

export type ProcessingTextMode = typeof ProcessingTextMode[keyof typeof ProcessingTextMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessingTextMode = {
  Sequence: 'Sequence',
  Random: 'Random',
} as const;

export type RAGEvaluationSampleUserInput = null | string;

export type RAGEvaluationSampleResponse = null | string;

export type RAGEvaluationSampleReference = null | string;

export interface RAGEvaluationSample {
  userInput?: RAGEvaluationSampleUserInput;
  response?: RAGEvaluationSampleResponse;
  reference?: RAGEvaluationSampleReference;
  retrievedContexts?: string[];
}

export type RegexChatHandlerConditionRegex = null | string;

export interface RegexChatHandlerCondition {
  regex?: RegexChatHandlerConditionRegex;
}

export interface RenameBundleRequest {
  oldBundleName?: string;
  newBundleName?: string;
}

export interface RenameCustomUiFileRequest {
  oldFilePath?: string;
  newFileName?: string;
}

export interface RenameCustomUiFolderRequest {
  oldFolderPath?: string;
  newFolderName?: string;
}

export interface RenameFileRequest {
  bundleName?: string;
  oldFilePath?: string;
  newFileName?: string;
}

export interface RenameFolderRequest {
  bundleName?: string;
  oldFolderPath?: string;
  newFolderName?: string;
}

export interface SaveCustomUiFileRequest {
  filePath?: string;
  content?: string;
}

export interface SaveTextFileRequest {
  content?: string;
}

export interface SearchListResultOfChatBotData {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatBotData[];
}

export interface SearchListResultOfChatBotHistoryGroupWithUserSettings {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatBotHistoryGroupWithUserSettings[];
}

export interface SearchListResultOfChatBotHistoryWithUserSettings {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatBotHistoryWithUserSettings[];
}

export interface SearchListResultOfChatCreditKey {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatCreditKey[];
}

export interface SearchListResultOfChatEvaluationTestBase {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatEvaluationTestBase[];
}

export interface SearchListResultOfChatEvaluationTestSetBase {
  skip?: number;
  limit?: number;
  total?: number;
  results?: ChatEvaluationTestSetBase[];
}

export interface SearchListResultOfEmbeddingCollection {
  skip?: number;
  limit?: number;
  total?: number;
  results?: EmbeddingCollection[];
}

export interface SearchListResultOfEmbeddingDataItem {
  skip?: number;
  limit?: number;
  total?: number;
  results?: EmbeddingDataItem[];
}

export interface SearchListResultOfEmbeddingDataPoint {
  skip?: number;
  limit?: number;
  total?: number;
  results?: EmbeddingDataPoint[];
}

export interface SearchListResultOfEvaluateTestSetJob {
  skip?: number;
  limit?: number;
  total?: number;
  results?: EvaluateTestSetJob[];
}

export interface SearchListResultOfGenerateTestSetJob {
  skip?: number;
  limit?: number;
  total?: number;
  results?: GenerateTestSetJob[];
}

export interface SearchListResultOfWorkspace {
  skip?: number;
  limit?: number;
  total?: number;
  results?: Workspace[];
}

export type TagDataConfigPrompt = null | string;

export interface TagDataConfig {
  name?: string;
  prompt?: TagDataConfigPrompt;
}

export interface TagsConfig {
  tagDataConfigs?: TagDataConfig[];
}

export type TestConfigPublicAccessKey = null | string;

export interface TestConfig {
  allowPublicAccess?: boolean;
  publicAccessKey?: TestConfigPublicAccessKey;
}

export type TestSearchRequestTags = null | string[];

export interface TestSearchRequest {
  query?: string;
  collectionIds?: string[];
  denseWeight?: number;
  sparseWeight?: number;
  limit?: number;
  tags?: TestSearchRequestTags;
}

export type TestSearchResultPayloadAnyOf = { [key: string]: unknown };

export type TestSearchResultPayload = null | TestSearchResultPayloadAnyOf;

export interface TestSearchResult {
  text?: string;
  embeddingCollectionId?: string;
  score?: number;
  payload?: TestSearchResultPayload;
}

export type TestSetGenerationMode = typeof TestSetGenerationMode[keyof typeof TestSetGenerationMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TestSetGenerationMode = {
  ChunkCoverage: 'ChunkCoverage',
  Proportional: 'Proportional',
  SelectedDataIds: 'SelectedDataIds',
  DensityRatio: 'DensityRatio',
} as const;

export interface TextProcessConfig {
  forceRemoveMarkdown?: boolean;
  foreceHansToTW?: boolean;
}

export interface TokenUsageData {
  inputTokens?: number;
  outputTokens?: number;
}

export interface TokenUsageDataWithModel {
  model: string;
  inputTokens: number;
  outputTokens: number;
}

export interface UpdateCustomUiConfigRequest {
  enabled?: boolean;
  mode?: WebBotCustomUiMode;
  entryFile?: string;
}

export interface User {
  userName?: string;
  displayName?: string;
  setting?: UserSetting;
  provider?: UserProvider;
  password?: UserPassword;
  id?: string;
}

export type UserClientInfoIp = null | string;

export type UserClientInfoUserAgent = null | string;

export interface UserClientInfo {
  ip?: UserClientInfoIp;
  userAgent?: UserClientInfoUserAgent;
}

export interface UserIdPasswordViewModel {
  userId?: string;
  password?: string;
}

export interface UserPagingList {
  users: User[];
  count: number;
}

export interface UserPassword {
  passwordHash?: string;
  passwordSalt?: string;
}

export interface UserPasswordViewModel {
  userName?: string;
  displayName?: string;
  password?: string;
}

export interface UserProfile {
  userId?: string;
  name?: string;
  imageUrl?: string;
}

export type UserProvider = typeof UserProvider[keyof typeof UserProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProvider = {
  None: 'None',
  System: 'System',
  Google: 'Google',
} as const;

export interface UserSetting {
  allowWorkspaceJoin?: boolean;
}

export type WebBotBackgroundConfigColor = null | string;

export type WebBotBackgroundConfigGradient = null | string;

export interface WebBotBackgroundConfig {
  color?: WebBotBackgroundConfigColor;
  type?: WebBotBackgroundType;
  gradient?: WebBotBackgroundConfigGradient;
  target?: WebBotBackgroundTarget;
  imageMode?: WebBotBackgroundImageMode;
  imageScale?: number;
  imageOffsetX?: number;
  imageOffsetY?: number;
  opacity?: number;
}

export type WebBotBackgroundImageMode = typeof WebBotBackgroundImageMode[keyof typeof WebBotBackgroundImageMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebBotBackgroundImageMode = {
  Cover: 'Cover',
  Contain: 'Contain',
  Repeat: 'Repeat',
  Center: 'Center',
} as const;

export type WebBotBackgroundTarget = typeof WebBotBackgroundTarget[keyof typeof WebBotBackgroundTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebBotBackgroundTarget = {
  Window: 'Window',
  Messages: 'Messages',
} as const;

export type WebBotBackgroundType = typeof WebBotBackgroundType[keyof typeof WebBotBackgroundType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebBotBackgroundType = {
  Color: 'Color',
  Gradient: 'Gradient',
  Image: 'Image',
} as const;

export type WebBotBubbleConfigColor = null | string;

export type WebBotBubbleConfigTextColor = null | string;

export type WebBotBubbleConfigBorderColor = null | string;

export type WebBotBubbleConfigShadowColor = null | string;

export interface WebBotBubbleConfig {
  color?: WebBotBubbleConfigColor;
  textColor?: WebBotBubbleConfigTextColor;
  opacity?: number;
  blur?: number;
  borderWidth?: number;
  borderColor?: WebBotBubbleConfigBorderColor;
  borderRadius?: number;
  enableDirectionRadius?: boolean;
  shadowOffsetX?: number;
  shadowOffsetY?: number;
  shadowBlur?: number;
  shadowColor?: WebBotBubbleConfigShadowColor;
}

export type WebBotConfigResponseAvatarIconName = null | string;

export type WebBotConfigResponseWidgetIconName = null | string;

export type WebBotConfigResponseBackgroundImageName = null | string;

export interface WebBotConfigResponse {
  workspaceId?: string;
  avatarIconName?: WebBotConfigResponseAvatarIconName;
  widgetIconName?: WebBotConfigResponseWidgetIconName;
  backgroundImageName?: WebBotConfigResponseBackgroundImageName;
  text?: WebBotTextConfig;
  theme?: WebBotThemeConfig;
  background?: WebBotBackgroundConfig;
  header?: WebBotHeaderFooterConfig;
  footer?: WebBotHeaderFooterConfig;
  userBubble?: WebBotBubbleConfig;
  botBubble?: WebBotBubbleConfig;
  messageMeta?: WebBotMessageMetaConfig;
  layout?: WebBotLayoutConfig;
  responsive?: WebBotResponsiveConfig;
  features?: WebBotFeaturesConfig;
  extensions?: ExtensionSlotConfig[];
  customUi?: WebBotCustomUiConfig;
}

export type WebBotCustomUiConfigEntryFile = null | string;

export interface WebBotCustomUiConfig {
  enabled?: boolean;
  entryFile?: WebBotCustomUiConfigEntryFile;
  mode?: WebBotCustomUiMode;
}

export type WebBotCustomUiMode = typeof WebBotCustomUiMode[keyof typeof WebBotCustomUiMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebBotCustomUiMode = {
  Window: 'Window',
  Headless: 'Headless',
} as const;

export interface WebBotFeaturesConfig {
  enableClearHistoryButton?: boolean;
  enableStreamMode?: boolean;
  enableFeedbackRatingButtons?: boolean;
  enableReportIssueButton?: boolean;
}

export type WebBotFeedbackModelRating = null | ChatBotFeedbackRating;

export type WebBotFeedbackModelComment = null | string;

export interface WebBotFeedbackModel {
  userId?: string;
  rating?: WebBotFeedbackModelRating;
  comment?: WebBotFeedbackModelComment;
}

export type WebBotHeaderFooterConfigBackgroundColor = null | string;

export type WebBotHeaderFooterConfigTextColor = null | string;

export interface WebBotHeaderFooterConfig {
  style?: WebBotHeaderFooterStyle;
  backgroundColor?: WebBotHeaderFooterConfigBackgroundColor;
  textColor?: WebBotHeaderFooterConfigTextColor;
  blur?: number;
  opacity?: number;
}

export type WebBotHeaderFooterStyle = typeof WebBotHeaderFooterStyle[keyof typeof WebBotHeaderFooterStyle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebBotHeaderFooterStyle = {
  Default: 'Default',
  Frosted: 'Frosted',
  Transparent: 'Transparent',
  Custom: 'Custom',
} as const;

export type WebBotLayoutConfigWindowShadowColor = null | string;

export type WebBotLayoutConfigButtonShadowColor = null | string;

export interface WebBotLayoutConfig {
  positionRight?: number;
  positionBottom?: number;
  positionLeft?: number;
  positionTop?: number;
  windowWidth?: number;
  windowHeight?: number;
  windowOffsetX?: number;
  windowOffsetY?: number;
  windowShadow?: number;
  windowShadowOffsetX?: number;
  windowShadowOffsetY?: number;
  windowShadowBlur?: number;
  windowShadowColor?: WebBotLayoutConfigWindowShadowColor;
  buttonShape?: WidgetButtonShape;
  buttonWidth?: number;
  buttonHeight?: number;
  buttonShadow?: number;
  buttonShadowOffsetX?: number;
  buttonShadowOffsetY?: number;
  buttonShadowBlur?: number;
  buttonShadowColor?: WebBotLayoutConfigButtonShadowColor;
}

export type WebBotMessageMetaConfigBotNameColor = null | string;

export type WebBotMessageMetaConfigMetaColor = null | string;

export type WebBotMessageMetaConfigBadgeBackgroundColor = null | string;

export interface WebBotMessageMetaConfig {
  botNameColor?: WebBotMessageMetaConfigBotNameColor;
  metaColor?: WebBotMessageMetaConfigMetaColor;
  enableBadge?: boolean;
  badgeBackgroundColor?: WebBotMessageMetaConfigBadgeBackgroundColor;
  badgeOpacity?: number;
  badgeBlur?: number;
}

export interface WebBotProviderData {
  security?: WebBotSecurityConfig;
  text?: WebBotTextConfig;
  theme?: WebBotThemeConfig;
  background?: WebBotBackgroundConfig;
  header?: WebBotHeaderFooterConfig;
  footer?: WebBotHeaderFooterConfig;
  userBubble?: WebBotBubbleConfig;
  botBubble?: WebBotBubbleConfig;
  messageMeta?: WebBotMessageMetaConfig;
  layout?: WebBotLayoutConfig;
  responsive?: WebBotResponsiveConfig;
  features?: WebBotFeaturesConfig;
  extensions?: ExtensionSlotConfig[];
  customUi?: WebBotCustomUiConfig;
}

export interface WebBotResponsiveConfig {
  breakpoint?: number;
  forceFullScreen?: boolean;
  windowWidth?: number;
  windowHeight?: number;
  positionRight?: number;
  positionBottom?: number;
  positionLeft?: number;
  positionTop?: number;
  windowOffsetX?: number;
  windowOffsetY?: number;
  buttonWidth?: number;
  buttonHeight?: number;
}

export interface WebBotSecurityConfig {
  enableSecurity?: boolean;
  secretKey?: string;
  allowedDomains?: string[];
}

export type WebBotTextConfigFeedbackNotificationText = null | string;

export interface WebBotTextConfig {
  title?: string;
  botName?: string;
  inputPlaceholder?: string;
  footerText?: string;
  feedbackNotificationText?: WebBotTextConfigFeedbackNotificationText;
  defaultQuestions?: string[];
  processingTexts?: ProcessingTextItem[];
  processingTextMode?: ProcessingTextMode;
}

export interface WebBotThemeConfig {
  themeColor?: string;
}

export interface WebMessageModel {
  userId?: string;
  message?: string;
}

export type WidgetButtonShape = typeof WidgetButtonShape[keyof typeof WidgetButtonShape];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WidgetButtonShape = {
  Circle: 'Circle',
  Original: 'Original',
  Hide: 'Hide',
} as const;

export interface Workspace {
  name?: string;
  users?: WorkspaceUser[];
  pendingUsers?: WorkspacePendingUser[];
  id?: string;
}

export interface WorkspaceAddUsersModel {
  userName?: string;
  role?: WorkspaceUserRole;
}

export interface WorkspacePendingUser {
  userName?: string;
}

export interface WorkspacePublicInfo {
  id?: string;
  name?: string;
  ownerUserName?: string;
  ownerUserDisplayName?: string;
}

export interface WorkspaceUser {
  userName?: string;
  role?: WorkspaceUserRole;
}

export type WorkspaceUserRole = typeof WorkspaceUserRole[keyof typeof WorkspaceUserRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceUserRole = {
  None: 'None',
  Viewer: 'Viewer',
  Editor: 'Editor',
  Manager: 'Manager',
  Owner: 'Owner',
} as const;

export type GetApiChatBotDataListParams = {
workspaceId?: string;
skip?: number;
limit?: number;
};

export type GetApiChatBotDataListByEmbeddingCollectionIdParams = {
workspaceId?: string;
embeddingCollectionId?: string;
skip?: number;
limit?: number;
};

export type GetApiChatBotDataGetParams = {
workspaceId?: string;
id?: string;
};

export type GetApiChatBotDataPublicAcccessGetParams = {
id?: string;
accessKey?: string;
};

export type PostApiChatBotDataCreateParams = {
workspaceId?: string;
name?: string;
};

export type PostApiChatBotDataExportParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatBotDataImportParams = {
workspaceId?: string;
};

export type PutApiChatBotDataRenameParams = {
workspaceId?: string;
id?: string;
name?: string;
};

export type PutApiChatBotDataUpdateChatConfigParams = {
workspaceId?: string;
id?: string;
};

export type PutApiChatBotDataUpdateTagsConfigParams = {
workspaceId?: string;
id?: string;
};

export type PutApiChatBotDataUpdateTestConfigParams = {
workspaceId?: string;
id?: string;
};

export type DeleteApiChatBotDataDeleteParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatBotDataConnectEmbeddingCollectionParams = {
workspaceId?: string;
id?: string;
embeddingCollectionId?: string;
};

export type PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams = {
workspaceId?: string;
id?: string;
embeddingCollectionName?: string;
};

export type DeleteApiChatBotDataDisconnectEmbeddingCollectionParams = {
workspaceId?: string;
id?: string;
embeddingCollectionId?: string;
};

export type PostApiChatBotHistorySearchWithUserSettingsParams = {
recordsLimit?: number;
skip?: number;
limit?: number;
};

export type PostApiChatBotHistorySearchFeedbackWithUserSettingsParams = {
skip?: number;
limit?: number;
};

export type GetApiChatBotHistoryGetParams = {
botProviderId?: string;
userId?: string;
recordsLimit?: number;
withToolRecords?: boolean;
};

export type GetApiChatBotHistoryGetContextParams = {
historyId?: string;
beforeCount?: number;
afterCount?: number;
withToolRecords?: boolean;
};

export type GetApiChatBotHistoryGetBeforeParams = {
botProviderId?: string;
userId?: string;
timestamp?: number;
count?: number;
withToolRecords?: boolean;
};

export type GetApiChatBotHistoryGetAfterParams = {
botProviderId?: string;
userId?: string;
timestamp?: number;
count?: number;
withToolRecords?: boolean;
};

export type PostApiChatDebugMultipleChatParams = {
chatBotDataId?: string;
count?: number;
};

export type GetApiChatCreditKeyListByUserIdParams = {
skip?: number;
limit?: number;
};

export type GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerParams = {
workspaceId?: string;
};

export type GetApiEmbeddingCollectionListParams = {
workspaceId?: string;
skip?: number;
limit?: number;
};

export type PostApiEmbeddingCollectionFindCollectionsTagsParams = {
workspaceId?: string;
};

export type PostApiEmbeddingCollectionSearchDataItemsParams = {
workspaceId?: string;
skip?: number;
limit?: number;
search?: string;
};

export type PostApiEmbeddingCollectionSearchDataItemsBodyOne = null | string[];

export type PostApiEmbeddingCollectionSearchDataItemsBodyTwo = null | string[];

export type PostApiEmbeddingCollectionSearchDataItemsBodyThree = null | string[];

export type GetApiEmbeddingCollectionGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiEmbeddingCollectionCreateParams = {
workspaceId?: string;
name?: string;
};

export type PutApiEmbeddingCollectionRenameParams = {
workspaceId?: string;
id?: string;
name?: string;
};

export type DeleteApiEmbeddingCollectionDeleteParams = {
workspaceId?: string;
id?: string;
};

export type PostApiEmbeddingCollectionTestSearchParams = {
workspaceId?: string;
};

export type GetApiEmbeddingCollectionDataToolExportParams = {
workspaceId?: string;
embeddingCollectionId?: string;
};

export type PostApiEmbeddingCollectionDataToolImportParams = {
workspaceId?: string;
embeddingCollectionId?: string;
};

export type PostApiEmbeddingCollectionDataToolImportBody = {
  file?: IFormFile;
};

export type PostApiEmbeddingAddExcelParams = {
workspaceId?: string;
collectionId?: string;
};

export type PostApiEmbeddingAddExcelBody = {
  file?: IFormFile;
};

export type PostApiEmbeddingReplaceDataWithExcelParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
};

export type PostApiEmbeddingReplaceDataWithExcelBody = {
  file?: IFormFile;
};

export type PostApiEmbeddingAddTextParams = {
workspaceId?: string;
collectionId?: string;
};

export type PostApiEmbeddingAddTextToDataParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
};

export type PutApiEmbeddingUpdateDataPointTextParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
pointId?: string;
};

export type PutApiEmbeddingUpdateDataDescriptionParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
description?: string;
};

export type PutApiEmbeddingUpdateDataTagsParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
};

export type GetApiEmbeddingListTextDataParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
skip?: number;
limit?: number;
};

export type DeleteApiEmbeddingDeleteDataParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
};

export type DeleteApiEmbeddingDeleteDataPointParams = {
workspaceId?: string;
collectionId?: string;
dataId?: string;
pointId?: string;
};

export type PutApiUserChangeDisplayNameParams = {
newDisplayName?: string;
};

export type GetApiWorkspaceGetParams = {
id?: string;
};

export type GetApiWorkspaceGetPublicInfoParams = {
id?: string;
};

export type PostApiWorkspaceCreateParams = {
name?: string;
};

export type PutApiWorkspaceRenameParams = {
id?: string;
name?: string;
};

export type DeleteApiWorkspaceDeleteParams = {
id?: string;
};

export type GetApiWorkspaceUserGetRoleParams = {
workspaceId?: string;
};

export type GetApiWorkspaceUserListUsersParams = {
workspaceId?: string;
};

export type DeleteApiWorkspaceUserLeaveParams = {
workspaceId?: string;
};

export type PostApiWorkspaceUserAddUsersParams = {
workspaceId?: string;
};

export type PutApiWorkspaceUserSetUserRoleParams = {
workspaceId?: string;
userName?: string;
role?: WorkspaceUserRole;
};

export type PutApiWorkspaceUserSetUserOwnerRoleParams = {
workspaceId?: string;
userName?: string;
};

export type DeleteApiWorkspaceUserDeleteUserParams = {
workspaceId?: string;
userName?: string;
};

export type GetApiWorkspaceUserListPendingUsersParams = {
workspaceId?: string;
};

export type PostApiWorkspaceUserProcessPendingUserParams = {
workspaceId?: string;
userName?: string;
role?: WorkspaceUserRole;
};

export type PostApiWorkspaceUserRequestPendingUserParams = {
workspaceId?: string;
};

export type GetApiWorkspaceUserCheckPendingUserParams = {
workspaceId?: string;
};

export type GetApiNotificationSettingsListParams = {
workspaceId?: string;
};

export type GetApiNotificationSettingsGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiNotificationSettingsCreateParams = {
workspaceId?: string;
};

export type PutApiNotificationSettingsUpdateParams = {
workspaceId?: string;
};

export type PostApiNotificationSettingsTestParams = {
workspaceId?: string;
id?: string;
};

export type PutApiNotificationSettingsDeleteParams = {
workspaceId?: string;
id?: string;
};

export type PostApiNotificationSettingsExportParams = {
workspaceId?: string;
id?: string;
};

export type PostApiNotificationSettingsImportParams = {
workspaceId?: string;
};

export type GetApiEvaluateTestSetJobListParams = {
workspaceId?: string;
testSetId?: string;
skip?: number;
limit?: number;
};

export type GetApiEvaluateTestSetJobGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiEvaluateTestSetJobCreateParams = {
workspaceId?: string;
};

export type PostApiEvaluateTestSetJobRequeueParams = {
workspaceId?: string;
id?: string;
};

export type DeleteApiEvaluateTestSetJobDeleteParams = {
workspaceId?: string;
id?: string;
};

export type GetApiGenerateTestSetJobListParams = {
workspaceId?: string;
testSetId?: string;
skip?: number;
limit?: number;
};

export type GetApiGenerateTestSetJobGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiGenerateTestSetJobPreviewParams = {
workspaceId?: string;
};

export type PostApiGenerateTestSetJobCreateParams = {
workspaceId?: string;
};

export type PostApiGenerateTestSetJobRequeueParams = {
workspaceId?: string;
id?: string;
};

export type DeleteApiGenerateTestSetJobDeleteParams = {
workspaceId?: string;
id?: string;
};

export type GetApiChatEvaluationTestListParams = {
workspaceId?: string;
testSetId?: string;
skip?: number;
limit?: number;
};

export type GetApiChatEvaluationTestGetParams = {
workspaceId?: string;
id?: string;
};

export type PutApiChatEvaluationTestRenameParams = {
workspaceId?: string;
id?: string;
name?: string;
};

export type PutApiChatEvaluationTestDeleteParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatEvaluationTestEvaluateParams = {
workspaceId?: string;
};

export type PostApiChatEvaluationTestEvaluate200OneItem = {[key: string]: ChatEvaluationTestMetric};

export type PostApiChatEvaluationTestEvaluate200TwoItem = {[key: string]: ChatEvaluationTestMetric};

export type PostApiChatEvaluationTestEvaluate200ThreeItem = {[key: string]: ChatEvaluationTestMetric};

export type GetApiChatEvaluationTestSetListParams = {
workspaceId?: string;
skip?: number;
limit?: number;
};

export type GetApiChatEvaluationTestSetGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatEvaluationTestSetCreateParams = {
workspaceId?: string;
name?: string;
};

export type PutApiChatEvaluationTestSetRenameParams = {
workspaceId?: string;
id?: string;
name?: string;
};

export type PostApiChatEvaluationTestSetAddSamplesParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatEvaluationTestSetUpdateSampleParams = {
workspaceId?: string;
id?: string;
};

export type DeleteApiChatEvaluationTestSetDeleteSamplesParams = {
workspaceId?: string;
id?: string;
};

export type PutApiChatEvaluationTestSetDeleteParams = {
workspaceId?: string;
id?: string;
};

export type GetApiChatEvaluationTestSetExportParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatEvaluationTestSetImportParams = {
workspaceId?: string;
id?: string;
};

export type PostApiChatEvaluationTestSetImportBody = {
  file?: IFormFile;
};

export type PostApiBotProviderActionsSendParams = {
workspaceId?: string;
botProviderId?: string;
userId?: string;
};

export type GetApiBotProviderActionsGetUserProfileParams = {
workspaceId?: string;
botProviderId?: string;
userId?: string;
};

export type DeleteApiBotProviderActionsDeleteHistoryParams = {
workspaceId?: string;
botProviderId?: string;
userId?: string;
};

export type PostApiBotProviderAssetBundleCreateEmptyBundleParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleUploadFileParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
relativePath?: string;
};

export type PostApiBotProviderAssetBundleUploadFileBody = {
  file?: IFormFile;
};

export type DeleteApiBotProviderAssetBundleDeleteFileParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
fileName?: string;
};

export type PostApiBotProviderAssetBundleCreateFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type DeleteApiBotProviderAssetBundleDeleteFolderParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
folderPath?: string;
};

export type PutApiBotProviderAssetBundleSaveTextFileParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
filePath?: string;
};

export type GetApiBotProviderAssetBundleDownloadZipParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
};

export type PostApiBotProviderAssetBundleUploadZipParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
};

export type PostApiBotProviderAssetBundleUploadZipBody = {
  file?: IFormFile;
};

export type GetApiBotProviderAssetBundleListBundlesParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderAssetBundleGetFileParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
fileName?: string;
};

export type DeleteApiBotProviderAssetBundleDeleteBundleParams = {
workspaceId?: string;
botProviderId?: string;
bundleName?: string;
};

export type PostApiBotProviderAssetBundleRenameBundleParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleDuplicateBundleParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleRenameFileParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleDuplicateFileParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleRenameFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderAssetBundleDuplicateFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderListParams = {
workspaceId?: string;
};

export type GetApiBotProviderGetParams = {
workspaceId?: string;
id?: string;
};

export type PostApiBotProviderCreateParams = {
workspaceId?: string;
};

export type PutApiBotProviderRenameParams = {
workspaceId?: string;
id?: string;
name?: string;
};

export type PutApiBotProviderUpdateParams = {
workspaceId?: string;
};

export type PutApiBotProviderDeleteParams = {
workspaceId?: string;
id?: string;
};

export type PostApiBotProviderExportParams = {
workspaceId?: string;
id?: string;
};

export type PostApiBotProviderImportParams = {
workspaceId?: string;
};

export type GetApiBotProviderCustomUiGetConfigParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderCustomUiListFilesParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PutApiBotProviderCustomUiUpdateConfigParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderCustomUiUploadZipParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderCustomUiUploadZipBody = {
  file?: IFormFile;
};

export type PostApiBotProviderCustomUiApplyBotConfigParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderCustomUiDownloadZipParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderCustomUiGetFileContentParams = {
workspaceId?: string;
botProviderId?: string;
filePath?: string;
};

export type PostApiBotProviderCustomUiSaveFileParams = {
workspaceId?: string;
botProviderId?: string;
};

export type DeleteApiBotProviderCustomUiDeleteFileParams = {
workspaceId?: string;
botProviderId?: string;
filePath?: string;
};

export type PostApiBotProviderCustomUiUploadFileParams = {
workspaceId?: string;
botProviderId?: string;
relativePath?: string;
};

export type PostApiBotProviderCustomUiUploadFileBody = {
  file?: IFormFile;
};

export type PostApiBotProviderCustomUiCreateFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type DeleteApiBotProviderCustomUiDeleteFolderParams = {
workspaceId?: string;
botProviderId?: string;
folderPath?: string;
};

export type PostApiBotProviderCustomUiRenameFileParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderCustomUiDuplicateFileParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderCustomUiRenameFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderCustomUiDuplicateFolderParams = {
workspaceId?: string;
botProviderId?: string;
};

export type DeleteApiBotProviderCustomUiResetParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderStatisticsGetByBotProviderIdParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadAvatarIconParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadAvatarIconBody = {
  file?: IFormFile;
};

export type DeleteApiBotProviderUploadDeleteAvatarIconParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadWidgetIconParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadWidgetIconBody = {
  file?: IFormFile;
};

export type DeleteApiBotProviderUploadDeleteWidgetIconParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadBackgroundImageParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUploadUploadBackgroundImageBody = {
  file?: IFormFile;
};

export type DeleteApiBotProviderUploadDeleteBackgroundImageParams = {
workspaceId?: string;
botProviderId?: string;
};

export type GetApiBotProviderUserSettingsGetParams = {
workspaceId?: string;
botProviderId?: string;
userId?: string;
};

export type GetApiBotProviderUserSettingsGetBotProviderTagsParams = {
workspaceId?: string;
botProviderId?: string;
};

export type PostApiBotProviderUserSettingsUpsertParams = {
workspaceId?: string;
};

export type GetApiAdminChatCreditKeyGetParams = {
id?: string;
};

export type GetApiAdminChatCreditKeyListByUserIdParams = {
userId?: string;
skip?: number;
limit?: number;
};

export type GetApiAdminChatCreditKeyGetValidCreditByUserIdParams = {
userId?: string;
};

export type DeleteApiAdminChatCreditKeyDeleteParams = {
id?: string;
};

export type GetApiAdminUserManagerListUsersParams = {
search?: string;
skip?: number;
take?: number;
};

export type GetApiAdminUserManagerGetUserParams = {
userId?: string;
};

export type GetApiAdminUserManagerGetUserByNameParams = {
userName?: string;
};

export type PatchApiAdminUserManagerChangeUserDisplayNameParams = {
userId?: string;
newDisplayName?: string;
};

export type DeleteApiAdminUserManagerDeleteUserParams = {
userId?: string;
};

export type GetApiAdminWorkspaceGetParams = {
workspaceId?: string;
};

export type PostApiAdminWorkspaceCreateParams = {
name?: string;
userName?: string;
};

export type PostApiAdminWorkspaceSearchParams = {
nameQuery?: string;
userQuery?: string;
skip?: number;
limit?: number;
};

export type PutApiAdminWorkspaceSetOwnerParams = {
workspaceId?: string;
userName?: string;
};

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




export const postApiAnalysisKeywordsChatBot = (
    chatBotHistorySearch: ChatBotHistorySearch, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AnalysisKeywordsResultGroup[]>> => {
    
    
    return axios.post(
      `/api/AnalysisKeywords/ChatBot`,
      chatBotHistorySearch,options
    );
  }



export const getPostApiAnalysisKeywordsChatBotMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>, TError,{data: ChatBotHistorySearch}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>, TError,{data: ChatBotHistorySearch}, TContext> => {

const mutationKey = ['postApiAnalysisKeywordsChatBot'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>, {data: ChatBotHistorySearch}> = (props) => {
          const {data} = props ?? {};

          return  postApiAnalysisKeywordsChatBot(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAnalysisKeywordsChatBotMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>>
    export type PostApiAnalysisKeywordsChatBotMutationBody = ChatBotHistorySearch
    export type PostApiAnalysisKeywordsChatBotMutationError = AxiosError<unknown>

    export const usePostApiAnalysisKeywordsChatBot = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>, TError,{data: ChatBotHistorySearch}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAnalysisKeywordsChatBot>>,
        TError,
        {data: ChatBotHistorySearch},
        TContext
      > => {

      const mutationOptions = getPostApiAnalysisKeywordsChatBotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiAuthLogin = (
    authViewModel: AuthViewModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {
    
    
    return axios.post(
      `/api/Auth/Login`,
      authViewModel,options
    );
  }



export const getPostApiAuthLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogin>>, TError,{data: AuthViewModel}, TContext> => {

const mutationKey = ['postApiAuthLogin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthLogin>>, {data: AuthViewModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiAuthLogin(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthLogin>>>
    export type PostApiAuthLoginMutationBody = AuthViewModel
    export type PostApiAuthLoginMutationError = AxiosError<unknown>

    export const usePostApiAuthLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthLogin>>,
        TError,
        {data: AuthViewModel},
        TContext
      > => {

      const mutationOptions = getPostApiAuthLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAuthState = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {
    
    
    return axios.get(
      `/api/Auth/State`,options
    );
  }




export const getGetApiAuthStateQueryKey = () => {
    return [
    `/api/Auth/State`
    ] as const;
    }

    
export const getGetApiAuthStateQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthState>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthStateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthState>>> = ({ signal }) => getApiAuthState({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAuthStateQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthState>>>
export type GetApiAuthStateQueryError = AxiosError<unknown>



export function useGetApiAuthState<TData = Awaited<ReturnType<typeof getApiAuthState>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAuthStateQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiAuthLogout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/Auth/Logout`,options
    );
  }



export const getDeleteApiAuthLogoutMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext> => {

const mutationKey = ['deleteApiAuthLogout'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAuthLogout>>, void> = () => {
          

          return  deleteApiAuthLogout(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAuthLogout>>>
    
    export type DeleteApiAuthLogoutMutationError = AxiosError<unknown>

    export const useDeleteApiAuthLogout = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAuthLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteApiAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatBotDataList = (
    params?: GetApiChatBotDataListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatBotData>> => {
    
    
    return axios.get(
      `/api/ChatBotData/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotDataListQueryKey = (params?: GetApiChatBotDataListParams,) => {
    return [
    `/api/ChatBotData/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotDataListQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotDataList>>, TError = AxiosError<unknown>>(params?: GetApiChatBotDataListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotDataListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotDataList>>> = ({ signal }) => getApiChatBotDataList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotDataListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotDataList>>>
export type GetApiChatBotDataListQueryError = AxiosError<unknown>



export function useGetApiChatBotDataList<TData = Awaited<ReturnType<typeof getApiChatBotDataList>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotDataListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotDataListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotDataListByEmbeddingCollectionId = (
    params?: GetApiChatBotDataListByEmbeddingCollectionIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatBotData>> => {
    
    
    return axios.get(
      `/api/ChatBotData/ListByEmbeddingCollectionId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotDataListByEmbeddingCollectionIdQueryKey = (params?: GetApiChatBotDataListByEmbeddingCollectionIdParams,) => {
    return [
    `/api/ChatBotData/ListByEmbeddingCollectionId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotDataListByEmbeddingCollectionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>, TError = AxiosError<unknown>>(params?: GetApiChatBotDataListByEmbeddingCollectionIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotDataListByEmbeddingCollectionIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>> = ({ signal }) => getApiChatBotDataListByEmbeddingCollectionId(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotDataListByEmbeddingCollectionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>>
export type GetApiChatBotDataListByEmbeddingCollectionIdQueryError = AxiosError<unknown>



export function useGetApiChatBotDataListByEmbeddingCollectionId<TData = Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotDataListByEmbeddingCollectionIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataListByEmbeddingCollectionId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotDataListByEmbeddingCollectionIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotDataGet = (
    params?: GetApiChatBotDataGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotData>> => {
    
    
    return axios.get(
      `/api/ChatBotData/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotDataGetQueryKey = (params?: GetApiChatBotDataGetParams,) => {
    return [
    `/api/ChatBotData/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotDataGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotDataGet>>, TError = AxiosError<unknown>>(params?: GetApiChatBotDataGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotDataGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotDataGet>>> = ({ signal }) => getApiChatBotDataGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotDataGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotDataGet>>>
export type GetApiChatBotDataGetQueryError = AxiosError<unknown>



export function useGetApiChatBotDataGet<TData = Awaited<ReturnType<typeof getApiChatBotDataGet>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotDataGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotDataGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotDataPublicAcccessGet = (
    params?: GetApiChatBotDataPublicAcccessGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotData>> => {
    
    
    return axios.get(
      `/api/ChatBotData/PublicAcccessGet`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotDataPublicAcccessGetQueryKey = (params?: GetApiChatBotDataPublicAcccessGetParams,) => {
    return [
    `/api/ChatBotData/PublicAcccessGet`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotDataPublicAcccessGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>, TError = AxiosError<unknown>>(params?: GetApiChatBotDataPublicAcccessGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotDataPublicAcccessGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>> = ({ signal }) => getApiChatBotDataPublicAcccessGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotDataPublicAcccessGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>>
export type GetApiChatBotDataPublicAcccessGetQueryError = AxiosError<unknown>



export function useGetApiChatBotDataPublicAcccessGet<TData = Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotDataPublicAcccessGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotDataPublicAcccessGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotDataPublicAcccessGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiChatBotDataCreate = (
    params?: PostApiChatBotDataCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatBotData/Create`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotDataCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreate>>, TError,{params?: PostApiChatBotDataCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreate>>, TError,{params?: PostApiChatBotDataCreateParams}, TContext> => {

const mutationKey = ['postApiChatBotDataCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotDataCreate>>, {params?: PostApiChatBotDataCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiChatBotDataCreate(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotDataCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotDataCreate>>>
    
    export type PostApiChatBotDataCreateMutationError = AxiosError<unknown>

    export const usePostApiChatBotDataCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreate>>, TError,{params?: PostApiChatBotDataCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotDataCreate>>,
        TError,
        {params?: PostApiChatBotDataCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotDataCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotDataExport = (
    params?: PostApiChatBotDataExportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotData>> => {
    
    
    return axios.post(
      `/api/ChatBotData/Export`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotDataExportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataExport>>, TError,{params?: PostApiChatBotDataExportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataExport>>, TError,{params?: PostApiChatBotDataExportParams}, TContext> => {

const mutationKey = ['postApiChatBotDataExport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotDataExport>>, {params?: PostApiChatBotDataExportParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiChatBotDataExport(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotDataExportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotDataExport>>>
    
    export type PostApiChatBotDataExportMutationError = AxiosError<unknown>

    export const usePostApiChatBotDataExport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataExport>>, TError,{params?: PostApiChatBotDataExportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotDataExport>>,
        TError,
        {params?: PostApiChatBotDataExportParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotDataExportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotDataImport = (
    chatBotDataImportModel: ChatBotDataImportModel,
    params?: PostApiChatBotDataImportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotData>> => {
    
    
    return axios.post(
      `/api/ChatBotData/Import`,
      chatBotDataImportModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotDataImportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataImport>>, TError,{data: ChatBotDataImportModel;params?: PostApiChatBotDataImportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataImport>>, TError,{data: ChatBotDataImportModel;params?: PostApiChatBotDataImportParams}, TContext> => {

const mutationKey = ['postApiChatBotDataImport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotDataImport>>, {data: ChatBotDataImportModel;params?: PostApiChatBotDataImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatBotDataImport(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotDataImport>>>
    export type PostApiChatBotDataImportMutationBody = ChatBotDataImportModel
    export type PostApiChatBotDataImportMutationError = AxiosError<unknown>

    export const usePostApiChatBotDataImport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataImport>>, TError,{data: ChatBotDataImportModel;params?: PostApiChatBotDataImportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotDataImport>>,
        TError,
        {data: ChatBotDataImportModel;params?: PostApiChatBotDataImportParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotDataImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatBotDataRename = (
    params?: PutApiChatBotDataRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatBotData/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatBotDataRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataRename>>, TError,{params?: PutApiChatBotDataRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataRename>>, TError,{params?: PutApiChatBotDataRenameParams}, TContext> => {

const mutationKey = ['putApiChatBotDataRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatBotDataRename>>, {params?: PutApiChatBotDataRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiChatBotDataRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatBotDataRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatBotDataRename>>>
    
    export type PutApiChatBotDataRenameMutationError = AxiosError<unknown>

    export const usePutApiChatBotDataRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataRename>>, TError,{params?: PutApiChatBotDataRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatBotDataRename>>,
        TError,
        {params?: PutApiChatBotDataRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatBotDataRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatBotDataUpdateChatConfig = (
    chatConfig: ChatConfig,
    params?: PutApiChatBotDataUpdateChatConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatBotData/UpdateChatConfig`,
      chatConfig,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatBotDataUpdateChatConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>, TError,{data: ChatConfig;params?: PutApiChatBotDataUpdateChatConfigParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>, TError,{data: ChatConfig;params?: PutApiChatBotDataUpdateChatConfigParams}, TContext> => {

const mutationKey = ['putApiChatBotDataUpdateChatConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>, {data: ChatConfig;params?: PutApiChatBotDataUpdateChatConfigParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiChatBotDataUpdateChatConfig(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatBotDataUpdateChatConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>>
    export type PutApiChatBotDataUpdateChatConfigMutationBody = ChatConfig
    export type PutApiChatBotDataUpdateChatConfigMutationError = AxiosError<unknown>

    export const usePutApiChatBotDataUpdateChatConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>, TError,{data: ChatConfig;params?: PutApiChatBotDataUpdateChatConfigParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatBotDataUpdateChatConfig>>,
        TError,
        {data: ChatConfig;params?: PutApiChatBotDataUpdateChatConfigParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatBotDataUpdateChatConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatBotDataUpdateTagsConfig = (
    tagsConfig: TagsConfig,
    params?: PutApiChatBotDataUpdateTagsConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatBotData/UpdateTagsConfig`,
      tagsConfig,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatBotDataUpdateTagsConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>, TError,{data: TagsConfig;params?: PutApiChatBotDataUpdateTagsConfigParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>, TError,{data: TagsConfig;params?: PutApiChatBotDataUpdateTagsConfigParams}, TContext> => {

const mutationKey = ['putApiChatBotDataUpdateTagsConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>, {data: TagsConfig;params?: PutApiChatBotDataUpdateTagsConfigParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiChatBotDataUpdateTagsConfig(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatBotDataUpdateTagsConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>>
    export type PutApiChatBotDataUpdateTagsConfigMutationBody = TagsConfig
    export type PutApiChatBotDataUpdateTagsConfigMutationError = AxiosError<unknown>

    export const usePutApiChatBotDataUpdateTagsConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>, TError,{data: TagsConfig;params?: PutApiChatBotDataUpdateTagsConfigParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatBotDataUpdateTagsConfig>>,
        TError,
        {data: TagsConfig;params?: PutApiChatBotDataUpdateTagsConfigParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatBotDataUpdateTagsConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatBotDataUpdateTestConfig = (
    testConfig: TestConfig,
    params?: PutApiChatBotDataUpdateTestConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatBotData/UpdateTestConfig`,
      testConfig,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatBotDataUpdateTestConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>, TError,{data: TestConfig;params?: PutApiChatBotDataUpdateTestConfigParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>, TError,{data: TestConfig;params?: PutApiChatBotDataUpdateTestConfigParams}, TContext> => {

const mutationKey = ['putApiChatBotDataUpdateTestConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>, {data: TestConfig;params?: PutApiChatBotDataUpdateTestConfigParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiChatBotDataUpdateTestConfig(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatBotDataUpdateTestConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>>
    export type PutApiChatBotDataUpdateTestConfigMutationBody = TestConfig
    export type PutApiChatBotDataUpdateTestConfigMutationError = AxiosError<unknown>

    export const usePutApiChatBotDataUpdateTestConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>, TError,{data: TestConfig;params?: PutApiChatBotDataUpdateTestConfigParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatBotDataUpdateTestConfig>>,
        TError,
        {data: TestConfig;params?: PutApiChatBotDataUpdateTestConfigParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatBotDataUpdateTestConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiChatBotDataDelete = (
    params?: DeleteApiChatBotDataDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/ChatBotData/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiChatBotDataDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>, TError,{params?: DeleteApiChatBotDataDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>, TError,{params?: DeleteApiChatBotDataDeleteParams}, TContext> => {

const mutationKey = ['deleteApiChatBotDataDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>, {params?: DeleteApiChatBotDataDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiChatBotDataDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiChatBotDataDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>>
    
    export type DeleteApiChatBotDataDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiChatBotDataDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>, TError,{params?: DeleteApiChatBotDataDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiChatBotDataDelete>>,
        TError,
        {params?: DeleteApiChatBotDataDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiChatBotDataDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotDataConnectEmbeddingCollection = (
    params?: PostApiChatBotDataConnectEmbeddingCollectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatBotData/ConnectEmbeddingCollection`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotDataConnectEmbeddingCollectionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataConnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataConnectEmbeddingCollectionParams}, TContext> => {

const mutationKey = ['postApiChatBotDataConnectEmbeddingCollection'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>, {params?: PostApiChatBotDataConnectEmbeddingCollectionParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiChatBotDataConnectEmbeddingCollection(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotDataConnectEmbeddingCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>>
    
    export type PostApiChatBotDataConnectEmbeddingCollectionMutationError = AxiosError<unknown>

    export const usePostApiChatBotDataConnectEmbeddingCollection = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataConnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotDataConnectEmbeddingCollection>>,
        TError,
        {params?: PostApiChatBotDataConnectEmbeddingCollectionParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotDataConnectEmbeddingCollectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotDataCreateAndConnectEmbeddingCollection = (
    params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatBotData/CreateAndConnectEmbeddingCollection`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotDataCreateAndConnectEmbeddingCollectionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams}, TContext> => {

const mutationKey = ['postApiChatBotDataCreateAndConnectEmbeddingCollection'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>, {params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiChatBotDataCreateAndConnectEmbeddingCollection(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotDataCreateAndConnectEmbeddingCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>>
    
    export type PostApiChatBotDataCreateAndConnectEmbeddingCollectionMutationError = AxiosError<unknown>

    export const usePostApiChatBotDataCreateAndConnectEmbeddingCollection = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>, TError,{params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotDataCreateAndConnectEmbeddingCollection>>,
        TError,
        {params?: PostApiChatBotDataCreateAndConnectEmbeddingCollectionParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotDataCreateAndConnectEmbeddingCollectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiChatBotDataDisconnectEmbeddingCollection = (
    params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/ChatBotData/DisconnectEmbeddingCollection`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiChatBotDataDisconnectEmbeddingCollectionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>, TError,{params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>, TError,{params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams}, TContext> => {

const mutationKey = ['deleteApiChatBotDataDisconnectEmbeddingCollection'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>, {params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiChatBotDataDisconnectEmbeddingCollection(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiChatBotDataDisconnectEmbeddingCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>>
    
    export type DeleteApiChatBotDataDisconnectEmbeddingCollectionMutationError = AxiosError<unknown>

    export const useDeleteApiChatBotDataDisconnectEmbeddingCollection = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>, TError,{params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiChatBotDataDisconnectEmbeddingCollection>>,
        TError,
        {params?: DeleteApiChatBotDataDisconnectEmbeddingCollectionParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiChatBotDataDisconnectEmbeddingCollectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotHistoryExportCsv = (
    chatBotHistoryExportRequest: ChatBotHistoryExportRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatBotHistory/ExportCsv`,
      chatBotHistoryExportRequest,options
    );
  }



export const getPostApiChatBotHistoryExportCsvMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>, TError,{data: ChatBotHistoryExportRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>, TError,{data: ChatBotHistoryExportRequest}, TContext> => {

const mutationKey = ['postApiChatBotHistoryExportCsv'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>, {data: ChatBotHistoryExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiChatBotHistoryExportCsv(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotHistoryExportCsvMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>>
    export type PostApiChatBotHistoryExportCsvMutationBody = ChatBotHistoryExportRequest
    export type PostApiChatBotHistoryExportCsvMutationError = AxiosError<unknown>

    export const usePostApiChatBotHistoryExportCsv = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>, TError,{data: ChatBotHistoryExportRequest}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotHistoryExportCsv>>,
        TError,
        {data: ChatBotHistoryExportRequest},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotHistoryExportCsvMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotHistorySearchWithUserSettings = (
    chatBotHistoryUserSettingSearch: ChatBotHistoryUserSettingSearch,
    params?: PostApiChatBotHistorySearchWithUserSettingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatBotHistoryGroupWithUserSettings>> => {
    
    
    return axios.post(
      `/api/ChatBotHistory/SearchWithUserSettings`,
      chatBotHistoryUserSettingSearch,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotHistorySearchWithUserSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchWithUserSettingsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchWithUserSettingsParams}, TContext> => {

const mutationKey = ['postApiChatBotHistorySearchWithUserSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>, {data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchWithUserSettingsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatBotHistorySearchWithUserSettings(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotHistorySearchWithUserSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>>
    export type PostApiChatBotHistorySearchWithUserSettingsMutationBody = ChatBotHistoryUserSettingSearch
    export type PostApiChatBotHistorySearchWithUserSettingsMutationError = AxiosError<unknown>

    export const usePostApiChatBotHistorySearchWithUserSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchWithUserSettingsParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotHistorySearchWithUserSettings>>,
        TError,
        {data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchWithUserSettingsParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotHistorySearchWithUserSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatBotHistorySearchFeedbackWithUserSettings = (
    chatBotHistoryUserSettingSearch: ChatBotHistoryUserSettingSearch,
    params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatBotHistoryWithUserSettings>> => {
    
    
    return axios.post(
      `/api/ChatBotHistory/SearchFeedbackWithUserSettings`,
      chatBotHistoryUserSettingSearch,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatBotHistorySearchFeedbackWithUserSettingsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams}, TContext> => {

const mutationKey = ['postApiChatBotHistorySearchFeedbackWithUserSettings'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>, {data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatBotHistorySearchFeedbackWithUserSettings(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatBotHistorySearchFeedbackWithUserSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>>
    export type PostApiChatBotHistorySearchFeedbackWithUserSettingsMutationBody = ChatBotHistoryUserSettingSearch
    export type PostApiChatBotHistorySearchFeedbackWithUserSettingsMutationError = AxiosError<unknown>

    export const usePostApiChatBotHistorySearchFeedbackWithUserSettings = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>, TError,{data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatBotHistorySearchFeedbackWithUserSettings>>,
        TError,
        {data: ChatBotHistoryUserSettingSearch;params?: PostApiChatBotHistorySearchFeedbackWithUserSettingsParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatBotHistorySearchFeedbackWithUserSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatBotHistoryGet = (
    params?: GetApiChatBotHistoryGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotHistory[]>> => {
    
    
    return axios.get(
      `/api/ChatBotHistory/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotHistoryGetQueryKey = (params?: GetApiChatBotHistoryGetParams,) => {
    return [
    `/api/ChatBotHistory/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotHistoryGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotHistoryGet>>, TError = AxiosError<unknown>>(params?: GetApiChatBotHistoryGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotHistoryGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotHistoryGet>>> = ({ signal }) => getApiChatBotHistoryGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotHistoryGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotHistoryGet>>>
export type GetApiChatBotHistoryGetQueryError = AxiosError<unknown>



export function useGetApiChatBotHistoryGet<TData = Awaited<ReturnType<typeof getApiChatBotHistoryGet>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotHistoryGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotHistoryGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotHistoryGetContext = (
    params?: GetApiChatBotHistoryGetContextParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotHistory[]>> => {
    
    
    return axios.get(
      `/api/ChatBotHistory/GetContext`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotHistoryGetContextQueryKey = (params?: GetApiChatBotHistoryGetContextParams,) => {
    return [
    `/api/ChatBotHistory/GetContext`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotHistoryGetContextQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>, TError = AxiosError<unknown>>(params?: GetApiChatBotHistoryGetContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotHistoryGetContextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>> = ({ signal }) => getApiChatBotHistoryGetContext(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotHistoryGetContextQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>>
export type GetApiChatBotHistoryGetContextQueryError = AxiosError<unknown>



export function useGetApiChatBotHistoryGetContext<TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotHistoryGetContextParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetContext>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotHistoryGetContextQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotHistoryGetBefore = (
    params?: GetApiChatBotHistoryGetBeforeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotHistory[]>> => {
    
    
    return axios.get(
      `/api/ChatBotHistory/GetBefore`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotHistoryGetBeforeQueryKey = (params?: GetApiChatBotHistoryGetBeforeParams,) => {
    return [
    `/api/ChatBotHistory/GetBefore`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotHistoryGetBeforeQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>, TError = AxiosError<unknown>>(params?: GetApiChatBotHistoryGetBeforeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotHistoryGetBeforeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>> = ({ signal }) => getApiChatBotHistoryGetBefore(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotHistoryGetBeforeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>>
export type GetApiChatBotHistoryGetBeforeQueryError = AxiosError<unknown>



export function useGetApiChatBotHistoryGetBefore<TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotHistoryGetBeforeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetBefore>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotHistoryGetBeforeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatBotHistoryGetAfter = (
    params?: GetApiChatBotHistoryGetAfterParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotHistory[]>> => {
    
    
    return axios.get(
      `/api/ChatBotHistory/GetAfter`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatBotHistoryGetAfterQueryKey = (params?: GetApiChatBotHistoryGetAfterParams,) => {
    return [
    `/api/ChatBotHistory/GetAfter`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatBotHistoryGetAfterQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>, TError = AxiosError<unknown>>(params?: GetApiChatBotHistoryGetAfterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatBotHistoryGetAfterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>> = ({ signal }) => getApiChatBotHistoryGetAfter(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatBotHistoryGetAfterQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>>
export type GetApiChatBotHistoryGetAfterQueryError = AxiosError<unknown>



export function useGetApiChatBotHistoryGetAfter<TData = Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>, TError = AxiosError<unknown>>(
 params?: GetApiChatBotHistoryGetAfterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatBotHistoryGetAfter>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatBotHistoryGetAfterQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatListChatModelIds = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.get(
      `/api/Chat/ListChatModelIds`,options
    );
  }




export const getGetApiChatListChatModelIdsQueryKey = () => {
    return [
    `/api/Chat/ListChatModelIds`
    ] as const;
    }

    
export const getGetApiChatListChatModelIdsQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatListChatModelIds>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatListChatModelIds>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatListChatModelIdsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatListChatModelIds>>> = ({ signal }) => getApiChatListChatModelIds({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatListChatModelIds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatListChatModelIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatListChatModelIds>>>
export type GetApiChatListChatModelIdsQueryError = AxiosError<unknown>



export function useGetApiChatListChatModelIds<TData = Awaited<ReturnType<typeof getApiChatListChatModelIds>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatListChatModelIds>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatListChatModelIdsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiChatDebugMultipleChat = (
    chatInput: ChatInput,
    params?: PostApiChatDebugMultipleChatParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DebugChatResult[]>> => {
    
    
    return axios.post(
      `/api/Chat/DebugMultipleChat`,
      chatInput,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatDebugMultipleChatMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>, TError,{data: ChatInput;params?: PostApiChatDebugMultipleChatParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>, TError,{data: ChatInput;params?: PostApiChatDebugMultipleChatParams}, TContext> => {

const mutationKey = ['postApiChatDebugMultipleChat'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>, {data: ChatInput;params?: PostApiChatDebugMultipleChatParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatDebugMultipleChat(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatDebugMultipleChatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>>
    export type PostApiChatDebugMultipleChatMutationBody = ChatInput
    export type PostApiChatDebugMultipleChatMutationError = AxiosError<unknown>

    export const usePostApiChatDebugMultipleChat = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>, TError,{data: ChatInput;params?: PostApiChatDebugMultipleChatParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatDebugMultipleChat>>,
        TError,
        {data: ChatInput;params?: PostApiChatDebugMultipleChatParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatDebugMultipleChatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatCreditKeyListByUserId = (
    params?: GetApiChatCreditKeyListByUserIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatCreditKey>> => {
    
    
    return axios.get(
      `/api/ChatCreditKey/ListByUserId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatCreditKeyListByUserIdQueryKey = (params?: GetApiChatCreditKeyListByUserIdParams,) => {
    return [
    `/api/ChatCreditKey/ListByUserId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatCreditKeyListByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>, TError = AxiosError<unknown>>(params?: GetApiChatCreditKeyListByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatCreditKeyListByUserIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>> = ({ signal }) => getApiChatCreditKeyListByUserId(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatCreditKeyListByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>>
export type GetApiChatCreditKeyListByUserIdQueryError = AxiosError<unknown>



export function useGetApiChatCreditKeyListByUserId<TData = Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>, TError = AxiosError<unknown>>(
 params?: GetApiChatCreditKeyListByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyListByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatCreditKeyListByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatCreditKeyGetValidCredit = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.get(
      `/api/ChatCreditKey/GetValidCredit`,options
    );
  }




export const getGetApiChatCreditKeyGetValidCreditQueryKey = () => {
    return [
    `/api/ChatCreditKey/GetValidCredit`
    ] as const;
    }

    
export const getGetApiChatCreditKeyGetValidCreditQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatCreditKeyGetValidCreditQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>> = ({ signal }) => getApiChatCreditKeyGetValidCredit({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatCreditKeyGetValidCreditQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>>
export type GetApiChatCreditKeyGetValidCreditQueryError = AxiosError<unknown>



export function useGetApiChatCreditKeyGetValidCredit<TData = Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCredit>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatCreditKeyGetValidCreditQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatCreditKeyGetValidCreditByWorkspaceOwner = (
    params?: GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.get(
      `/api/ChatCreditKey/GetValidCreditByWorkspaceOwner`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryKey = (params?: GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerParams,) => {
    return [
    `/api/ChatCreditKey/GetValidCreditByWorkspaceOwner`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>, TError = AxiosError<unknown>>(params?: GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>> = ({ signal }) => getApiChatCreditKeyGetValidCreditByWorkspaceOwner(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>>
export type GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryError = AxiosError<unknown>



export function useGetApiChatCreditKeyGetValidCreditByWorkspaceOwner<TData = Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>, TError = AxiosError<unknown>>(
 params?: GetApiChatCreditKeyGetValidCreditByWorkspaceOwnerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatCreditKeyGetValidCreditByWorkspaceOwner>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatCreditKeyGetValidCreditByWorkspaceOwnerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiEmbeddingCollectionList = (
    params?: GetApiEmbeddingCollectionListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfEmbeddingCollection>> => {
    
    
    return axios.get(
      `/api/EmbeddingCollection/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEmbeddingCollectionListQueryKey = (params?: GetApiEmbeddingCollectionListParams,) => {
    return [
    `/api/EmbeddingCollection/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEmbeddingCollectionListQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>, TError = AxiosError<unknown>>(params?: GetApiEmbeddingCollectionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmbeddingCollectionListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>> = ({ signal }) => getApiEmbeddingCollectionList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEmbeddingCollectionListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>>
export type GetApiEmbeddingCollectionListQueryError = AxiosError<unknown>



export function useGetApiEmbeddingCollectionList<TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>, TError = AxiosError<unknown>>(
 params?: GetApiEmbeddingCollectionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEmbeddingCollectionListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiEmbeddingCollectionFindCollectionsTags = (
    postApiEmbeddingCollectionFindCollectionsTagsBody: string[],
    params?: PostApiEmbeddingCollectionFindCollectionsTagsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.post(
      `/api/EmbeddingCollection/FindCollectionsTags`,
      postApiEmbeddingCollectionFindCollectionsTagsBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingCollectionFindCollectionsTagsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>, TError,{data: string[];params?: PostApiEmbeddingCollectionFindCollectionsTagsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>, TError,{data: string[];params?: PostApiEmbeddingCollectionFindCollectionsTagsParams}, TContext> => {

const mutationKey = ['postApiEmbeddingCollectionFindCollectionsTags'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>, {data: string[];params?: PostApiEmbeddingCollectionFindCollectionsTagsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingCollectionFindCollectionsTags(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingCollectionFindCollectionsTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>>
    export type PostApiEmbeddingCollectionFindCollectionsTagsMutationBody = string[]
    export type PostApiEmbeddingCollectionFindCollectionsTagsMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingCollectionFindCollectionsTags = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>, TError,{data: string[];params?: PostApiEmbeddingCollectionFindCollectionsTagsParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingCollectionFindCollectionsTags>>,
        TError,
        {data: string[];params?: PostApiEmbeddingCollectionFindCollectionsTagsParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingCollectionFindCollectionsTagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingCollectionSearchDataItems = (
    postApiEmbeddingCollectionSearchDataItemsBody: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree,
    params?: PostApiEmbeddingCollectionSearchDataItemsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfEmbeddingDataItem>> => {
    
    
    return axios.post(
      `/api/EmbeddingCollection/SearchDataItems`,
      postApiEmbeddingCollectionSearchDataItemsBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingCollectionSearchDataItemsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>, TError,{data: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree;params?: PostApiEmbeddingCollectionSearchDataItemsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>, TError,{data: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree;params?: PostApiEmbeddingCollectionSearchDataItemsParams}, TContext> => {

const mutationKey = ['postApiEmbeddingCollectionSearchDataItems'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>, {data: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree;params?: PostApiEmbeddingCollectionSearchDataItemsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingCollectionSearchDataItems(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingCollectionSearchDataItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>>
    export type PostApiEmbeddingCollectionSearchDataItemsMutationBody = PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree
    export type PostApiEmbeddingCollectionSearchDataItemsMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingCollectionSearchDataItems = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>, TError,{data: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree;params?: PostApiEmbeddingCollectionSearchDataItemsParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingCollectionSearchDataItems>>,
        TError,
        {data: PostApiEmbeddingCollectionSearchDataItemsBodyOne | PostApiEmbeddingCollectionSearchDataItemsBodyTwo | PostApiEmbeddingCollectionSearchDataItemsBodyThree;params?: PostApiEmbeddingCollectionSearchDataItemsParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingCollectionSearchDataItemsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiEmbeddingCollectionGet = (
    params?: GetApiEmbeddingCollectionGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmbeddingCollection>> => {
    
    
    return axios.get(
      `/api/EmbeddingCollection/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEmbeddingCollectionGetQueryKey = (params?: GetApiEmbeddingCollectionGetParams,) => {
    return [
    `/api/EmbeddingCollection/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEmbeddingCollectionGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>, TError = AxiosError<unknown>>(params?: GetApiEmbeddingCollectionGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmbeddingCollectionGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>> = ({ signal }) => getApiEmbeddingCollectionGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEmbeddingCollectionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>>
export type GetApiEmbeddingCollectionGetQueryError = AxiosError<unknown>



export function useGetApiEmbeddingCollectionGet<TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>, TError = AxiosError<unknown>>(
 params?: GetApiEmbeddingCollectionGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEmbeddingCollectionGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiEmbeddingCollectionCreate = (
    params?: PostApiEmbeddingCollectionCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/EmbeddingCollection/Create`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingCollectionCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>, TError,{params?: PostApiEmbeddingCollectionCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>, TError,{params?: PostApiEmbeddingCollectionCreateParams}, TContext> => {

const mutationKey = ['postApiEmbeddingCollectionCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>, {params?: PostApiEmbeddingCollectionCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiEmbeddingCollectionCreate(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingCollectionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>>
    
    export type PostApiEmbeddingCollectionCreateMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingCollectionCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>, TError,{params?: PostApiEmbeddingCollectionCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingCollectionCreate>>,
        TError,
        {params?: PostApiEmbeddingCollectionCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingCollectionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiEmbeddingCollectionRename = (
    params?: PutApiEmbeddingCollectionRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/EmbeddingCollection/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiEmbeddingCollectionRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>, TError,{params?: PutApiEmbeddingCollectionRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>, TError,{params?: PutApiEmbeddingCollectionRenameParams}, TContext> => {

const mutationKey = ['putApiEmbeddingCollectionRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>, {params?: PutApiEmbeddingCollectionRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiEmbeddingCollectionRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiEmbeddingCollectionRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>>
    
    export type PutApiEmbeddingCollectionRenameMutationError = AxiosError<unknown>

    export const usePutApiEmbeddingCollectionRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>, TError,{params?: PutApiEmbeddingCollectionRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiEmbeddingCollectionRename>>,
        TError,
        {params?: PutApiEmbeddingCollectionRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiEmbeddingCollectionRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiEmbeddingCollectionDelete = (
    params?: DeleteApiEmbeddingCollectionDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/EmbeddingCollection/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiEmbeddingCollectionDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>, TError,{params?: DeleteApiEmbeddingCollectionDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>, TError,{params?: DeleteApiEmbeddingCollectionDeleteParams}, TContext> => {

const mutationKey = ['deleteApiEmbeddingCollectionDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>, {params?: DeleteApiEmbeddingCollectionDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiEmbeddingCollectionDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiEmbeddingCollectionDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>>
    
    export type DeleteApiEmbeddingCollectionDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiEmbeddingCollectionDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>, TError,{params?: DeleteApiEmbeddingCollectionDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiEmbeddingCollectionDelete>>,
        TError,
        {params?: DeleteApiEmbeddingCollectionDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiEmbeddingCollectionDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingCollectionTestSearch = (
    testSearchRequest: TestSearchRequest,
    params?: PostApiEmbeddingCollectionTestSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TestSearchResult[]>> => {
    
    
    return axios.post(
      `/api/EmbeddingCollection/TestSearch`,
      testSearchRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingCollectionTestSearchMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>, TError,{data: TestSearchRequest;params?: PostApiEmbeddingCollectionTestSearchParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>, TError,{data: TestSearchRequest;params?: PostApiEmbeddingCollectionTestSearchParams}, TContext> => {

const mutationKey = ['postApiEmbeddingCollectionTestSearch'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>, {data: TestSearchRequest;params?: PostApiEmbeddingCollectionTestSearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingCollectionTestSearch(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingCollectionTestSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>>
    export type PostApiEmbeddingCollectionTestSearchMutationBody = TestSearchRequest
    export type PostApiEmbeddingCollectionTestSearchMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingCollectionTestSearch = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>, TError,{data: TestSearchRequest;params?: PostApiEmbeddingCollectionTestSearchParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingCollectionTestSearch>>,
        TError,
        {data: TestSearchRequest;params?: PostApiEmbeddingCollectionTestSearchParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingCollectionTestSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiEmbeddingCollectionDataToolExport = (
    params?: GetApiEmbeddingCollectionDataToolExportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/EmbeddingCollectionDataTool/Export`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEmbeddingCollectionDataToolExportQueryKey = (params?: GetApiEmbeddingCollectionDataToolExportParams,) => {
    return [
    `/api/EmbeddingCollectionDataTool/Export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEmbeddingCollectionDataToolExportQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>, TError = AxiosError<unknown>>(params?: GetApiEmbeddingCollectionDataToolExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmbeddingCollectionDataToolExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>> = ({ signal }) => getApiEmbeddingCollectionDataToolExport(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEmbeddingCollectionDataToolExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>>
export type GetApiEmbeddingCollectionDataToolExportQueryError = AxiosError<unknown>



export function useGetApiEmbeddingCollectionDataToolExport<TData = Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>, TError = AxiosError<unknown>>(
 params?: GetApiEmbeddingCollectionDataToolExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingCollectionDataToolExport>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEmbeddingCollectionDataToolExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiEmbeddingCollectionDataToolImport = (
    postApiEmbeddingCollectionDataToolImportBody: PostApiEmbeddingCollectionDataToolImportBody,
    params?: PostApiEmbeddingCollectionDataToolImportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiEmbeddingCollectionDataToolImportBody.file !== undefined) {
 formData.append(`file`, postApiEmbeddingCollectionDataToolImportBody.file)
 }

    return axios.post(
      `/api/EmbeddingCollectionDataTool/Import`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingCollectionDataToolImportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>, TError,{data: PostApiEmbeddingCollectionDataToolImportBody;params?: PostApiEmbeddingCollectionDataToolImportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>, TError,{data: PostApiEmbeddingCollectionDataToolImportBody;params?: PostApiEmbeddingCollectionDataToolImportParams}, TContext> => {

const mutationKey = ['postApiEmbeddingCollectionDataToolImport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>, {data: PostApiEmbeddingCollectionDataToolImportBody;params?: PostApiEmbeddingCollectionDataToolImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingCollectionDataToolImport(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingCollectionDataToolImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>>
    export type PostApiEmbeddingCollectionDataToolImportMutationBody = PostApiEmbeddingCollectionDataToolImportBody
    export type PostApiEmbeddingCollectionDataToolImportMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingCollectionDataToolImport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>, TError,{data: PostApiEmbeddingCollectionDataToolImportBody;params?: PostApiEmbeddingCollectionDataToolImportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingCollectionDataToolImport>>,
        TError,
        {data: PostApiEmbeddingCollectionDataToolImportBody;params?: PostApiEmbeddingCollectionDataToolImportParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingCollectionDataToolImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingAddExcel = (
    postApiEmbeddingAddExcelBody: PostApiEmbeddingAddExcelBody,
    params?: PostApiEmbeddingAddExcelParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiEmbeddingAddExcelBody.file !== undefined) {
 formData.append(`file`, postApiEmbeddingAddExcelBody.file)
 }

    return axios.post(
      `/api/Embedding/AddExcel`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingAddExcelMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>, TError,{data: PostApiEmbeddingAddExcelBody;params?: PostApiEmbeddingAddExcelParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>, TError,{data: PostApiEmbeddingAddExcelBody;params?: PostApiEmbeddingAddExcelParams}, TContext> => {

const mutationKey = ['postApiEmbeddingAddExcel'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>, {data: PostApiEmbeddingAddExcelBody;params?: PostApiEmbeddingAddExcelParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingAddExcel(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingAddExcelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>>
    export type PostApiEmbeddingAddExcelMutationBody = PostApiEmbeddingAddExcelBody
    export type PostApiEmbeddingAddExcelMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingAddExcel = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>, TError,{data: PostApiEmbeddingAddExcelBody;params?: PostApiEmbeddingAddExcelParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingAddExcel>>,
        TError,
        {data: PostApiEmbeddingAddExcelBody;params?: PostApiEmbeddingAddExcelParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingAddExcelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingReplaceDataWithExcel = (
    postApiEmbeddingReplaceDataWithExcelBody: PostApiEmbeddingReplaceDataWithExcelBody,
    params?: PostApiEmbeddingReplaceDataWithExcelParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiEmbeddingReplaceDataWithExcelBody.file !== undefined) {
 formData.append(`file`, postApiEmbeddingReplaceDataWithExcelBody.file)
 }

    return axios.post(
      `/api/Embedding/ReplaceDataWithExcel`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingReplaceDataWithExcelMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>, TError,{data: PostApiEmbeddingReplaceDataWithExcelBody;params?: PostApiEmbeddingReplaceDataWithExcelParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>, TError,{data: PostApiEmbeddingReplaceDataWithExcelBody;params?: PostApiEmbeddingReplaceDataWithExcelParams}, TContext> => {

const mutationKey = ['postApiEmbeddingReplaceDataWithExcel'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>, {data: PostApiEmbeddingReplaceDataWithExcelBody;params?: PostApiEmbeddingReplaceDataWithExcelParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingReplaceDataWithExcel(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingReplaceDataWithExcelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>>
    export type PostApiEmbeddingReplaceDataWithExcelMutationBody = PostApiEmbeddingReplaceDataWithExcelBody
    export type PostApiEmbeddingReplaceDataWithExcelMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingReplaceDataWithExcel = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>, TError,{data: PostApiEmbeddingReplaceDataWithExcelBody;params?: PostApiEmbeddingReplaceDataWithExcelParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingReplaceDataWithExcel>>,
        TError,
        {data: PostApiEmbeddingReplaceDataWithExcelBody;params?: PostApiEmbeddingReplaceDataWithExcelParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingReplaceDataWithExcelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingAddText = (
    embeddingAddTextViewModel: EmbeddingAddTextViewModel,
    params?: PostApiEmbeddingAddTextParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/Embedding/AddText`,
      embeddingAddTextViewModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingAddTextMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddText>>, TError,{data: EmbeddingAddTextViewModel;params?: PostApiEmbeddingAddTextParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddText>>, TError,{data: EmbeddingAddTextViewModel;params?: PostApiEmbeddingAddTextParams}, TContext> => {

const mutationKey = ['postApiEmbeddingAddText'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingAddText>>, {data: EmbeddingAddTextViewModel;params?: PostApiEmbeddingAddTextParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingAddText(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingAddTextMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingAddText>>>
    export type PostApiEmbeddingAddTextMutationBody = EmbeddingAddTextViewModel
    export type PostApiEmbeddingAddTextMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingAddText = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddText>>, TError,{data: EmbeddingAddTextViewModel;params?: PostApiEmbeddingAddTextParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingAddText>>,
        TError,
        {data: EmbeddingAddTextViewModel;params?: PostApiEmbeddingAddTextParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingAddTextMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEmbeddingAddTextToData = (
    embeddingTextData: EmbeddingTextData,
    params?: PostApiEmbeddingAddTextToDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/Embedding/AddTextToData`,
      embeddingTextData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEmbeddingAddTextToDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>, TError,{data: EmbeddingTextData;params?: PostApiEmbeddingAddTextToDataParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>, TError,{data: EmbeddingTextData;params?: PostApiEmbeddingAddTextToDataParams}, TContext> => {

const mutationKey = ['postApiEmbeddingAddTextToData'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>, {data: EmbeddingTextData;params?: PostApiEmbeddingAddTextToDataParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEmbeddingAddTextToData(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmbeddingAddTextToDataMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>>
    export type PostApiEmbeddingAddTextToDataMutationBody = EmbeddingTextData
    export type PostApiEmbeddingAddTextToDataMutationError = AxiosError<unknown>

    export const usePostApiEmbeddingAddTextToData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>, TError,{data: EmbeddingTextData;params?: PostApiEmbeddingAddTextToDataParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmbeddingAddTextToData>>,
        TError,
        {data: EmbeddingTextData;params?: PostApiEmbeddingAddTextToDataParams},
        TContext
      > => {

      const mutationOptions = getPostApiEmbeddingAddTextToDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiEmbeddingUpdateDataPointText = (
    embeddingTextData: EmbeddingTextData,
    params?: PutApiEmbeddingUpdateDataPointTextParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/Embedding/UpdateDataPointText`,
      embeddingTextData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiEmbeddingUpdateDataPointTextMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>, TError,{data: EmbeddingTextData;params?: PutApiEmbeddingUpdateDataPointTextParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>, TError,{data: EmbeddingTextData;params?: PutApiEmbeddingUpdateDataPointTextParams}, TContext> => {

const mutationKey = ['putApiEmbeddingUpdateDataPointText'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>, {data: EmbeddingTextData;params?: PutApiEmbeddingUpdateDataPointTextParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiEmbeddingUpdateDataPointText(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiEmbeddingUpdateDataPointTextMutationResult = NonNullable<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>>
    export type PutApiEmbeddingUpdateDataPointTextMutationBody = EmbeddingTextData
    export type PutApiEmbeddingUpdateDataPointTextMutationError = AxiosError<unknown>

    export const usePutApiEmbeddingUpdateDataPointText = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>, TError,{data: EmbeddingTextData;params?: PutApiEmbeddingUpdateDataPointTextParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiEmbeddingUpdateDataPointText>>,
        TError,
        {data: EmbeddingTextData;params?: PutApiEmbeddingUpdateDataPointTextParams},
        TContext
      > => {

      const mutationOptions = getPutApiEmbeddingUpdateDataPointTextMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiEmbeddingUpdateDataDescription = (
    params?: PutApiEmbeddingUpdateDataDescriptionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/Embedding/UpdateDataDescription`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiEmbeddingUpdateDataDescriptionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>, TError,{params?: PutApiEmbeddingUpdateDataDescriptionParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>, TError,{params?: PutApiEmbeddingUpdateDataDescriptionParams}, TContext> => {

const mutationKey = ['putApiEmbeddingUpdateDataDescription'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>, {params?: PutApiEmbeddingUpdateDataDescriptionParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiEmbeddingUpdateDataDescription(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiEmbeddingUpdateDataDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>>
    
    export type PutApiEmbeddingUpdateDataDescriptionMutationError = AxiosError<unknown>

    export const usePutApiEmbeddingUpdateDataDescription = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>, TError,{params?: PutApiEmbeddingUpdateDataDescriptionParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiEmbeddingUpdateDataDescription>>,
        TError,
        {params?: PutApiEmbeddingUpdateDataDescriptionParams},
        TContext
      > => {

      const mutationOptions = getPutApiEmbeddingUpdateDataDescriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiEmbeddingUpdateDataTags = (
    putApiEmbeddingUpdateDataTagsBody: string[],
    params?: PutApiEmbeddingUpdateDataTagsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/Embedding/UpdateDataTags`,
      putApiEmbeddingUpdateDataTagsBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiEmbeddingUpdateDataTagsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>, TError,{data: string[];params?: PutApiEmbeddingUpdateDataTagsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>, TError,{data: string[];params?: PutApiEmbeddingUpdateDataTagsParams}, TContext> => {

const mutationKey = ['putApiEmbeddingUpdateDataTags'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>, {data: string[];params?: PutApiEmbeddingUpdateDataTagsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiEmbeddingUpdateDataTags(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiEmbeddingUpdateDataTagsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>>
    export type PutApiEmbeddingUpdateDataTagsMutationBody = string[]
    export type PutApiEmbeddingUpdateDataTagsMutationError = AxiosError<unknown>

    export const usePutApiEmbeddingUpdateDataTags = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>, TError,{data: string[];params?: PutApiEmbeddingUpdateDataTagsParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiEmbeddingUpdateDataTags>>,
        TError,
        {data: string[];params?: PutApiEmbeddingUpdateDataTagsParams},
        TContext
      > => {

      const mutationOptions = getPutApiEmbeddingUpdateDataTagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiEmbeddingListTextData = (
    params?: GetApiEmbeddingListTextDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfEmbeddingDataPoint>> => {
    
    
    return axios.get(
      `/api/Embedding/ListTextData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEmbeddingListTextDataQueryKey = (params?: GetApiEmbeddingListTextDataParams,) => {
    return [
    `/api/Embedding/ListTextData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEmbeddingListTextDataQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmbeddingListTextData>>, TError = AxiosError<unknown>>(params?: GetApiEmbeddingListTextDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingListTextData>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmbeddingListTextDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmbeddingListTextData>>> = ({ signal }) => getApiEmbeddingListTextData(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingListTextData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEmbeddingListTextDataQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmbeddingListTextData>>>
export type GetApiEmbeddingListTextDataQueryError = AxiosError<unknown>



export function useGetApiEmbeddingListTextData<TData = Awaited<ReturnType<typeof getApiEmbeddingListTextData>>, TError = AxiosError<unknown>>(
 params?: GetApiEmbeddingListTextDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEmbeddingListTextData>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEmbeddingListTextDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiEmbeddingDeleteData = (
    params?: DeleteApiEmbeddingDeleteDataParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/Embedding/DeleteData`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiEmbeddingDeleteDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>, TError,{params?: DeleteApiEmbeddingDeleteDataParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>, TError,{params?: DeleteApiEmbeddingDeleteDataParams}, TContext> => {

const mutationKey = ['deleteApiEmbeddingDeleteData'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>, {params?: DeleteApiEmbeddingDeleteDataParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiEmbeddingDeleteData(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiEmbeddingDeleteDataMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>>
    
    export type DeleteApiEmbeddingDeleteDataMutationError = AxiosError<unknown>

    export const useDeleteApiEmbeddingDeleteData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>, TError,{params?: DeleteApiEmbeddingDeleteDataParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiEmbeddingDeleteData>>,
        TError,
        {params?: DeleteApiEmbeddingDeleteDataParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiEmbeddingDeleteDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiEmbeddingDeleteDataPoint = (
    params?: DeleteApiEmbeddingDeleteDataPointParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/Embedding/DeleteDataPoint`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiEmbeddingDeleteDataPointMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>, TError,{params?: DeleteApiEmbeddingDeleteDataPointParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>, TError,{params?: DeleteApiEmbeddingDeleteDataPointParams}, TContext> => {

const mutationKey = ['deleteApiEmbeddingDeleteDataPoint'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>, {params?: DeleteApiEmbeddingDeleteDataPointParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiEmbeddingDeleteDataPoint(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiEmbeddingDeleteDataPointMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>>
    
    export type DeleteApiEmbeddingDeleteDataPointMutationError = AxiosError<unknown>

    export const useDeleteApiEmbeddingDeleteDataPoint = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>, TError,{params?: DeleteApiEmbeddingDeleteDataPointParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiEmbeddingDeleteDataPoint>>,
        TError,
        {params?: DeleteApiEmbeddingDeleteDataPointParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiEmbeddingDeleteDataPointMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiLineBotWebhookBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/LineBot/webhook/${botProviderId}`,undefined,options
    );
  }



export const getPostApiLineBotWebhookBotProviderIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>, TError,{botProviderId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>, TError,{botProviderId: string}, TContext> => {

const mutationKey = ['postApiLineBotWebhookBotProviderId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>, {botProviderId: string}> = (props) => {
          const {botProviderId} = props ?? {};

          return  postApiLineBotWebhookBotProviderId(botProviderId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiLineBotWebhookBotProviderIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>>
    
    export type PostApiLineBotWebhookBotProviderIdMutationError = AxiosError<unknown>

    export const usePostApiLineBotWebhookBotProviderId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>, TError,{botProviderId: string}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiLineBotWebhookBotProviderId>>,
        TError,
        {botProviderId: string},
        TContext
      > => {

      const mutationOptions = getPostApiLineBotWebhookBotProviderIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiUserGetSetting = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSetting>> => {
    
    
    return axios.get(
      `/api/User/GetSetting`,options
    );
  }




export const getGetApiUserGetSettingQueryKey = () => {
    return [
    `/api/User/GetSetting`
    ] as const;
    }

    
export const getGetApiUserGetSettingQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserGetSetting>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUserGetSetting>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserGetSettingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserGetSetting>>> = ({ signal }) => getApiUserGetSetting({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserGetSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiUserGetSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetSetting>>>
export type GetApiUserGetSettingQueryError = AxiosError<unknown>



export function useGetApiUserGetSetting<TData = Awaited<ReturnType<typeof getApiUserGetSetting>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUserGetSetting>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiUserGetSettingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiUserChangeDisplayName = (
    params?: PutApiUserChangeDisplayNameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.put(
      `/api/User/ChangeDisplayName`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiUserChangeDisplayNameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangeDisplayName>>, TError,{params?: PutApiUserChangeDisplayNameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangeDisplayName>>, TError,{params?: PutApiUserChangeDisplayNameParams}, TContext> => {

const mutationKey = ['putApiUserChangeDisplayName'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUserChangeDisplayName>>, {params?: PutApiUserChangeDisplayNameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiUserChangeDisplayName(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiUserChangeDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUserChangeDisplayName>>>
    
    export type PutApiUserChangeDisplayNameMutationError = AxiosError<unknown>

    export const usePutApiUserChangeDisplayName = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserChangeDisplayName>>, TError,{params?: PutApiUserChangeDisplayNameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiUserChangeDisplayName>>,
        TError,
        {params?: PutApiUserChangeDisplayNameParams},
        TContext
      > => {

      const mutationOptions = getPutApiUserChangeDisplayNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiUserUpdateSetting = (
    userSetting: UserSetting, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.put(
      `/api/User/UpdateSetting`,
      userSetting,options
    );
  }



export const getPutApiUserUpdateSettingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserUpdateSetting>>, TError,{data: UserSetting}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUserUpdateSetting>>, TError,{data: UserSetting}, TContext> => {

const mutationKey = ['putApiUserUpdateSetting'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUserUpdateSetting>>, {data: UserSetting}> = (props) => {
          const {data} = props ?? {};

          return  putApiUserUpdateSetting(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiUserUpdateSettingMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUserUpdateSetting>>>
    export type PutApiUserUpdateSettingMutationBody = UserSetting
    export type PutApiUserUpdateSettingMutationError = AxiosError<unknown>

    export const usePutApiUserUpdateSetting = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUserUpdateSetting>>, TError,{data: UserSetting}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiUserUpdateSetting>>,
        TError,
        {data: UserSetting},
        TContext
      > => {

      const mutationOptions = getPutApiUserUpdateSettingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiUserChangePassword = (
    changePasswordModel: ChangePasswordModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.post(
      `/api/User/ChangePassword`,
      changePasswordModel,options
    );
  }



export const getPostApiUserChangePasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserChangePassword>>, TError,{data: ChangePasswordModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUserChangePassword>>, TError,{data: ChangePasswordModel}, TContext> => {

const mutationKey = ['postApiUserChangePassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserChangePassword>>, {data: ChangePasswordModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiUserChangePassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUserChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserChangePassword>>>
    export type PostApiUserChangePasswordMutationBody = ChangePasswordModel
    export type PostApiUserChangePasswordMutationError = AxiosError<unknown>

    export const usePostApiUserChangePassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUserChangePassword>>, TError,{data: ChangePasswordModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiUserChangePassword>>,
        TError,
        {data: ChangePasswordModel},
        TContext
      > => {

      const mutationOptions = getPostApiUserChangePasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiWebBotChatBotProviderId = (
    botProviderId: string,
    webMessageModel: WebMessageModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/WebBot/chat/${botProviderId}`,
      webMessageModel,options
    );
  }



export const getPostApiWebBotChatBotProviderIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>, TError,{botProviderId: string;data: WebMessageModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>, TError,{botProviderId: string;data: WebMessageModel}, TContext> => {

const mutationKey = ['postApiWebBotChatBotProviderId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>, {botProviderId: string;data: WebMessageModel}> = (props) => {
          const {botProviderId,data} = props ?? {};

          return  postApiWebBotChatBotProviderId(botProviderId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebBotChatBotProviderIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>>
    export type PostApiWebBotChatBotProviderIdMutationBody = WebMessageModel
    export type PostApiWebBotChatBotProviderIdMutationError = AxiosError<unknown>

    export const usePostApiWebBotChatBotProviderId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>, TError,{botProviderId: string;data: WebMessageModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebBotChatBotProviderId>>,
        TError,
        {botProviderId: string;data: WebMessageModel},
        TContext
      > => {

      const mutationOptions = getPostApiWebBotChatBotProviderIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiWebBotHistoryBotProviderIdUserId = (
    botProviderId: string,
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatBotHistory[]>> => {
    
    
    return axios.get(
      `/api/WebBot/history/${botProviderId}/${userId}`,options
    );
  }




export const getGetApiWebBotHistoryBotProviderIdUserIdQueryKey = (botProviderId?: string,
    userId?: string,) => {
    return [
    `/api/WebBot/history/${botProviderId}/${userId}`
    ] as const;
    }

    
export const getGetApiWebBotHistoryBotProviderIdUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>, TError = AxiosError<unknown>>(botProviderId: string,
    userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotHistoryBotProviderIdUserIdQueryKey(botProviderId,userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>> = ({ signal }) => getApiWebBotHistoryBotProviderIdUserId(botProviderId,userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotHistoryBotProviderIdUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>>
export type GetApiWebBotHistoryBotProviderIdUserIdQueryError = AxiosError<unknown>



export function useGetApiWebBotHistoryBotProviderIdUserId<TData = Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>, TError = AxiosError<unknown>>(
 botProviderId: string,
    userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotHistoryBotProviderIdUserId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotHistoryBotProviderIdUserIdQueryOptions(botProviderId,userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiWebBotClearHistoryBotProviderIdUserId = (
    botProviderId: string,
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/WebBot/clear-history/${botProviderId}/${userId}`,undefined,options
    );
  }



export const getPostApiWebBotClearHistoryBotProviderIdUserIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>, TError,{botProviderId: string;userId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>, TError,{botProviderId: string;userId: string}, TContext> => {

const mutationKey = ['postApiWebBotClearHistoryBotProviderIdUserId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>, {botProviderId: string;userId: string}> = (props) => {
          const {botProviderId,userId} = props ?? {};

          return  postApiWebBotClearHistoryBotProviderIdUserId(botProviderId,userId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebBotClearHistoryBotProviderIdUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>>
    
    export type PostApiWebBotClearHistoryBotProviderIdUserIdMutationError = AxiosError<unknown>

    export const usePostApiWebBotClearHistoryBotProviderIdUserId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>, TError,{botProviderId: string;userId: string}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebBotClearHistoryBotProviderIdUserId>>,
        TError,
        {botProviderId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getPostApiWebBotClearHistoryBotProviderIdUserIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiWebBotFeedbackBotProviderIdHistoryId = (
    botProviderId: string,
    historyId: string,
    webBotFeedbackModel: WebBotFeedbackModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/WebBot/feedback/${botProviderId}/${historyId}`,
      webBotFeedbackModel,options
    );
  }



export const getPostApiWebBotFeedbackBotProviderIdHistoryIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>, TError,{botProviderId: string;historyId: string;data: WebBotFeedbackModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>, TError,{botProviderId: string;historyId: string;data: WebBotFeedbackModel}, TContext> => {

const mutationKey = ['postApiWebBotFeedbackBotProviderIdHistoryId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>, {botProviderId: string;historyId: string;data: WebBotFeedbackModel}> = (props) => {
          const {botProviderId,historyId,data} = props ?? {};

          return  postApiWebBotFeedbackBotProviderIdHistoryId(botProviderId,historyId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWebBotFeedbackBotProviderIdHistoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>>
    export type PostApiWebBotFeedbackBotProviderIdHistoryIdMutationBody = WebBotFeedbackModel
    export type PostApiWebBotFeedbackBotProviderIdHistoryIdMutationError = AxiosError<unknown>

    export const usePostApiWebBotFeedbackBotProviderIdHistoryId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>, TError,{botProviderId: string;historyId: string;data: WebBotFeedbackModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWebBotFeedbackBotProviderIdHistoryId>>,
        TError,
        {botProviderId: string;historyId: string;data: WebBotFeedbackModel},
        TContext
      > => {

      const mutationOptions = getPostApiWebBotFeedbackBotProviderIdHistoryIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiWebBotConfigBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebBotConfigResponse>> => {
    
    
    return axios.get(
      `/api/WebBot/config/${botProviderId}`,options
    );
  }




export const getGetApiWebBotConfigBotProviderIdQueryKey = (botProviderId?: string,) => {
    return [
    `/api/WebBot/config/${botProviderId}`
    ] as const;
    }

    
export const getGetApiWebBotConfigBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>, TError = AxiosError<unknown>>(botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotConfigBotProviderIdQueryKey(botProviderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>> = ({ signal }) => getApiWebBotConfigBotProviderId(botProviderId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotConfigBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>>
export type GetApiWebBotConfigBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiWebBotConfigBotProviderId<TData = Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>, TError = AxiosError<unknown>>(
 botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotConfigBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotConfigBotProviderIdQueryOptions(botProviderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotAvatarIconBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/avatarIcon/${botProviderId}`,options
    );
  }




export const getGetApiWebBotAvatarIconBotProviderIdQueryKey = (botProviderId?: string,) => {
    return [
    `/api/WebBot/avatarIcon/${botProviderId}`
    ] as const;
    }

    
export const getGetApiWebBotAvatarIconBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>, TError = AxiosError<unknown>>(botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotAvatarIconBotProviderIdQueryKey(botProviderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>> = ({ signal }) => getApiWebBotAvatarIconBotProviderId(botProviderId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotAvatarIconBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>>
export type GetApiWebBotAvatarIconBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiWebBotAvatarIconBotProviderId<TData = Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>, TError = AxiosError<unknown>>(
 botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotAvatarIconBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotAvatarIconBotProviderIdQueryOptions(botProviderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotWidgetIconBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/widgetIcon/${botProviderId}`,options
    );
  }




export const getGetApiWebBotWidgetIconBotProviderIdQueryKey = (botProviderId?: string,) => {
    return [
    `/api/WebBot/widgetIcon/${botProviderId}`
    ] as const;
    }

    
export const getGetApiWebBotWidgetIconBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>, TError = AxiosError<unknown>>(botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotWidgetIconBotProviderIdQueryKey(botProviderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>> = ({ signal }) => getApiWebBotWidgetIconBotProviderId(botProviderId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotWidgetIconBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>>
export type GetApiWebBotWidgetIconBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiWebBotWidgetIconBotProviderId<TData = Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>, TError = AxiosError<unknown>>(
 botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotWidgetIconBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotWidgetIconBotProviderIdQueryOptions(botProviderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotBackgroundImageBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/backgroundImage/${botProviderId}`,options
    );
  }




export const getGetApiWebBotBackgroundImageBotProviderIdQueryKey = (botProviderId?: string,) => {
    return [
    `/api/WebBot/backgroundImage/${botProviderId}`
    ] as const;
    }

    
export const getGetApiWebBotBackgroundImageBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>, TError = AxiosError<unknown>>(botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotBackgroundImageBotProviderIdQueryKey(botProviderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>> = ({ signal }) => getApiWebBotBackgroundImageBotProviderId(botProviderId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotBackgroundImageBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>>
export type GetApiWebBotBackgroundImageBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiWebBotBackgroundImageBotProviderId<TData = Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>, TError = AxiosError<unknown>>(
 botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBackgroundImageBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotBackgroundImageBotProviderIdQueryOptions(botProviderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotScript = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/script`,options
    );
  }




export const getGetApiWebBotScriptQueryKey = () => {
    return [
    `/api/WebBot/script`
    ] as const;
    }

    
export const getGetApiWebBotScriptQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotScript>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotScript>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotScriptQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotScript>>> = ({ signal }) => getApiWebBotScript({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotScript>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotScriptQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotScript>>>
export type GetApiWebBotScriptQueryError = AxiosError<unknown>



export function useGetApiWebBotScript<TData = Awaited<ReturnType<typeof getApiWebBotScript>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotScript>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotScriptQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotSdk = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/sdk`,options
    );
  }




export const getGetApiWebBotSdkQueryKey = () => {
    return [
    `/api/WebBot/sdk`
    ] as const;
    }

    
export const getGetApiWebBotSdkQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotSdk>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdk>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotSdkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotSdk>>> = ({ signal }) => getApiWebBotSdk({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdk>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotSdkQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotSdk>>>
export type GetApiWebBotSdkQueryError = AxiosError<unknown>



export function useGetApiWebBotSdk<TData = Awaited<ReturnType<typeof getApiWebBotSdk>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdk>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotSdkQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotSdkDTs = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/sdk.d.ts`,options
    );
  }




export const getGetApiWebBotSdkDTsQueryKey = () => {
    return [
    `/api/WebBot/sdk.d.ts`
    ] as const;
    }

    
export const getGetApiWebBotSdkDTsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotSdkDTs>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdkDTs>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotSdkDTsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotSdkDTs>>> = ({ signal }) => getApiWebBotSdkDTs({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdkDTs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotSdkDTsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotSdkDTs>>>
export type GetApiWebBotSdkDTsQueryError = AxiosError<unknown>



export function useGetApiWebBotSdkDTs<TData = Awaited<ReturnType<typeof getApiWebBotSdkDTs>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotSdkDTs>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotSdkDTsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotRuntimeFilePath = (
    filePath: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/runtime/${filePath}`,options
    );
  }




export const getGetApiWebBotRuntimeFilePathQueryKey = (filePath?: string,) => {
    return [
    `/api/WebBot/runtime/${filePath}`
    ] as const;
    }

    
export const getGetApiWebBotRuntimeFilePathQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>, TError = AxiosError<unknown>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotRuntimeFilePathQueryKey(filePath);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>> = ({ signal }) => getApiWebBotRuntimeFilePath(filePath, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(filePath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotRuntimeFilePathQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>>
export type GetApiWebBotRuntimeFilePathQueryError = AxiosError<unknown>



export function useGetApiWebBotRuntimeFilePath<TData = Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>, TError = AxiosError<unknown>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotRuntimeFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotRuntimeFilePathQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotBundleBotProviderIdFilePath = (
    botProviderId: string,
    filePath: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/bundle/${botProviderId}/${filePath}`,options
    );
  }




export const getGetApiWebBotBundleBotProviderIdFilePathQueryKey = (botProviderId?: string,
    filePath?: string,) => {
    return [
    `/api/WebBot/bundle/${botProviderId}/${filePath}`
    ] as const;
    }

    
export const getGetApiWebBotBundleBotProviderIdFilePathQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>, TError = AxiosError<unknown>>(botProviderId: string,
    filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotBundleBotProviderIdFilePathQueryKey(botProviderId,filePath);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>> = ({ signal }) => getApiWebBotBundleBotProviderIdFilePath(botProviderId,filePath, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId && filePath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotBundleBotProviderIdFilePathQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>>
export type GetApiWebBotBundleBotProviderIdFilePathQueryError = AxiosError<unknown>



export function useGetApiWebBotBundleBotProviderIdFilePath<TData = Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>, TError = AxiosError<unknown>>(
 botProviderId: string,
    filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotBundleBotProviderIdFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotBundleBotProviderIdFilePathQueryOptions(botProviderId,filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotCustomBotProviderId = (
    botProviderId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/custom/${botProviderId}`,options
    );
  }




export const getGetApiWebBotCustomBotProviderIdQueryKey = (botProviderId?: string,) => {
    return [
    `/api/WebBot/custom/${botProviderId}`
    ] as const;
    }

    
export const getGetApiWebBotCustomBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>, TError = AxiosError<unknown>>(botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotCustomBotProviderIdQueryKey(botProviderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>> = ({ signal }) => getApiWebBotCustomBotProviderId(botProviderId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotCustomBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>>
export type GetApiWebBotCustomBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiWebBotCustomBotProviderId<TData = Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>, TError = AxiosError<unknown>>(
 botProviderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotCustomBotProviderIdQueryOptions(botProviderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWebBotCustomBotProviderIdFilePath = (
    botProviderId: string,
    filePath: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/WebBot/custom/${botProviderId}/${filePath}`,options
    );
  }




export const getGetApiWebBotCustomBotProviderIdFilePathQueryKey = (botProviderId?: string,
    filePath?: string,) => {
    return [
    `/api/WebBot/custom/${botProviderId}/${filePath}`
    ] as const;
    }

    
export const getGetApiWebBotCustomBotProviderIdFilePathQueryOptions = <TData = Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>, TError = AxiosError<unknown>>(botProviderId: string,
    filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWebBotCustomBotProviderIdFilePathQueryKey(botProviderId,filePath);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>> = ({ signal }) => getApiWebBotCustomBotProviderIdFilePath(botProviderId,filePath, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(botProviderId && filePath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWebBotCustomBotProviderIdFilePathQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>>
export type GetApiWebBotCustomBotProviderIdFilePathQueryError = AxiosError<unknown>



export function useGetApiWebBotCustomBotProviderIdFilePath<TData = Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>, TError = AxiosError<unknown>>(
 botProviderId: string,
    filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWebBotCustomBotProviderIdFilePath>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWebBotCustomBotProviderIdFilePathQueryOptions(botProviderId,filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWorkspaceList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Workspace[]>> => {
    
    
    return axios.get(
      `/api/Workspace/List`,options
    );
  }




export const getGetApiWorkspaceListQueryKey = () => {
    return [
    `/api/Workspace/List`
    ] as const;
    }

    
export const getGetApiWorkspaceListQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceList>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceList>>> = ({ signal }) => getApiWorkspaceList({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceList>>>
export type GetApiWorkspaceListQueryError = AxiosError<unknown>



export function useGetApiWorkspaceList<TData = Awaited<ReturnType<typeof getApiWorkspaceList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWorkspaceGet = (
    params?: GetApiWorkspaceGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Workspace>> => {
    
    
    return axios.get(
      `/api/Workspace/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceGetQueryKey = (params?: GetApiWorkspaceGetParams,) => {
    return [
    `/api/Workspace/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceGet>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceGet>>> = ({ signal }) => getApiWorkspaceGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceGet>>>
export type GetApiWorkspaceGetQueryError = AxiosError<unknown>



export function useGetApiWorkspaceGet<TData = Awaited<ReturnType<typeof getApiWorkspaceGet>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWorkspaceGetPublicInfo = (
    params?: GetApiWorkspaceGetPublicInfoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspacePublicInfo>> => {
    
    
    return axios.get(
      `/api/Workspace/GetPublicInfo`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceGetPublicInfoQueryKey = (params?: GetApiWorkspaceGetPublicInfoParams,) => {
    return [
    `/api/Workspace/GetPublicInfo`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceGetPublicInfoQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceGetPublicInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceGetPublicInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>> = ({ signal }) => getApiWorkspaceGetPublicInfo(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceGetPublicInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>>
export type GetApiWorkspaceGetPublicInfoQueryError = AxiosError<unknown>



export function useGetApiWorkspaceGetPublicInfo<TData = Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceGetPublicInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceGetPublicInfo>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceGetPublicInfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiWorkspaceCreate = (
    params?: PostApiWorkspaceCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.post(
      `/api/Workspace/Create`,undefined,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiWorkspaceCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceCreate>>, TError,{params?: PostApiWorkspaceCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceCreate>>, TError,{params?: PostApiWorkspaceCreateParams}, TContext> => {

const mutationKey = ['postApiWorkspaceCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspaceCreate>>, {params?: PostApiWorkspaceCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiWorkspaceCreate(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspaceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspaceCreate>>>
    
    export type PostApiWorkspaceCreateMutationError = AxiosError<unknown>

    export const usePostApiWorkspaceCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceCreate>>, TError,{params?: PostApiWorkspaceCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspaceCreate>>,
        TError,
        {params?: PostApiWorkspaceCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspaceCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiWorkspaceRename = (
    params?: PutApiWorkspaceRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/Workspace/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiWorkspaceRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceRename>>, TError,{params?: PutApiWorkspaceRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceRename>>, TError,{params?: PutApiWorkspaceRenameParams}, TContext> => {

const mutationKey = ['putApiWorkspaceRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspaceRename>>, {params?: PutApiWorkspaceRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiWorkspaceRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspaceRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspaceRename>>>
    
    export type PutApiWorkspaceRenameMutationError = AxiosError<unknown>

    export const usePutApiWorkspaceRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceRename>>, TError,{params?: PutApiWorkspaceRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspaceRename>>,
        TError,
        {params?: PutApiWorkspaceRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspaceRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiWorkspaceDelete = (
    params?: DeleteApiWorkspaceDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/Workspace/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiWorkspaceDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>, TError,{params?: DeleteApiWorkspaceDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>, TError,{params?: DeleteApiWorkspaceDeleteParams}, TContext> => {

const mutationKey = ['deleteApiWorkspaceDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>, {params?: DeleteApiWorkspaceDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiWorkspaceDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspaceDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>>
    
    export type DeleteApiWorkspaceDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiWorkspaceDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>, TError,{params?: DeleteApiWorkspaceDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspaceDelete>>,
        TError,
        {params?: DeleteApiWorkspaceDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspaceDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiWorkspaceUserGetRole = (
    params?: GetApiWorkspaceUserGetRoleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspaceUserRole>> => {
    
    
    return axios.get(
      `/api/WorkspaceUser/GetRole`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceUserGetRoleQueryKey = (params?: GetApiWorkspaceUserGetRoleParams,) => {
    return [
    `/api/WorkspaceUser/GetRole`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceUserGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceUserGetRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceUserGetRoleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>> = ({ signal }) => getApiWorkspaceUserGetRole(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceUserGetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>>
export type GetApiWorkspaceUserGetRoleQueryError = AxiosError<unknown>



export function useGetApiWorkspaceUserGetRole<TData = Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceUserGetRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserGetRole>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceUserGetRoleQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiWorkspaceUserListUsers = (
    params?: GetApiWorkspaceUserListUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspaceUser[]>> => {
    
    
    return axios.get(
      `/api/WorkspaceUser/ListUsers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceUserListUsersQueryKey = (params?: GetApiWorkspaceUserListUsersParams,) => {
    return [
    `/api/WorkspaceUser/ListUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceUserListUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceUserListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceUserListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>> = ({ signal }) => getApiWorkspaceUserListUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceUserListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>>
export type GetApiWorkspaceUserListUsersQueryError = AxiosError<unknown>



export function useGetApiWorkspaceUserListUsers<TData = Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceUserListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListUsers>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceUserListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiWorkspaceUserLeave = (
    params?: DeleteApiWorkspaceUserLeaveParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspaceUser[]>> => {
    
    
    return axios.delete(
      `/api/WorkspaceUser/Leave`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiWorkspaceUserLeaveMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>, TError,{params?: DeleteApiWorkspaceUserLeaveParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>, TError,{params?: DeleteApiWorkspaceUserLeaveParams}, TContext> => {

const mutationKey = ['deleteApiWorkspaceUserLeave'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>, {params?: DeleteApiWorkspaceUserLeaveParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiWorkspaceUserLeave(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspaceUserLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>>
    
    export type DeleteApiWorkspaceUserLeaveMutationError = AxiosError<unknown>

    export const useDeleteApiWorkspaceUserLeave = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>, TError,{params?: DeleteApiWorkspaceUserLeaveParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspaceUserLeave>>,
        TError,
        {params?: DeleteApiWorkspaceUserLeaveParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspaceUserLeaveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiWorkspaceUserAddUsers = (
    workspaceAddUsersModel: WorkspaceAddUsersModel[],
    params?: PostApiWorkspaceUserAddUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.post(
      `/api/WorkspaceUser/AddUsers`,
      workspaceAddUsersModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiWorkspaceUserAddUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>, TError,{data: WorkspaceAddUsersModel[];params?: PostApiWorkspaceUserAddUsersParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>, TError,{data: WorkspaceAddUsersModel[];params?: PostApiWorkspaceUserAddUsersParams}, TContext> => {

const mutationKey = ['postApiWorkspaceUserAddUsers'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>, {data: WorkspaceAddUsersModel[];params?: PostApiWorkspaceUserAddUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiWorkspaceUserAddUsers(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspaceUserAddUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>>
    export type PostApiWorkspaceUserAddUsersMutationBody = WorkspaceAddUsersModel[]
    export type PostApiWorkspaceUserAddUsersMutationError = AxiosError<unknown>

    export const usePostApiWorkspaceUserAddUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>, TError,{data: WorkspaceAddUsersModel[];params?: PostApiWorkspaceUserAddUsersParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspaceUserAddUsers>>,
        TError,
        {data: WorkspaceAddUsersModel[];params?: PostApiWorkspaceUserAddUsersParams},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspaceUserAddUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiWorkspaceUserSetUserRole = (
    params?: PutApiWorkspaceUserSetUserRoleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspaceUser>> => {
    
    
    return axios.put(
      `/api/WorkspaceUser/SetUserRole`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiWorkspaceUserSetUserRoleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>, TError,{params?: PutApiWorkspaceUserSetUserRoleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>, TError,{params?: PutApiWorkspaceUserSetUserRoleParams}, TContext> => {

const mutationKey = ['putApiWorkspaceUserSetUserRole'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>, {params?: PutApiWorkspaceUserSetUserRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiWorkspaceUserSetUserRole(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspaceUserSetUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>>
    
    export type PutApiWorkspaceUserSetUserRoleMutationError = AxiosError<unknown>

    export const usePutApiWorkspaceUserSetUserRole = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>, TError,{params?: PutApiWorkspaceUserSetUserRoleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspaceUserSetUserRole>>,
        TError,
        {params?: PutApiWorkspaceUserSetUserRoleParams},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspaceUserSetUserRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiWorkspaceUserSetUserOwnerRole = (
    params?: PutApiWorkspaceUserSetUserOwnerRoleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.put(
      `/api/WorkspaceUser/SetUserOwnerRole`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiWorkspaceUserSetUserOwnerRoleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>, TError,{params?: PutApiWorkspaceUserSetUserOwnerRoleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>, TError,{params?: PutApiWorkspaceUserSetUserOwnerRoleParams}, TContext> => {

const mutationKey = ['putApiWorkspaceUserSetUserOwnerRole'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>, {params?: PutApiWorkspaceUserSetUserOwnerRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiWorkspaceUserSetUserOwnerRole(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspaceUserSetUserOwnerRoleMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>>
    
    export type PutApiWorkspaceUserSetUserOwnerRoleMutationError = AxiosError<unknown>

    export const usePutApiWorkspaceUserSetUserOwnerRole = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>, TError,{params?: PutApiWorkspaceUserSetUserOwnerRoleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspaceUserSetUserOwnerRole>>,
        TError,
        {params?: PutApiWorkspaceUserSetUserOwnerRoleParams},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspaceUserSetUserOwnerRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiWorkspaceUserDeleteUser = (
    params?: DeleteApiWorkspaceUserDeleteUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspaceUser[]>> => {
    
    
    return axios.delete(
      `/api/WorkspaceUser/DeleteUser`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiWorkspaceUserDeleteUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>, TError,{params?: DeleteApiWorkspaceUserDeleteUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>, TError,{params?: DeleteApiWorkspaceUserDeleteUserParams}, TContext> => {

const mutationKey = ['deleteApiWorkspaceUserDeleteUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>, {params?: DeleteApiWorkspaceUserDeleteUserParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiWorkspaceUserDeleteUser(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspaceUserDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>>
    
    export type DeleteApiWorkspaceUserDeleteUserMutationError = AxiosError<unknown>

    export const useDeleteApiWorkspaceUserDeleteUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>, TError,{params?: DeleteApiWorkspaceUserDeleteUserParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspaceUserDeleteUser>>,
        TError,
        {params?: DeleteApiWorkspaceUserDeleteUserParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspaceUserDeleteUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiWorkspaceUserListPendingUsers = (
    params?: GetApiWorkspaceUserListPendingUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WorkspacePendingUser[]>> => {
    
    
    return axios.get(
      `/api/WorkspaceUser/ListPendingUsers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceUserListPendingUsersQueryKey = (params?: GetApiWorkspaceUserListPendingUsersParams,) => {
    return [
    `/api/WorkspaceUser/ListPendingUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceUserListPendingUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceUserListPendingUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceUserListPendingUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>> = ({ signal }) => getApiWorkspaceUserListPendingUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceUserListPendingUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>>
export type GetApiWorkspaceUserListPendingUsersQueryError = AxiosError<unknown>



export function useGetApiWorkspaceUserListPendingUsers<TData = Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceUserListPendingUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserListPendingUsers>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceUserListPendingUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiWorkspaceUserProcessPendingUser = (
    params?: PostApiWorkspaceUserProcessPendingUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/WorkspaceUser/ProcessPendingUser`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiWorkspaceUserProcessPendingUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>, TError,{params?: PostApiWorkspaceUserProcessPendingUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>, TError,{params?: PostApiWorkspaceUserProcessPendingUserParams}, TContext> => {

const mutationKey = ['postApiWorkspaceUserProcessPendingUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>, {params?: PostApiWorkspaceUserProcessPendingUserParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiWorkspaceUserProcessPendingUser(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspaceUserProcessPendingUserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>>
    
    export type PostApiWorkspaceUserProcessPendingUserMutationError = AxiosError<unknown>

    export const usePostApiWorkspaceUserProcessPendingUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>, TError,{params?: PostApiWorkspaceUserProcessPendingUserParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspaceUserProcessPendingUser>>,
        TError,
        {params?: PostApiWorkspaceUserProcessPendingUserParams},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspaceUserProcessPendingUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiWorkspaceUserRequestPendingUser = (
    params?: PostApiWorkspaceUserRequestPendingUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/WorkspaceUser/RequestPendingUser`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiWorkspaceUserRequestPendingUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>, TError,{params?: PostApiWorkspaceUserRequestPendingUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>, TError,{params?: PostApiWorkspaceUserRequestPendingUserParams}, TContext> => {

const mutationKey = ['postApiWorkspaceUserRequestPendingUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>, {params?: PostApiWorkspaceUserRequestPendingUserParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiWorkspaceUserRequestPendingUser(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspaceUserRequestPendingUserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>>
    
    export type PostApiWorkspaceUserRequestPendingUserMutationError = AxiosError<unknown>

    export const usePostApiWorkspaceUserRequestPendingUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>, TError,{params?: PostApiWorkspaceUserRequestPendingUserParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspaceUserRequestPendingUser>>,
        TError,
        {params?: PostApiWorkspaceUserRequestPendingUserParams},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspaceUserRequestPendingUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiWorkspaceUserCheckPendingUser = (
    params?: GetApiWorkspaceUserCheckPendingUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.get(
      `/api/WorkspaceUser/CheckPendingUser`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiWorkspaceUserCheckPendingUserQueryKey = (params?: GetApiWorkspaceUserCheckPendingUserParams,) => {
    return [
    `/api/WorkspaceUser/CheckPendingUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspaceUserCheckPendingUserQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>, TError = AxiosError<unknown>>(params?: GetApiWorkspaceUserCheckPendingUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspaceUserCheckPendingUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>> = ({ signal }) => getApiWorkspaceUserCheckPendingUser(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiWorkspaceUserCheckPendingUserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>>
export type GetApiWorkspaceUserCheckPendingUserQueryError = AxiosError<unknown>



export function useGetApiWorkspaceUserCheckPendingUser<TData = Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>, TError = AxiosError<unknown>>(
 params?: GetApiWorkspaceUserCheckPendingUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaceUserCheckPendingUser>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiWorkspaceUserCheckPendingUserQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiNotificationLineRegisterNotificationSettingsId = (
    notificationSettingsId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/notification/line/register/${notificationSettingsId}`,undefined,options
    );
  }



export const getPostApiNotificationLineRegisterNotificationSettingsIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>, TError,{notificationSettingsId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>, TError,{notificationSettingsId: string}, TContext> => {

const mutationKey = ['postApiNotificationLineRegisterNotificationSettingsId'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>, {notificationSettingsId: string}> = (props) => {
          const {notificationSettingsId} = props ?? {};

          return  postApiNotificationLineRegisterNotificationSettingsId(notificationSettingsId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationLineRegisterNotificationSettingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>>
    
    export type PostApiNotificationLineRegisterNotificationSettingsIdMutationError = AxiosError<unknown>

    export const usePostApiNotificationLineRegisterNotificationSettingsId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>, TError,{notificationSettingsId: string}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationLineRegisterNotificationSettingsId>>,
        TError,
        {notificationSettingsId: string},
        TContext
      > => {

      const mutationOptions = getPostApiNotificationLineRegisterNotificationSettingsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiNotificationSettingsList = (
    params?: GetApiNotificationSettingsListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings[]>> => {
    
    
    return axios.get(
      `/api/NotificationSettings/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiNotificationSettingsListQueryKey = (params?: GetApiNotificationSettingsListParams,) => {
    return [
    `/api/NotificationSettings/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiNotificationSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotificationSettingsList>>, TError = AxiosError<unknown>>(params?: GetApiNotificationSettingsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotificationSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotificationSettingsList>>> = ({ signal }) => getApiNotificationSettingsList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiNotificationSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotificationSettingsList>>>
export type GetApiNotificationSettingsListQueryError = AxiosError<unknown>



export function useGetApiNotificationSettingsList<TData = Awaited<ReturnType<typeof getApiNotificationSettingsList>>, TError = AxiosError<unknown>>(
 params?: GetApiNotificationSettingsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiNotificationSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiNotificationSettingsGet = (
    params?: GetApiNotificationSettingsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    
    
    return axios.get(
      `/api/NotificationSettings/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiNotificationSettingsGetQueryKey = (params?: GetApiNotificationSettingsGetParams,) => {
    return [
    `/api/NotificationSettings/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiNotificationSettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotificationSettingsGet>>, TError = AxiosError<unknown>>(params?: GetApiNotificationSettingsGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotificationSettingsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotificationSettingsGet>>> = ({ signal }) => getApiNotificationSettingsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiNotificationSettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotificationSettingsGet>>>
export type GetApiNotificationSettingsGetQueryError = AxiosError<unknown>



export function useGetApiNotificationSettingsGet<TData = Awaited<ReturnType<typeof getApiNotificationSettingsGet>>, TError = AxiosError<unknown>>(
 params?: GetApiNotificationSettingsGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiNotificationSettingsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiNotificationSettingsCreate = (
    notificationSettings: NotificationSettings,
    params?: PostApiNotificationSettingsCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    
    
    return axios.post(
      `/api/NotificationSettings/Create`,
      notificationSettings,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiNotificationSettingsCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>, TError,{data: NotificationSettings;params?: PostApiNotificationSettingsCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>, TError,{data: NotificationSettings;params?: PostApiNotificationSettingsCreateParams}, TContext> => {

const mutationKey = ['postApiNotificationSettingsCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>, {data: NotificationSettings;params?: PostApiNotificationSettingsCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiNotificationSettingsCreate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationSettingsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>>
    export type PostApiNotificationSettingsCreateMutationBody = NotificationSettings
    export type PostApiNotificationSettingsCreateMutationError = AxiosError<unknown>

    export const usePostApiNotificationSettingsCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>, TError,{data: NotificationSettings;params?: PostApiNotificationSettingsCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationSettingsCreate>>,
        TError,
        {data: NotificationSettings;params?: PostApiNotificationSettingsCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiNotificationSettingsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiNotificationSettingsUpdate = (
    notificationSettings: NotificationSettings,
    params?: PutApiNotificationSettingsUpdateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/NotificationSettings/Update`,
      notificationSettings,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiNotificationSettingsUpdateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>, TError,{data: NotificationSettings;params?: PutApiNotificationSettingsUpdateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>, TError,{data: NotificationSettings;params?: PutApiNotificationSettingsUpdateParams}, TContext> => {

const mutationKey = ['putApiNotificationSettingsUpdate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>, {data: NotificationSettings;params?: PutApiNotificationSettingsUpdateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiNotificationSettingsUpdate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiNotificationSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>>
    export type PutApiNotificationSettingsUpdateMutationBody = NotificationSettings
    export type PutApiNotificationSettingsUpdateMutationError = AxiosError<unknown>

    export const usePutApiNotificationSettingsUpdate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>, TError,{data: NotificationSettings;params?: PutApiNotificationSettingsUpdateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiNotificationSettingsUpdate>>,
        TError,
        {data: NotificationSettings;params?: PutApiNotificationSettingsUpdateParams},
        TContext
      > => {

      const mutationOptions = getPutApiNotificationSettingsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiNotificationSettingsTest = (
    postApiNotificationSettingsTestBody: string,
    params?: PostApiNotificationSettingsTestParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/NotificationSettings/Test`,
      postApiNotificationSettingsTestBody,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiNotificationSettingsTestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsTest>>, TError,{data: string;params?: PostApiNotificationSettingsTestParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsTest>>, TError,{data: string;params?: PostApiNotificationSettingsTestParams}, TContext> => {

const mutationKey = ['postApiNotificationSettingsTest'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationSettingsTest>>, {data: string;params?: PostApiNotificationSettingsTestParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiNotificationSettingsTest(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationSettingsTestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationSettingsTest>>>
    export type PostApiNotificationSettingsTestMutationBody = string
    export type PostApiNotificationSettingsTestMutationError = AxiosError<unknown>

    export const usePostApiNotificationSettingsTest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsTest>>, TError,{data: string;params?: PostApiNotificationSettingsTestParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationSettingsTest>>,
        TError,
        {data: string;params?: PostApiNotificationSettingsTestParams},
        TContext
      > => {

      const mutationOptions = getPostApiNotificationSettingsTestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiNotificationSettingsDelete = (
    params?: PutApiNotificationSettingsDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/NotificationSettings/Delete`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiNotificationSettingsDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>, TError,{params?: PutApiNotificationSettingsDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>, TError,{params?: PutApiNotificationSettingsDeleteParams}, TContext> => {

const mutationKey = ['putApiNotificationSettingsDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>, {params?: PutApiNotificationSettingsDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiNotificationSettingsDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiNotificationSettingsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>>
    
    export type PutApiNotificationSettingsDeleteMutationError = AxiosError<unknown>

    export const usePutApiNotificationSettingsDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>, TError,{params?: PutApiNotificationSettingsDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiNotificationSettingsDelete>>,
        TError,
        {params?: PutApiNotificationSettingsDeleteParams},
        TContext
      > => {

      const mutationOptions = getPutApiNotificationSettingsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiNotificationSettingsExport = (
    params?: PostApiNotificationSettingsExportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    
    
    return axios.post(
      `/api/NotificationSettings/Export`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiNotificationSettingsExportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsExport>>, TError,{params?: PostApiNotificationSettingsExportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsExport>>, TError,{params?: PostApiNotificationSettingsExportParams}, TContext> => {

const mutationKey = ['postApiNotificationSettingsExport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationSettingsExport>>, {params?: PostApiNotificationSettingsExportParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiNotificationSettingsExport(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationSettingsExportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationSettingsExport>>>
    
    export type PostApiNotificationSettingsExportMutationError = AxiosError<unknown>

    export const usePostApiNotificationSettingsExport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsExport>>, TError,{params?: PostApiNotificationSettingsExportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationSettingsExport>>,
        TError,
        {params?: PostApiNotificationSettingsExportParams},
        TContext
      > => {

      const mutationOptions = getPostApiNotificationSettingsExportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiNotificationSettingsImport = (
    notificationSettingsImportModel: NotificationSettingsImportModel,
    params?: PostApiNotificationSettingsImportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    
    
    return axios.post(
      `/api/NotificationSettings/Import`,
      notificationSettingsImportModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiNotificationSettingsImportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsImport>>, TError,{data: NotificationSettingsImportModel;params?: PostApiNotificationSettingsImportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsImport>>, TError,{data: NotificationSettingsImportModel;params?: PostApiNotificationSettingsImportParams}, TContext> => {

const mutationKey = ['postApiNotificationSettingsImport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiNotificationSettingsImport>>, {data: NotificationSettingsImportModel;params?: PostApiNotificationSettingsImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiNotificationSettingsImport(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiNotificationSettingsImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiNotificationSettingsImport>>>
    export type PostApiNotificationSettingsImportMutationBody = NotificationSettingsImportModel
    export type PostApiNotificationSettingsImportMutationError = AxiosError<unknown>

    export const usePostApiNotificationSettingsImport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiNotificationSettingsImport>>, TError,{data: NotificationSettingsImportModel;params?: PostApiNotificationSettingsImportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiNotificationSettingsImport>>,
        TError,
        {data: NotificationSettingsImportModel;params?: PostApiNotificationSettingsImportParams},
        TContext
      > => {

      const mutationOptions = getPostApiNotificationSettingsImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiNotificationSettingsGetScheme = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettingsDataScheme>> => {
    
    
    return axios.get(
      `/api/NotificationSettings/GetScheme`,options
    );
  }




export const getGetApiNotificationSettingsGetSchemeQueryKey = () => {
    return [
    `/api/NotificationSettings/GetScheme`
    ] as const;
    }

    
export const getGetApiNotificationSettingsGetSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotificationSettingsGetSchemeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>> = ({ signal }) => getApiNotificationSettingsGetScheme({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiNotificationSettingsGetSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>>
export type GetApiNotificationSettingsGetSchemeQueryError = AxiosError<unknown>



export function useGetApiNotificationSettingsGetScheme<TData = Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiNotificationSettingsGetScheme>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiNotificationSettingsGetSchemeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiEvaluateTestSetJobList = (
    params?: GetApiEvaluateTestSetJobListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfEvaluateTestSetJob>> => {
    
    
    return axios.get(
      `/api/EvaluateTestSetJob/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEvaluateTestSetJobListQueryKey = (params?: GetApiEvaluateTestSetJobListParams,) => {
    return [
    `/api/EvaluateTestSetJob/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEvaluateTestSetJobListQueryOptions = <TData = Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>, TError = AxiosError<unknown>>(params?: GetApiEvaluateTestSetJobListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEvaluateTestSetJobListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>> = ({ signal }) => getApiEvaluateTestSetJobList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEvaluateTestSetJobListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>>
export type GetApiEvaluateTestSetJobListQueryError = AxiosError<unknown>



export function useGetApiEvaluateTestSetJobList<TData = Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>, TError = AxiosError<unknown>>(
 params?: GetApiEvaluateTestSetJobListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEvaluateTestSetJobListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiEvaluateTestSetJobGet = (
    params?: GetApiEvaluateTestSetJobGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EvaluateTestSetJob>> => {
    
    
    return axios.get(
      `/api/EvaluateTestSetJob/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiEvaluateTestSetJobGetQueryKey = (params?: GetApiEvaluateTestSetJobGetParams,) => {
    return [
    `/api/EvaluateTestSetJob/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiEvaluateTestSetJobGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>, TError = AxiosError<unknown>>(params?: GetApiEvaluateTestSetJobGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEvaluateTestSetJobGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>> = ({ signal }) => getApiEvaluateTestSetJobGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiEvaluateTestSetJobGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>>
export type GetApiEvaluateTestSetJobGetQueryError = AxiosError<unknown>



export function useGetApiEvaluateTestSetJobGet<TData = Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>, TError = AxiosError<unknown>>(
 params?: GetApiEvaluateTestSetJobGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiEvaluateTestSetJobGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiEvaluateTestSetJobGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiEvaluateTestSetJobCreate = (
    createEvaluateTestSetJobViewModel: CreateEvaluateTestSetJobViewModel,
    params?: PostApiEvaluateTestSetJobCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/EvaluateTestSetJob/Create`,
      createEvaluateTestSetJobViewModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEvaluateTestSetJobCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>, TError,{data: CreateEvaluateTestSetJobViewModel;params?: PostApiEvaluateTestSetJobCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>, TError,{data: CreateEvaluateTestSetJobViewModel;params?: PostApiEvaluateTestSetJobCreateParams}, TContext> => {

const mutationKey = ['postApiEvaluateTestSetJobCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>, {data: CreateEvaluateTestSetJobViewModel;params?: PostApiEvaluateTestSetJobCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiEvaluateTestSetJobCreate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEvaluateTestSetJobCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>>
    export type PostApiEvaluateTestSetJobCreateMutationBody = CreateEvaluateTestSetJobViewModel
    export type PostApiEvaluateTestSetJobCreateMutationError = AxiosError<unknown>

    export const usePostApiEvaluateTestSetJobCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>, TError,{data: CreateEvaluateTestSetJobViewModel;params?: PostApiEvaluateTestSetJobCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEvaluateTestSetJobCreate>>,
        TError,
        {data: CreateEvaluateTestSetJobViewModel;params?: PostApiEvaluateTestSetJobCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiEvaluateTestSetJobCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiEvaluateTestSetJobRequeue = (
    params?: PostApiEvaluateTestSetJobRequeueParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/EvaluateTestSetJob/Requeue`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiEvaluateTestSetJobRequeueMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>, TError,{params?: PostApiEvaluateTestSetJobRequeueParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>, TError,{params?: PostApiEvaluateTestSetJobRequeueParams}, TContext> => {

const mutationKey = ['postApiEvaluateTestSetJobRequeue'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>, {params?: PostApiEvaluateTestSetJobRequeueParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiEvaluateTestSetJobRequeue(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiEvaluateTestSetJobRequeueMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>>
    
    export type PostApiEvaluateTestSetJobRequeueMutationError = AxiosError<unknown>

    export const usePostApiEvaluateTestSetJobRequeue = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>, TError,{params?: PostApiEvaluateTestSetJobRequeueParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiEvaluateTestSetJobRequeue>>,
        TError,
        {params?: PostApiEvaluateTestSetJobRequeueParams},
        TContext
      > => {

      const mutationOptions = getPostApiEvaluateTestSetJobRequeueMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiEvaluateTestSetJobDelete = (
    params?: DeleteApiEvaluateTestSetJobDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/EvaluateTestSetJob/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiEvaluateTestSetJobDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>, TError,{params?: DeleteApiEvaluateTestSetJobDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>, TError,{params?: DeleteApiEvaluateTestSetJobDeleteParams}, TContext> => {

const mutationKey = ['deleteApiEvaluateTestSetJobDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>, {params?: DeleteApiEvaluateTestSetJobDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiEvaluateTestSetJobDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiEvaluateTestSetJobDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>>
    
    export type DeleteApiEvaluateTestSetJobDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiEvaluateTestSetJobDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>, TError,{params?: DeleteApiEvaluateTestSetJobDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiEvaluateTestSetJobDelete>>,
        TError,
        {params?: DeleteApiEvaluateTestSetJobDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiEvaluateTestSetJobDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiGenerateTestSetJobList = (
    params?: GetApiGenerateTestSetJobListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfGenerateTestSetJob>> => {
    
    
    return axios.get(
      `/api/GenerateTestSetJob/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiGenerateTestSetJobListQueryKey = (params?: GetApiGenerateTestSetJobListParams,) => {
    return [
    `/api/GenerateTestSetJob/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiGenerateTestSetJobListQueryOptions = <TData = Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>, TError = AxiosError<unknown>>(params?: GetApiGenerateTestSetJobListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGenerateTestSetJobListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>> = ({ signal }) => getApiGenerateTestSetJobList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGenerateTestSetJobListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>>
export type GetApiGenerateTestSetJobListQueryError = AxiosError<unknown>



export function useGetApiGenerateTestSetJobList<TData = Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>, TError = AxiosError<unknown>>(
 params?: GetApiGenerateTestSetJobListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGenerateTestSetJobListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiGenerateTestSetJobGet = (
    params?: GetApiGenerateTestSetJobGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GenerateTestSetJob>> => {
    
    
    return axios.get(
      `/api/GenerateTestSetJob/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiGenerateTestSetJobGetQueryKey = (params?: GetApiGenerateTestSetJobGetParams,) => {
    return [
    `/api/GenerateTestSetJob/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiGenerateTestSetJobGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>, TError = AxiosError<unknown>>(params?: GetApiGenerateTestSetJobGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGenerateTestSetJobGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>> = ({ signal }) => getApiGenerateTestSetJobGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGenerateTestSetJobGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>>
export type GetApiGenerateTestSetJobGetQueryError = AxiosError<unknown>



export function useGetApiGenerateTestSetJobGet<TData = Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>, TError = AxiosError<unknown>>(
 params?: GetApiGenerateTestSetJobGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiGenerateTestSetJobGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiGenerateTestSetJobGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiGenerateTestSetJobPreview = (
    createGenerateTestSetJobViewModel: CreateGenerateTestSetJobViewModel,
    params?: PostApiGenerateTestSetJobPreviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GenerateTestSetJobPreviewViewModel>> => {
    
    
    return axios.post(
      `/api/GenerateTestSetJob/Preview`,
      createGenerateTestSetJobViewModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiGenerateTestSetJobPreviewMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobPreviewParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobPreviewParams}, TContext> => {

const mutationKey = ['postApiGenerateTestSetJobPreview'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>, {data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobPreviewParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiGenerateTestSetJobPreview(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGenerateTestSetJobPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>>
    export type PostApiGenerateTestSetJobPreviewMutationBody = CreateGenerateTestSetJobViewModel
    export type PostApiGenerateTestSetJobPreviewMutationError = AxiosError<unknown>

    export const usePostApiGenerateTestSetJobPreview = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobPreviewParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGenerateTestSetJobPreview>>,
        TError,
        {data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobPreviewParams},
        TContext
      > => {

      const mutationOptions = getPostApiGenerateTestSetJobPreviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiGenerateTestSetJobCreate = (
    createGenerateTestSetJobViewModel: CreateGenerateTestSetJobViewModel,
    params?: PostApiGenerateTestSetJobCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/GenerateTestSetJob/Create`,
      createGenerateTestSetJobViewModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiGenerateTestSetJobCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobCreateParams}, TContext> => {

const mutationKey = ['postApiGenerateTestSetJobCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>, {data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiGenerateTestSetJobCreate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGenerateTestSetJobCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>>
    export type PostApiGenerateTestSetJobCreateMutationBody = CreateGenerateTestSetJobViewModel
    export type PostApiGenerateTestSetJobCreateMutationError = AxiosError<unknown>

    export const usePostApiGenerateTestSetJobCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>, TError,{data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGenerateTestSetJobCreate>>,
        TError,
        {data: CreateGenerateTestSetJobViewModel;params?: PostApiGenerateTestSetJobCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiGenerateTestSetJobCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiGenerateTestSetJobRequeue = (
    params?: PostApiGenerateTestSetJobRequeueParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/GenerateTestSetJob/Requeue`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiGenerateTestSetJobRequeueMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>, TError,{params?: PostApiGenerateTestSetJobRequeueParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>, TError,{params?: PostApiGenerateTestSetJobRequeueParams}, TContext> => {

const mutationKey = ['postApiGenerateTestSetJobRequeue'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>, {params?: PostApiGenerateTestSetJobRequeueParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiGenerateTestSetJobRequeue(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGenerateTestSetJobRequeueMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>>
    
    export type PostApiGenerateTestSetJobRequeueMutationError = AxiosError<unknown>

    export const usePostApiGenerateTestSetJobRequeue = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>, TError,{params?: PostApiGenerateTestSetJobRequeueParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiGenerateTestSetJobRequeue>>,
        TError,
        {params?: PostApiGenerateTestSetJobRequeueParams},
        TContext
      > => {

      const mutationOptions = getPostApiGenerateTestSetJobRequeueMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiGenerateTestSetJobDelete = (
    params?: DeleteApiGenerateTestSetJobDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/GenerateTestSetJob/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiGenerateTestSetJobDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>, TError,{params?: DeleteApiGenerateTestSetJobDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>, TError,{params?: DeleteApiGenerateTestSetJobDeleteParams}, TContext> => {

const mutationKey = ['deleteApiGenerateTestSetJobDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>, {params?: DeleteApiGenerateTestSetJobDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiGenerateTestSetJobDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGenerateTestSetJobDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>>
    
    export type DeleteApiGenerateTestSetJobDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiGenerateTestSetJobDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>, TError,{params?: DeleteApiGenerateTestSetJobDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGenerateTestSetJobDelete>>,
        TError,
        {params?: DeleteApiGenerateTestSetJobDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiGenerateTestSetJobDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatEvaluationTestList = (
    params?: GetApiChatEvaluationTestListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatEvaluationTestBase>> => {
    
    
    return axios.get(
      `/api/ChatEvaluationTest/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatEvaluationTestListQueryKey = (params?: GetApiChatEvaluationTestListParams,) => {
    return [
    `/api/ChatEvaluationTest/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatEvaluationTestListQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatEvaluationTestList>>, TError = AxiosError<unknown>>(params?: GetApiChatEvaluationTestListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatEvaluationTestListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatEvaluationTestList>>> = ({ signal }) => getApiChatEvaluationTestList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatEvaluationTestListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatEvaluationTestList>>>
export type GetApiChatEvaluationTestListQueryError = AxiosError<unknown>



export function useGetApiChatEvaluationTestList<TData = Awaited<ReturnType<typeof getApiChatEvaluationTestList>>, TError = AxiosError<unknown>>(
 params?: GetApiChatEvaluationTestListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatEvaluationTestListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatEvaluationTestGet = (
    params?: GetApiChatEvaluationTestGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatEvaluationTest>> => {
    
    
    return axios.get(
      `/api/ChatEvaluationTest/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatEvaluationTestGetQueryKey = (params?: GetApiChatEvaluationTestGetParams,) => {
    return [
    `/api/ChatEvaluationTest/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatEvaluationTestGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>, TError = AxiosError<unknown>>(params?: GetApiChatEvaluationTestGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatEvaluationTestGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>> = ({ signal }) => getApiChatEvaluationTestGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatEvaluationTestGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>>
export type GetApiChatEvaluationTestGetQueryError = AxiosError<unknown>



export function useGetApiChatEvaluationTestGet<TData = Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>, TError = AxiosError<unknown>>(
 params?: GetApiChatEvaluationTestGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatEvaluationTestGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiChatEvaluationTestRename = (
    params?: PutApiChatEvaluationTestRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatEvaluationTest/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatEvaluationTestRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>, TError,{params?: PutApiChatEvaluationTestRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>, TError,{params?: PutApiChatEvaluationTestRenameParams}, TContext> => {

const mutationKey = ['putApiChatEvaluationTestRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>, {params?: PutApiChatEvaluationTestRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiChatEvaluationTestRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatEvaluationTestRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>>
    
    export type PutApiChatEvaluationTestRenameMutationError = AxiosError<unknown>

    export const usePutApiChatEvaluationTestRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>, TError,{params?: PutApiChatEvaluationTestRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatEvaluationTestRename>>,
        TError,
        {params?: PutApiChatEvaluationTestRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatEvaluationTestRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatEvaluationTestDelete = (
    params?: PutApiChatEvaluationTestDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatEvaluationTest/Delete`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatEvaluationTestDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>, TError,{params?: PutApiChatEvaluationTestDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>, TError,{params?: PutApiChatEvaluationTestDeleteParams}, TContext> => {

const mutationKey = ['putApiChatEvaluationTestDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>, {params?: PutApiChatEvaluationTestDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiChatEvaluationTestDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatEvaluationTestDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>>
    
    export type PutApiChatEvaluationTestDeleteMutationError = AxiosError<unknown>

    export const usePutApiChatEvaluationTestDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>, TError,{params?: PutApiChatEvaluationTestDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatEvaluationTestDelete>>,
        TError,
        {params?: PutApiChatEvaluationTestDeleteParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatEvaluationTestDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatEvaluationTestEvaluate = (
    rAGEvaluationSample: RAGEvaluationSample[],
    params?: PostApiChatEvaluationTestEvaluateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostApiChatEvaluationTestEvaluate200OneItem[] | PostApiChatEvaluationTestEvaluate200TwoItem[] | PostApiChatEvaluationTestEvaluate200ThreeItem[]>> => {
    
    
    return axios.post(
      `/api/ChatEvaluationTest/Evaluate`,
      rAGEvaluationSample,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatEvaluationTestEvaluateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>, TError,{data: RAGEvaluationSample[];params?: PostApiChatEvaluationTestEvaluateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>, TError,{data: RAGEvaluationSample[];params?: PostApiChatEvaluationTestEvaluateParams}, TContext> => {

const mutationKey = ['postApiChatEvaluationTestEvaluate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>, {data: RAGEvaluationSample[];params?: PostApiChatEvaluationTestEvaluateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatEvaluationTestEvaluate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatEvaluationTestEvaluateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>>
    export type PostApiChatEvaluationTestEvaluateMutationBody = RAGEvaluationSample[]
    export type PostApiChatEvaluationTestEvaluateMutationError = AxiosError<unknown>

    export const usePostApiChatEvaluationTestEvaluate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>, TError,{data: RAGEvaluationSample[];params?: PostApiChatEvaluationTestEvaluateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatEvaluationTestEvaluate>>,
        TError,
        {data: RAGEvaluationSample[];params?: PostApiChatEvaluationTestEvaluateParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatEvaluationTestEvaluateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatEvaluationTestSetList = (
    params?: GetApiChatEvaluationTestSetListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatEvaluationTestSetBase>> => {
    
    
    return axios.get(
      `/api/ChatEvaluationTestSet/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatEvaluationTestSetListQueryKey = (params?: GetApiChatEvaluationTestSetListParams,) => {
    return [
    `/api/ChatEvaluationTestSet/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatEvaluationTestSetListQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>, TError = AxiosError<unknown>>(params?: GetApiChatEvaluationTestSetListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatEvaluationTestSetListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>> = ({ signal }) => getApiChatEvaluationTestSetList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatEvaluationTestSetListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>>
export type GetApiChatEvaluationTestSetListQueryError = AxiosError<unknown>



export function useGetApiChatEvaluationTestSetList<TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>, TError = AxiosError<unknown>>(
 params?: GetApiChatEvaluationTestSetListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatEvaluationTestSetListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiChatEvaluationTestSetGet = (
    params?: GetApiChatEvaluationTestSetGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatEvaluationTestSet>> => {
    
    
    return axios.get(
      `/api/ChatEvaluationTestSet/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatEvaluationTestSetGetQueryKey = (params?: GetApiChatEvaluationTestSetGetParams,) => {
    return [
    `/api/ChatEvaluationTestSet/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatEvaluationTestSetGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>, TError = AxiosError<unknown>>(params?: GetApiChatEvaluationTestSetGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatEvaluationTestSetGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>> = ({ signal }) => getApiChatEvaluationTestSetGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatEvaluationTestSetGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>>
export type GetApiChatEvaluationTestSetGetQueryError = AxiosError<unknown>



export function useGetApiChatEvaluationTestSetGet<TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>, TError = AxiosError<unknown>>(
 params?: GetApiChatEvaluationTestSetGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatEvaluationTestSetGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiChatEvaluationTestSetCreate = (
    params?: PostApiChatEvaluationTestSetCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatEvaluationTestSet>> => {
    
    
    return axios.post(
      `/api/ChatEvaluationTestSet/Create`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatEvaluationTestSetCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>, TError,{params?: PostApiChatEvaluationTestSetCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>, TError,{params?: PostApiChatEvaluationTestSetCreateParams}, TContext> => {

const mutationKey = ['postApiChatEvaluationTestSetCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>, {params?: PostApiChatEvaluationTestSetCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiChatEvaluationTestSetCreate(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatEvaluationTestSetCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>>
    
    export type PostApiChatEvaluationTestSetCreateMutationError = AxiosError<unknown>

    export const usePostApiChatEvaluationTestSetCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>, TError,{params?: PostApiChatEvaluationTestSetCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatEvaluationTestSetCreate>>,
        TError,
        {params?: PostApiChatEvaluationTestSetCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatEvaluationTestSetCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatEvaluationTestSetRename = (
    params?: PutApiChatEvaluationTestSetRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatEvaluationTestSet/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatEvaluationTestSetRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>, TError,{params?: PutApiChatEvaluationTestSetRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>, TError,{params?: PutApiChatEvaluationTestSetRenameParams}, TContext> => {

const mutationKey = ['putApiChatEvaluationTestSetRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>, {params?: PutApiChatEvaluationTestSetRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiChatEvaluationTestSetRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatEvaluationTestSetRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>>
    
    export type PutApiChatEvaluationTestSetRenameMutationError = AxiosError<unknown>

    export const usePutApiChatEvaluationTestSetRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>, TError,{params?: PutApiChatEvaluationTestSetRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatEvaluationTestSetRename>>,
        TError,
        {params?: PutApiChatEvaluationTestSetRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatEvaluationTestSetRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatEvaluationTestSetAddSamples = (
    chatEvaluationTestSetSample: ChatEvaluationTestSetSample[],
    params?: PostApiChatEvaluationTestSetAddSamplesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatEvaluationTestSet/AddSamples`,
      chatEvaluationTestSetSample,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatEvaluationTestSetAddSamplesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>, TError,{data: ChatEvaluationTestSetSample[];params?: PostApiChatEvaluationTestSetAddSamplesParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>, TError,{data: ChatEvaluationTestSetSample[];params?: PostApiChatEvaluationTestSetAddSamplesParams}, TContext> => {

const mutationKey = ['postApiChatEvaluationTestSetAddSamples'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>, {data: ChatEvaluationTestSetSample[];params?: PostApiChatEvaluationTestSetAddSamplesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatEvaluationTestSetAddSamples(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatEvaluationTestSetAddSamplesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>>
    export type PostApiChatEvaluationTestSetAddSamplesMutationBody = ChatEvaluationTestSetSample[]
    export type PostApiChatEvaluationTestSetAddSamplesMutationError = AxiosError<unknown>

    export const usePostApiChatEvaluationTestSetAddSamples = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>, TError,{data: ChatEvaluationTestSetSample[];params?: PostApiChatEvaluationTestSetAddSamplesParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatEvaluationTestSetAddSamples>>,
        TError,
        {data: ChatEvaluationTestSetSample[];params?: PostApiChatEvaluationTestSetAddSamplesParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatEvaluationTestSetAddSamplesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiChatEvaluationTestSetUpdateSample = (
    chatEvaluationTestSetSample: ChatEvaluationTestSetSample,
    params?: PostApiChatEvaluationTestSetUpdateSampleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/ChatEvaluationTestSet/UpdateSample`,
      chatEvaluationTestSetSample,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatEvaluationTestSetUpdateSampleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>, TError,{data: ChatEvaluationTestSetSample;params?: PostApiChatEvaluationTestSetUpdateSampleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>, TError,{data: ChatEvaluationTestSetSample;params?: PostApiChatEvaluationTestSetUpdateSampleParams}, TContext> => {

const mutationKey = ['postApiChatEvaluationTestSetUpdateSample'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>, {data: ChatEvaluationTestSetSample;params?: PostApiChatEvaluationTestSetUpdateSampleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatEvaluationTestSetUpdateSample(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatEvaluationTestSetUpdateSampleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>>
    export type PostApiChatEvaluationTestSetUpdateSampleMutationBody = ChatEvaluationTestSetSample
    export type PostApiChatEvaluationTestSetUpdateSampleMutationError = AxiosError<unknown>

    export const usePostApiChatEvaluationTestSetUpdateSample = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>, TError,{data: ChatEvaluationTestSetSample;params?: PostApiChatEvaluationTestSetUpdateSampleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatEvaluationTestSetUpdateSample>>,
        TError,
        {data: ChatEvaluationTestSetSample;params?: PostApiChatEvaluationTestSetUpdateSampleParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatEvaluationTestSetUpdateSampleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiChatEvaluationTestSetDeleteSamples = (
    deleteApiChatEvaluationTestSetDeleteSamplesBody: string[],
    params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/ChatEvaluationTestSet/DeleteSamples`,{data:
      deleteApiChatEvaluationTestSetDeleteSamplesBody, 
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiChatEvaluationTestSetDeleteSamplesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>, TError,{data: string[];params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>, TError,{data: string[];params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams}, TContext> => {

const mutationKey = ['deleteApiChatEvaluationTestSetDeleteSamples'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>, {data: string[];params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteApiChatEvaluationTestSetDeleteSamples(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiChatEvaluationTestSetDeleteSamplesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>>
    export type DeleteApiChatEvaluationTestSetDeleteSamplesMutationBody = string[]
    export type DeleteApiChatEvaluationTestSetDeleteSamplesMutationError = AxiosError<unknown>

    export const useDeleteApiChatEvaluationTestSetDeleteSamples = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>, TError,{data: string[];params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiChatEvaluationTestSetDeleteSamples>>,
        TError,
        {data: string[];params?: DeleteApiChatEvaluationTestSetDeleteSamplesParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiChatEvaluationTestSetDeleteSamplesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiChatEvaluationTestSetDelete = (
    params?: PutApiChatEvaluationTestSetDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/ChatEvaluationTestSet/Delete`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiChatEvaluationTestSetDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>, TError,{params?: PutApiChatEvaluationTestSetDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>, TError,{params?: PutApiChatEvaluationTestSetDeleteParams}, TContext> => {

const mutationKey = ['putApiChatEvaluationTestSetDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>, {params?: PutApiChatEvaluationTestSetDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiChatEvaluationTestSetDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiChatEvaluationTestSetDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>>
    
    export type PutApiChatEvaluationTestSetDeleteMutationError = AxiosError<unknown>

    export const usePutApiChatEvaluationTestSetDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>, TError,{params?: PutApiChatEvaluationTestSetDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiChatEvaluationTestSetDelete>>,
        TError,
        {params?: PutApiChatEvaluationTestSetDeleteParams},
        TContext
      > => {

      const mutationOptions = getPutApiChatEvaluationTestSetDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiChatEvaluationTestSetExport = (
    params?: GetApiChatEvaluationTestSetExportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/ChatEvaluationTestSet/Export`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiChatEvaluationTestSetExportQueryKey = (params?: GetApiChatEvaluationTestSetExportParams,) => {
    return [
    `/api/ChatEvaluationTestSet/Export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiChatEvaluationTestSetExportQueryOptions = <TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>, TError = AxiosError<unknown>>(params?: GetApiChatEvaluationTestSetExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChatEvaluationTestSetExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>> = ({ signal }) => getApiChatEvaluationTestSetExport(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiChatEvaluationTestSetExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>>
export type GetApiChatEvaluationTestSetExportQueryError = AxiosError<unknown>



export function useGetApiChatEvaluationTestSetExport<TData = Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>, TError = AxiosError<unknown>>(
 params?: GetApiChatEvaluationTestSetExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiChatEvaluationTestSetExport>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiChatEvaluationTestSetExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiChatEvaluationTestSetImport = (
    postApiChatEvaluationTestSetImportBody: PostApiChatEvaluationTestSetImportBody,
    params?: PostApiChatEvaluationTestSetImportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiChatEvaluationTestSetImportBody.file !== undefined) {
 formData.append(`file`, postApiChatEvaluationTestSetImportBody.file)
 }

    return axios.post(
      `/api/ChatEvaluationTestSet/Import`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiChatEvaluationTestSetImportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>, TError,{data: PostApiChatEvaluationTestSetImportBody;params?: PostApiChatEvaluationTestSetImportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>, TError,{data: PostApiChatEvaluationTestSetImportBody;params?: PostApiChatEvaluationTestSetImportParams}, TContext> => {

const mutationKey = ['postApiChatEvaluationTestSetImport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>, {data: PostApiChatEvaluationTestSetImportBody;params?: PostApiChatEvaluationTestSetImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiChatEvaluationTestSetImport(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatEvaluationTestSetImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>>
    export type PostApiChatEvaluationTestSetImportMutationBody = PostApiChatEvaluationTestSetImportBody
    export type PostApiChatEvaluationTestSetImportMutationError = AxiosError<unknown>

    export const usePostApiChatEvaluationTestSetImport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>, TError,{data: PostApiChatEvaluationTestSetImportBody;params?: PostApiChatEvaluationTestSetImportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatEvaluationTestSetImport>>,
        TError,
        {data: PostApiChatEvaluationTestSetImportBody;params?: PostApiChatEvaluationTestSetImportParams},
        TContext
      > => {

      const mutationOptions = getPostApiChatEvaluationTestSetImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderActionsSend = (
    chatMessage: ChatMessage,
    params?: PostApiBotProviderActionsSendParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/BotProviderActions/Send`,
      chatMessage,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderActionsSendMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderActionsSend>>, TError,{data: ChatMessage;params?: PostApiBotProviderActionsSendParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderActionsSend>>, TError,{data: ChatMessage;params?: PostApiBotProviderActionsSendParams}, TContext> => {

const mutationKey = ['postApiBotProviderActionsSend'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderActionsSend>>, {data: ChatMessage;params?: PostApiBotProviderActionsSendParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderActionsSend(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderActionsSendMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderActionsSend>>>
    export type PostApiBotProviderActionsSendMutationBody = ChatMessage
    export type PostApiBotProviderActionsSendMutationError = AxiosError<unknown>

    export const usePostApiBotProviderActionsSend = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderActionsSend>>, TError,{data: ChatMessage;params?: PostApiBotProviderActionsSendParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderActionsSend>>,
        TError,
        {data: ChatMessage;params?: PostApiBotProviderActionsSendParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderActionsSendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderActionsGetUserProfile = (
    params?: GetApiBotProviderActionsGetUserProfileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserProfile>> => {
    
    
    return axios.get(
      `/api/BotProviderActions/GetUserProfile`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderActionsGetUserProfileQueryKey = (params?: GetApiBotProviderActionsGetUserProfileParams,) => {
    return [
    `/api/BotProviderActions/GetUserProfile`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderActionsGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderActionsGetUserProfileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderActionsGetUserProfileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>> = ({ signal }) => getApiBotProviderActionsGetUserProfile(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderActionsGetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>>
export type GetApiBotProviderActionsGetUserProfileQueryError = AxiosError<unknown>



export function useGetApiBotProviderActionsGetUserProfile<TData = Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderActionsGetUserProfileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderActionsGetUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderActionsGetUserProfileQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiBotProviderActionsDeleteHistory = (
    params?: DeleteApiBotProviderActionsDeleteHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderActions/DeleteHistory`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderActionsDeleteHistoryMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>, TError,{params?: DeleteApiBotProviderActionsDeleteHistoryParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>, TError,{params?: DeleteApiBotProviderActionsDeleteHistoryParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderActionsDeleteHistory'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>, {params?: DeleteApiBotProviderActionsDeleteHistoryParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderActionsDeleteHistory(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderActionsDeleteHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>>
    
    export type DeleteApiBotProviderActionsDeleteHistoryMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderActionsDeleteHistory = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>, TError,{params?: DeleteApiBotProviderActionsDeleteHistoryParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderActionsDeleteHistory>>,
        TError,
        {params?: DeleteApiBotProviderActionsDeleteHistoryParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderActionsDeleteHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleCreateEmptyBundle = (
    createBundleRequest: CreateBundleRequest,
    params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/CreateEmptyBundle`,
      createBundleRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleCreateEmptyBundleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>, TError,{data: CreateBundleRequest;params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>, TError,{data: CreateBundleRequest;params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleCreateEmptyBundle'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>, {data: CreateBundleRequest;params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleCreateEmptyBundle(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleCreateEmptyBundleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>>
    export type PostApiBotProviderAssetBundleCreateEmptyBundleMutationBody = CreateBundleRequest
    export type PostApiBotProviderAssetBundleCreateEmptyBundleMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleCreateEmptyBundle = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>, TError,{data: CreateBundleRequest;params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateEmptyBundle>>,
        TError,
        {data: CreateBundleRequest;params?: PostApiBotProviderAssetBundleCreateEmptyBundleParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleCreateEmptyBundleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleUploadFile = (
    postApiBotProviderAssetBundleUploadFileBody: PostApiBotProviderAssetBundleUploadFileBody,
    params?: PostApiBotProviderAssetBundleUploadFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    const formData = new FormData();
if(postApiBotProviderAssetBundleUploadFileBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderAssetBundleUploadFileBody.file)
 }

    return axios.post(
      `/api/BotProviderAssetBundle/UploadFile`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleUploadFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>, TError,{data: PostApiBotProviderAssetBundleUploadFileBody;params?: PostApiBotProviderAssetBundleUploadFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>, TError,{data: PostApiBotProviderAssetBundleUploadFileBody;params?: PostApiBotProviderAssetBundleUploadFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleUploadFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>, {data: PostApiBotProviderAssetBundleUploadFileBody;params?: PostApiBotProviderAssetBundleUploadFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleUploadFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>>
    export type PostApiBotProviderAssetBundleUploadFileMutationBody = PostApiBotProviderAssetBundleUploadFileBody
    export type PostApiBotProviderAssetBundleUploadFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleUploadFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>, TError,{data: PostApiBotProviderAssetBundleUploadFileBody;params?: PostApiBotProviderAssetBundleUploadFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadFile>>,
        TError,
        {data: PostApiBotProviderAssetBundleUploadFileBody;params?: PostApiBotProviderAssetBundleUploadFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderAssetBundleDeleteFile = (
    params?: DeleteApiBotProviderAssetBundleDeleteFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.delete(
      `/api/BotProviderAssetBundle/DeleteFile`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderAssetBundleDeleteFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFileParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderAssetBundleDeleteFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>, {params?: DeleteApiBotProviderAssetBundleDeleteFileParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderAssetBundleDeleteFile(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderAssetBundleDeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>>
    
    export type DeleteApiBotProviderAssetBundleDeleteFileMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderAssetBundleDeleteFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFile>>,
        TError,
        {params?: DeleteApiBotProviderAssetBundleDeleteFileParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderAssetBundleDeleteFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleCreateFolder = (
    createFolderRequest: CreateFolderRequest,
    params?: PostApiBotProviderAssetBundleCreateFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/CreateFolder`,
      createFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleCreateFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>, TError,{data: CreateFolderRequest;params?: PostApiBotProviderAssetBundleCreateFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>, TError,{data: CreateFolderRequest;params?: PostApiBotProviderAssetBundleCreateFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleCreateFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>, {data: CreateFolderRequest;params?: PostApiBotProviderAssetBundleCreateFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleCreateFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleCreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>>
    export type PostApiBotProviderAssetBundleCreateFolderMutationBody = CreateFolderRequest
    export type PostApiBotProviderAssetBundleCreateFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleCreateFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>, TError,{data: CreateFolderRequest;params?: PostApiBotProviderAssetBundleCreateFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleCreateFolder>>,
        TError,
        {data: CreateFolderRequest;params?: PostApiBotProviderAssetBundleCreateFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleCreateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderAssetBundleDeleteFolder = (
    params?: DeleteApiBotProviderAssetBundleDeleteFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.delete(
      `/api/BotProviderAssetBundle/DeleteFolder`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderAssetBundleDeleteFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFolderParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderAssetBundleDeleteFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>, {params?: DeleteApiBotProviderAssetBundleDeleteFolderParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderAssetBundleDeleteFolder(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderAssetBundleDeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>>
    
    export type DeleteApiBotProviderAssetBundleDeleteFolderMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderAssetBundleDeleteFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteFolder>>,
        TError,
        {params?: DeleteApiBotProviderAssetBundleDeleteFolderParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderAssetBundleDeleteFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiBotProviderAssetBundleSaveTextFile = (
    saveTextFileRequest: SaveTextFileRequest,
    params?: PutApiBotProviderAssetBundleSaveTextFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/BotProviderAssetBundle/SaveTextFile`,
      saveTextFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiBotProviderAssetBundleSaveTextFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>, TError,{data: SaveTextFileRequest;params?: PutApiBotProviderAssetBundleSaveTextFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>, TError,{data: SaveTextFileRequest;params?: PutApiBotProviderAssetBundleSaveTextFileParams}, TContext> => {

const mutationKey = ['putApiBotProviderAssetBundleSaveTextFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>, {data: SaveTextFileRequest;params?: PutApiBotProviderAssetBundleSaveTextFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiBotProviderAssetBundleSaveTextFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiBotProviderAssetBundleSaveTextFileMutationResult = NonNullable<Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>>
    export type PutApiBotProviderAssetBundleSaveTextFileMutationBody = SaveTextFileRequest
    export type PutApiBotProviderAssetBundleSaveTextFileMutationError = AxiosError<unknown>

    export const usePutApiBotProviderAssetBundleSaveTextFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>, TError,{data: SaveTextFileRequest;params?: PutApiBotProviderAssetBundleSaveTextFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiBotProviderAssetBundleSaveTextFile>>,
        TError,
        {data: SaveTextFileRequest;params?: PutApiBotProviderAssetBundleSaveTextFileParams},
        TContext
      > => {

      const mutationOptions = getPutApiBotProviderAssetBundleSaveTextFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderAssetBundleDownloadZip = (
    params?: GetApiBotProviderAssetBundleDownloadZipParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/BotProviderAssetBundle/DownloadZip`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderAssetBundleDownloadZipQueryKey = (params?: GetApiBotProviderAssetBundleDownloadZipParams,) => {
    return [
    `/api/BotProviderAssetBundle/DownloadZip`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderAssetBundleDownloadZipQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderAssetBundleDownloadZipParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderAssetBundleDownloadZipQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>> = ({ signal }) => getApiBotProviderAssetBundleDownloadZip(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderAssetBundleDownloadZipQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>>
export type GetApiBotProviderAssetBundleDownloadZipQueryError = AxiosError<unknown>



export function useGetApiBotProviderAssetBundleDownloadZip<TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderAssetBundleDownloadZipParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleDownloadZip>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderAssetBundleDownloadZipQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiBotProviderAssetBundleUploadZip = (
    postApiBotProviderAssetBundleUploadZipBody: PostApiBotProviderAssetBundleUploadZipBody,
    params?: PostApiBotProviderAssetBundleUploadZipParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    const formData = new FormData();
if(postApiBotProviderAssetBundleUploadZipBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderAssetBundleUploadZipBody.file)
 }

    return axios.post(
      `/api/BotProviderAssetBundle/UploadZip`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleUploadZipMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>, TError,{data: PostApiBotProviderAssetBundleUploadZipBody;params?: PostApiBotProviderAssetBundleUploadZipParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>, TError,{data: PostApiBotProviderAssetBundleUploadZipBody;params?: PostApiBotProviderAssetBundleUploadZipParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleUploadZip'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>, {data: PostApiBotProviderAssetBundleUploadZipBody;params?: PostApiBotProviderAssetBundleUploadZipParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleUploadZip(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleUploadZipMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>>
    export type PostApiBotProviderAssetBundleUploadZipMutationBody = PostApiBotProviderAssetBundleUploadZipBody
    export type PostApiBotProviderAssetBundleUploadZipMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleUploadZip = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>, TError,{data: PostApiBotProviderAssetBundleUploadZipBody;params?: PostApiBotProviderAssetBundleUploadZipParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleUploadZip>>,
        TError,
        {data: PostApiBotProviderAssetBundleUploadZipBody;params?: PostApiBotProviderAssetBundleUploadZipParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleUploadZipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderAssetBundleListBundles = (
    params?: GetApiBotProviderAssetBundleListBundlesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem[]>> => {
    
    
    return axios.get(
      `/api/BotProviderAssetBundle/ListBundles`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderAssetBundleListBundlesQueryKey = (params?: GetApiBotProviderAssetBundleListBundlesParams,) => {
    return [
    `/api/BotProviderAssetBundle/ListBundles`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderAssetBundleListBundlesQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderAssetBundleListBundlesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderAssetBundleListBundlesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>> = ({ signal }) => getApiBotProviderAssetBundleListBundles(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderAssetBundleListBundlesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>>
export type GetApiBotProviderAssetBundleListBundlesQueryError = AxiosError<unknown>



export function useGetApiBotProviderAssetBundleListBundles<TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderAssetBundleListBundlesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleListBundles>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderAssetBundleListBundlesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderAssetBundleGetFile = (
    params?: GetApiBotProviderAssetBundleGetFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/BotProviderAssetBundle/GetFile`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderAssetBundleGetFileQueryKey = (params?: GetApiBotProviderAssetBundleGetFileParams,) => {
    return [
    `/api/BotProviderAssetBundle/GetFile`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderAssetBundleGetFileQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderAssetBundleGetFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderAssetBundleGetFileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>> = ({ signal }) => getApiBotProviderAssetBundleGetFile(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderAssetBundleGetFileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>>
export type GetApiBotProviderAssetBundleGetFileQueryError = AxiosError<unknown>



export function useGetApiBotProviderAssetBundleGetFile<TData = Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderAssetBundleGetFileParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderAssetBundleGetFile>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderAssetBundleGetFileQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiBotProviderAssetBundleDeleteBundle = (
    params?: DeleteApiBotProviderAssetBundleDeleteBundleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderAssetBundle/DeleteBundle`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderAssetBundleDeleteBundleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteBundleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteBundleParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderAssetBundleDeleteBundle'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>, {params?: DeleteApiBotProviderAssetBundleDeleteBundleParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderAssetBundleDeleteBundle(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderAssetBundleDeleteBundleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>>
    
    export type DeleteApiBotProviderAssetBundleDeleteBundleMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderAssetBundleDeleteBundle = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>, TError,{params?: DeleteApiBotProviderAssetBundleDeleteBundleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderAssetBundleDeleteBundle>>,
        TError,
        {params?: DeleteApiBotProviderAssetBundleDeleteBundleParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderAssetBundleDeleteBundleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleRenameBundle = (
    renameBundleRequest: RenameBundleRequest,
    params?: PostApiBotProviderAssetBundleRenameBundleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/RenameBundle`,
      renameBundleRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleRenameBundleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>, TError,{data: RenameBundleRequest;params?: PostApiBotProviderAssetBundleRenameBundleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>, TError,{data: RenameBundleRequest;params?: PostApiBotProviderAssetBundleRenameBundleParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleRenameBundle'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>, {data: RenameBundleRequest;params?: PostApiBotProviderAssetBundleRenameBundleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleRenameBundle(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleRenameBundleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>>
    export type PostApiBotProviderAssetBundleRenameBundleMutationBody = RenameBundleRequest
    export type PostApiBotProviderAssetBundleRenameBundleMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleRenameBundle = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>, TError,{data: RenameBundleRequest;params?: PostApiBotProviderAssetBundleRenameBundleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameBundle>>,
        TError,
        {data: RenameBundleRequest;params?: PostApiBotProviderAssetBundleRenameBundleParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleRenameBundleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleDuplicateBundle = (
    duplicateBundleRequest: DuplicateBundleRequest,
    params?: PostApiBotProviderAssetBundleDuplicateBundleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/DuplicateBundle`,
      duplicateBundleRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleDuplicateBundleMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>, TError,{data: DuplicateBundleRequest;params?: PostApiBotProviderAssetBundleDuplicateBundleParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>, TError,{data: DuplicateBundleRequest;params?: PostApiBotProviderAssetBundleDuplicateBundleParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleDuplicateBundle'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>, {data: DuplicateBundleRequest;params?: PostApiBotProviderAssetBundleDuplicateBundleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleDuplicateBundle(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleDuplicateBundleMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>>
    export type PostApiBotProviderAssetBundleDuplicateBundleMutationBody = DuplicateBundleRequest
    export type PostApiBotProviderAssetBundleDuplicateBundleMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleDuplicateBundle = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>, TError,{data: DuplicateBundleRequest;params?: PostApiBotProviderAssetBundleDuplicateBundleParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateBundle>>,
        TError,
        {data: DuplicateBundleRequest;params?: PostApiBotProviderAssetBundleDuplicateBundleParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleDuplicateBundleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleRenameFile = (
    renameFileRequest: RenameFileRequest,
    params?: PostApiBotProviderAssetBundleRenameFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/RenameFile`,
      renameFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleRenameFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>, TError,{data: RenameFileRequest;params?: PostApiBotProviderAssetBundleRenameFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>, TError,{data: RenameFileRequest;params?: PostApiBotProviderAssetBundleRenameFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleRenameFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>, {data: RenameFileRequest;params?: PostApiBotProviderAssetBundleRenameFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleRenameFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleRenameFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>>
    export type PostApiBotProviderAssetBundleRenameFileMutationBody = RenameFileRequest
    export type PostApiBotProviderAssetBundleRenameFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleRenameFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>, TError,{data: RenameFileRequest;params?: PostApiBotProviderAssetBundleRenameFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFile>>,
        TError,
        {data: RenameFileRequest;params?: PostApiBotProviderAssetBundleRenameFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleRenameFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleDuplicateFile = (
    duplicateFileRequest: DuplicateFileRequest,
    params?: PostApiBotProviderAssetBundleDuplicateFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/DuplicateFile`,
      duplicateFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleDuplicateFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>, TError,{data: DuplicateFileRequest;params?: PostApiBotProviderAssetBundleDuplicateFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>, TError,{data: DuplicateFileRequest;params?: PostApiBotProviderAssetBundleDuplicateFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleDuplicateFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>, {data: DuplicateFileRequest;params?: PostApiBotProviderAssetBundleDuplicateFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleDuplicateFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleDuplicateFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>>
    export type PostApiBotProviderAssetBundleDuplicateFileMutationBody = DuplicateFileRequest
    export type PostApiBotProviderAssetBundleDuplicateFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleDuplicateFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>, TError,{data: DuplicateFileRequest;params?: PostApiBotProviderAssetBundleDuplicateFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFile>>,
        TError,
        {data: DuplicateFileRequest;params?: PostApiBotProviderAssetBundleDuplicateFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleDuplicateFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleRenameFolder = (
    renameFolderRequest: RenameFolderRequest,
    params?: PostApiBotProviderAssetBundleRenameFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/RenameFolder`,
      renameFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleRenameFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>, TError,{data: RenameFolderRequest;params?: PostApiBotProviderAssetBundleRenameFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>, TError,{data: RenameFolderRequest;params?: PostApiBotProviderAssetBundleRenameFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleRenameFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>, {data: RenameFolderRequest;params?: PostApiBotProviderAssetBundleRenameFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleRenameFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleRenameFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>>
    export type PostApiBotProviderAssetBundleRenameFolderMutationBody = RenameFolderRequest
    export type PostApiBotProviderAssetBundleRenameFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleRenameFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>, TError,{data: RenameFolderRequest;params?: PostApiBotProviderAssetBundleRenameFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleRenameFolder>>,
        TError,
        {data: RenameFolderRequest;params?: PostApiBotProviderAssetBundleRenameFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleRenameFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderAssetBundleDuplicateFolder = (
    duplicateFolderRequest: DuplicateFolderRequest,
    params?: PostApiBotProviderAssetBundleDuplicateFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AssetBundleItem>> => {
    
    
    return axios.post(
      `/api/BotProviderAssetBundle/DuplicateFolder`,
      duplicateFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderAssetBundleDuplicateFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>, TError,{data: DuplicateFolderRequest;params?: PostApiBotProviderAssetBundleDuplicateFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>, TError,{data: DuplicateFolderRequest;params?: PostApiBotProviderAssetBundleDuplicateFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderAssetBundleDuplicateFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>, {data: DuplicateFolderRequest;params?: PostApiBotProviderAssetBundleDuplicateFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderAssetBundleDuplicateFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderAssetBundleDuplicateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>>
    export type PostApiBotProviderAssetBundleDuplicateFolderMutationBody = DuplicateFolderRequest
    export type PostApiBotProviderAssetBundleDuplicateFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderAssetBundleDuplicateFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>, TError,{data: DuplicateFolderRequest;params?: PostApiBotProviderAssetBundleDuplicateFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderAssetBundleDuplicateFolder>>,
        TError,
        {data: DuplicateFolderRequest;params?: PostApiBotProviderAssetBundleDuplicateFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderAssetBundleDuplicateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderList = (
    params?: GetApiBotProviderListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider[]>> => {
    
    
    return axios.get(
      `/api/BotProvider/List`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderListQueryKey = (params?: GetApiBotProviderListParams,) => {
    return [
    `/api/BotProvider/List`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderListQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderList>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderList>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderList>>> = ({ signal }) => getApiBotProviderList(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderList>>>
export type GetApiBotProviderListQueryError = AxiosError<unknown>



export function useGetApiBotProviderList<TData = Awaited<ReturnType<typeof getApiBotProviderList>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderList>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderGet = (
    params?: GetApiBotProviderGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider>> => {
    
    
    return axios.get(
      `/api/BotProvider/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderGetQueryKey = (params?: GetApiBotProviderGetParams,) => {
    return [
    `/api/BotProvider/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderGet>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderGet>>> = ({ signal }) => getApiBotProviderGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderGet>>>
export type GetApiBotProviderGetQueryError = AxiosError<unknown>



export function useGetApiBotProviderGet<TData = Awaited<ReturnType<typeof getApiBotProviderGet>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiBotProviderCreate = (
    botProvider: BotProvider,
    params?: PostApiBotProviderCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider>> => {
    
    
    return axios.post(
      `/api/BotProvider/Create`,
      botProvider,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCreate>>, TError,{data: BotProvider;params?: PostApiBotProviderCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCreate>>, TError,{data: BotProvider;params?: PostApiBotProviderCreateParams}, TContext> => {

const mutationKey = ['postApiBotProviderCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCreate>>, {data: BotProvider;params?: PostApiBotProviderCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCreate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCreate>>>
    export type PostApiBotProviderCreateMutationBody = BotProvider
    export type PostApiBotProviderCreateMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCreate>>, TError,{data: BotProvider;params?: PostApiBotProviderCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCreate>>,
        TError,
        {data: BotProvider;params?: PostApiBotProviderCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiBotProviderRename = (
    params?: PutApiBotProviderRenameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/BotProvider/Rename`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiBotProviderRenameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderRename>>, TError,{params?: PutApiBotProviderRenameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderRename>>, TError,{params?: PutApiBotProviderRenameParams}, TContext> => {

const mutationKey = ['putApiBotProviderRename'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiBotProviderRename>>, {params?: PutApiBotProviderRenameParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiBotProviderRename(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiBotProviderRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiBotProviderRename>>>
    
    export type PutApiBotProviderRenameMutationError = AxiosError<unknown>

    export const usePutApiBotProviderRename = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderRename>>, TError,{params?: PutApiBotProviderRenameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiBotProviderRename>>,
        TError,
        {params?: PutApiBotProviderRenameParams},
        TContext
      > => {

      const mutationOptions = getPutApiBotProviderRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiBotProviderUpdate = (
    botProvider: BotProvider,
    params?: PutApiBotProviderUpdateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/BotProvider/Update`,
      botProvider,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiBotProviderUpdateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderUpdate>>, TError,{data: BotProvider;params?: PutApiBotProviderUpdateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderUpdate>>, TError,{data: BotProvider;params?: PutApiBotProviderUpdateParams}, TContext> => {

const mutationKey = ['putApiBotProviderUpdate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiBotProviderUpdate>>, {data: BotProvider;params?: PutApiBotProviderUpdateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiBotProviderUpdate(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiBotProviderUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiBotProviderUpdate>>>
    export type PutApiBotProviderUpdateMutationBody = BotProvider
    export type PutApiBotProviderUpdateMutationError = AxiosError<unknown>

    export const usePutApiBotProviderUpdate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderUpdate>>, TError,{data: BotProvider;params?: PutApiBotProviderUpdateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiBotProviderUpdate>>,
        TError,
        {data: BotProvider;params?: PutApiBotProviderUpdateParams},
        TContext
      > => {

      const mutationOptions = getPutApiBotProviderUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiBotProviderDelete = (
    params?: PutApiBotProviderDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/BotProvider/Delete`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiBotProviderDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderDelete>>, TError,{params?: PutApiBotProviderDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderDelete>>, TError,{params?: PutApiBotProviderDeleteParams}, TContext> => {

const mutationKey = ['putApiBotProviderDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiBotProviderDelete>>, {params?: PutApiBotProviderDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiBotProviderDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiBotProviderDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof putApiBotProviderDelete>>>
    
    export type PutApiBotProviderDeleteMutationError = AxiosError<unknown>

    export const usePutApiBotProviderDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderDelete>>, TError,{params?: PutApiBotProviderDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiBotProviderDelete>>,
        TError,
        {params?: PutApiBotProviderDeleteParams},
        TContext
      > => {

      const mutationOptions = getPutApiBotProviderDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderExport = (
    params?: PostApiBotProviderExportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider>> => {
    
    
    return axios.post(
      `/api/BotProvider/Export`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderExportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderExport>>, TError,{params?: PostApiBotProviderExportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderExport>>, TError,{params?: PostApiBotProviderExportParams}, TContext> => {

const mutationKey = ['postApiBotProviderExport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderExport>>, {params?: PostApiBotProviderExportParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiBotProviderExport(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderExportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderExport>>>
    
    export type PostApiBotProviderExportMutationError = AxiosError<unknown>

    export const usePostApiBotProviderExport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderExport>>, TError,{params?: PostApiBotProviderExportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderExport>>,
        TError,
        {params?: PostApiBotProviderExportParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderExportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderImport = (
    botProviderImportModel: BotProviderImportModel,
    params?: PostApiBotProviderImportParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider>> => {
    
    
    return axios.post(
      `/api/BotProvider/Import`,
      botProviderImportModel,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderImportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderImport>>, TError,{data: BotProviderImportModel;params?: PostApiBotProviderImportParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderImport>>, TError,{data: BotProviderImportModel;params?: PostApiBotProviderImportParams}, TContext> => {

const mutationKey = ['postApiBotProviderImport'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderImport>>, {data: BotProviderImportModel;params?: PostApiBotProviderImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderImport(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderImport>>>
    export type PostApiBotProviderImportMutationBody = BotProviderImportModel
    export type PostApiBotProviderImportMutationError = AxiosError<unknown>

    export const usePostApiBotProviderImport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderImport>>, TError,{data: BotProviderImportModel;params?: PostApiBotProviderImportParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderImport>>,
        TError,
        {data: BotProviderImportModel;params?: PostApiBotProviderImportParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderGetScheme = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProviderDataScheme>> => {
    
    
    return axios.get(
      `/api/BotProvider/GetScheme`,options
    );
  }




export const getGetApiBotProviderGetSchemeQueryKey = () => {
    return [
    `/api/BotProvider/GetScheme`
    ] as const;
    }

    
export const getGetApiBotProviderGetSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderGetScheme>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGetScheme>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderGetSchemeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderGetScheme>>> = ({ signal }) => getApiBotProviderGetScheme({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGetScheme>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderGetSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderGetScheme>>>
export type GetApiBotProviderGetSchemeQueryError = AxiosError<unknown>



export function useGetApiBotProviderGetScheme<TData = Awaited<ReturnType<typeof getApiBotProviderGetScheme>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderGetScheme>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderGetSchemeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderCustomUiGetConfig = (
    params?: GetApiBotProviderCustomUiGetConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebBotCustomUiConfig>> => {
    
    
    return axios.get(
      `/api/BotProviderCustomUi/GetConfig`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderCustomUiGetConfigQueryKey = (params?: GetApiBotProviderCustomUiGetConfigParams,) => {
    return [
    `/api/BotProviderCustomUi/GetConfig`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderCustomUiGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderCustomUiGetConfigParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderCustomUiGetConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>> = ({ signal }) => getApiBotProviderCustomUiGetConfig(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderCustomUiGetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>>
export type GetApiBotProviderCustomUiGetConfigQueryError = AxiosError<unknown>



export function useGetApiBotProviderCustomUiGetConfig<TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderCustomUiGetConfigParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetConfig>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderCustomUiGetConfigQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderCustomUiListFiles = (
    params?: GetApiBotProviderCustomUiListFilesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.get(
      `/api/BotProviderCustomUi/ListFiles`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderCustomUiListFilesQueryKey = (params?: GetApiBotProviderCustomUiListFilesParams,) => {
    return [
    `/api/BotProviderCustomUi/ListFiles`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderCustomUiListFilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderCustomUiListFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderCustomUiListFilesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>> = ({ signal }) => getApiBotProviderCustomUiListFiles(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderCustomUiListFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>>
export type GetApiBotProviderCustomUiListFilesQueryError = AxiosError<unknown>



export function useGetApiBotProviderCustomUiListFiles<TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderCustomUiListFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiListFiles>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderCustomUiListFilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiBotProviderCustomUiUpdateConfig = (
    updateCustomUiConfigRequest: UpdateCustomUiConfigRequest,
    params?: PutApiBotProviderCustomUiUpdateConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WebBotCustomUiConfig>> => {
    
    
    return axios.put(
      `/api/BotProviderCustomUi/UpdateConfig`,
      updateCustomUiConfigRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiBotProviderCustomUiUpdateConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>, TError,{data: UpdateCustomUiConfigRequest;params?: PutApiBotProviderCustomUiUpdateConfigParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>, TError,{data: UpdateCustomUiConfigRequest;params?: PutApiBotProviderCustomUiUpdateConfigParams}, TContext> => {

const mutationKey = ['putApiBotProviderCustomUiUpdateConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>, {data: UpdateCustomUiConfigRequest;params?: PutApiBotProviderCustomUiUpdateConfigParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putApiBotProviderCustomUiUpdateConfig(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiBotProviderCustomUiUpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>>
    export type PutApiBotProviderCustomUiUpdateConfigMutationBody = UpdateCustomUiConfigRequest
    export type PutApiBotProviderCustomUiUpdateConfigMutationError = AxiosError<unknown>

    export const usePutApiBotProviderCustomUiUpdateConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>, TError,{data: UpdateCustomUiConfigRequest;params?: PutApiBotProviderCustomUiUpdateConfigParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiBotProviderCustomUiUpdateConfig>>,
        TError,
        {data: UpdateCustomUiConfigRequest;params?: PutApiBotProviderCustomUiUpdateConfigParams},
        TContext
      > => {

      const mutationOptions = getPutApiBotProviderCustomUiUpdateConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiUploadZip = (
    postApiBotProviderCustomUiUploadZipBody: PostApiBotProviderCustomUiUploadZipBody,
    params?: PostApiBotProviderCustomUiUploadZipParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiUploadResult>> => {
    
    const formData = new FormData();
if(postApiBotProviderCustomUiUploadZipBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderCustomUiUploadZipBody.file)
 }

    return axios.post(
      `/api/BotProviderCustomUi/UploadZip`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiUploadZipMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>, TError,{data: PostApiBotProviderCustomUiUploadZipBody;params?: PostApiBotProviderCustomUiUploadZipParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>, TError,{data: PostApiBotProviderCustomUiUploadZipBody;params?: PostApiBotProviderCustomUiUploadZipParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiUploadZip'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>, {data: PostApiBotProviderCustomUiUploadZipBody;params?: PostApiBotProviderCustomUiUploadZipParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiUploadZip(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiUploadZipMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>>
    export type PostApiBotProviderCustomUiUploadZipMutationBody = PostApiBotProviderCustomUiUploadZipBody
    export type PostApiBotProviderCustomUiUploadZipMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiUploadZip = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>, TError,{data: PostApiBotProviderCustomUiUploadZipBody;params?: PostApiBotProviderCustomUiUploadZipParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadZip>>,
        TError,
        {data: PostApiBotProviderCustomUiUploadZipBody;params?: PostApiBotProviderCustomUiUploadZipParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiUploadZipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiApplyBotConfig = (
    applyBotConfigRequest: ApplyBotConfigRequest,
    params?: PostApiBotProviderCustomUiApplyBotConfigParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProvider>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/ApplyBotConfig`,
      applyBotConfigRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiApplyBotConfigMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>, TError,{data: ApplyBotConfigRequest;params?: PostApiBotProviderCustomUiApplyBotConfigParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>, TError,{data: ApplyBotConfigRequest;params?: PostApiBotProviderCustomUiApplyBotConfigParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiApplyBotConfig'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>, {data: ApplyBotConfigRequest;params?: PostApiBotProviderCustomUiApplyBotConfigParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiApplyBotConfig(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiApplyBotConfigMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>>
    export type PostApiBotProviderCustomUiApplyBotConfigMutationBody = ApplyBotConfigRequest
    export type PostApiBotProviderCustomUiApplyBotConfigMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiApplyBotConfig = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>, TError,{data: ApplyBotConfigRequest;params?: PostApiBotProviderCustomUiApplyBotConfigParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiApplyBotConfig>>,
        TError,
        {data: ApplyBotConfigRequest;params?: PostApiBotProviderCustomUiApplyBotConfigParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiApplyBotConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderCustomUiDownloadZip = (
    params?: GetApiBotProviderCustomUiDownloadZipParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `/api/BotProviderCustomUi/DownloadZip`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderCustomUiDownloadZipQueryKey = (params?: GetApiBotProviderCustomUiDownloadZipParams,) => {
    return [
    `/api/BotProviderCustomUi/DownloadZip`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderCustomUiDownloadZipQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderCustomUiDownloadZipParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderCustomUiDownloadZipQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>> = ({ signal }) => getApiBotProviderCustomUiDownloadZip(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderCustomUiDownloadZipQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>>
export type GetApiBotProviderCustomUiDownloadZipQueryError = AxiosError<unknown>



export function useGetApiBotProviderCustomUiDownloadZip<TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderCustomUiDownloadZipParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiDownloadZip>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderCustomUiDownloadZipQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderCustomUiGetFileContent = (
    params?: GetApiBotProviderCustomUiGetFileContentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.get(
      `/api/BotProviderCustomUi/GetFileContent`,{
        responseType: 'text',
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderCustomUiGetFileContentQueryKey = (params?: GetApiBotProviderCustomUiGetFileContentParams,) => {
    return [
    `/api/BotProviderCustomUi/GetFileContent`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderCustomUiGetFileContentQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderCustomUiGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderCustomUiGetFileContentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>> = ({ signal }) => getApiBotProviderCustomUiGetFileContent(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderCustomUiGetFileContentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>>
export type GetApiBotProviderCustomUiGetFileContentQueryError = AxiosError<unknown>



export function useGetApiBotProviderCustomUiGetFileContent<TData = Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderCustomUiGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderCustomUiGetFileContent>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderCustomUiGetFileContentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiBotProviderCustomUiSaveFile = (
    saveCustomUiFileRequest: SaveCustomUiFileRequest,
    params?: PostApiBotProviderCustomUiSaveFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/SaveFile`,
      saveCustomUiFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiSaveFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>, TError,{data: SaveCustomUiFileRequest;params?: PostApiBotProviderCustomUiSaveFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>, TError,{data: SaveCustomUiFileRequest;params?: PostApiBotProviderCustomUiSaveFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiSaveFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>, {data: SaveCustomUiFileRequest;params?: PostApiBotProviderCustomUiSaveFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiSaveFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiSaveFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>>
    export type PostApiBotProviderCustomUiSaveFileMutationBody = SaveCustomUiFileRequest
    export type PostApiBotProviderCustomUiSaveFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiSaveFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>, TError,{data: SaveCustomUiFileRequest;params?: PostApiBotProviderCustomUiSaveFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiSaveFile>>,
        TError,
        {data: SaveCustomUiFileRequest;params?: PostApiBotProviderCustomUiSaveFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiSaveFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderCustomUiDeleteFile = (
    params?: DeleteApiBotProviderCustomUiDeleteFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.delete(
      `/api/BotProviderCustomUi/DeleteFile`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderCustomUiDeleteFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFileParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderCustomUiDeleteFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>, {params?: DeleteApiBotProviderCustomUiDeleteFileParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderCustomUiDeleteFile(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderCustomUiDeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>>
    
    export type DeleteApiBotProviderCustomUiDeleteFileMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderCustomUiDeleteFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFile>>,
        TError,
        {params?: DeleteApiBotProviderCustomUiDeleteFileParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderCustomUiDeleteFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiUploadFile = (
    postApiBotProviderCustomUiUploadFileBody: PostApiBotProviderCustomUiUploadFileBody,
    params?: PostApiBotProviderCustomUiUploadFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    const formData = new FormData();
if(postApiBotProviderCustomUiUploadFileBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderCustomUiUploadFileBody.file)
 }

    return axios.post(
      `/api/BotProviderCustomUi/UploadFile`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiUploadFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>, TError,{data: PostApiBotProviderCustomUiUploadFileBody;params?: PostApiBotProviderCustomUiUploadFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>, TError,{data: PostApiBotProviderCustomUiUploadFileBody;params?: PostApiBotProviderCustomUiUploadFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiUploadFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>, {data: PostApiBotProviderCustomUiUploadFileBody;params?: PostApiBotProviderCustomUiUploadFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiUploadFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>>
    export type PostApiBotProviderCustomUiUploadFileMutationBody = PostApiBotProviderCustomUiUploadFileBody
    export type PostApiBotProviderCustomUiUploadFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiUploadFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>, TError,{data: PostApiBotProviderCustomUiUploadFileBody;params?: PostApiBotProviderCustomUiUploadFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiUploadFile>>,
        TError,
        {data: PostApiBotProviderCustomUiUploadFileBody;params?: PostApiBotProviderCustomUiUploadFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiCreateFolder = (
    createCustomUiFolderRequest: CreateCustomUiFolderRequest,
    params?: PostApiBotProviderCustomUiCreateFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/CreateFolder`,
      createCustomUiFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiCreateFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>, TError,{data: CreateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiCreateFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>, TError,{data: CreateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiCreateFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiCreateFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>, {data: CreateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiCreateFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiCreateFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiCreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>>
    export type PostApiBotProviderCustomUiCreateFolderMutationBody = CreateCustomUiFolderRequest
    export type PostApiBotProviderCustomUiCreateFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiCreateFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>, TError,{data: CreateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiCreateFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiCreateFolder>>,
        TError,
        {data: CreateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiCreateFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiCreateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderCustomUiDeleteFolder = (
    params?: DeleteApiBotProviderCustomUiDeleteFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.delete(
      `/api/BotProviderCustomUi/DeleteFolder`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderCustomUiDeleteFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFolderParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderCustomUiDeleteFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>, {params?: DeleteApiBotProviderCustomUiDeleteFolderParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderCustomUiDeleteFolder(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderCustomUiDeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>>
    
    export type DeleteApiBotProviderCustomUiDeleteFolderMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderCustomUiDeleteFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>, TError,{params?: DeleteApiBotProviderCustomUiDeleteFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderCustomUiDeleteFolder>>,
        TError,
        {params?: DeleteApiBotProviderCustomUiDeleteFolderParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderCustomUiDeleteFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiRenameFile = (
    renameCustomUiFileRequest: RenameCustomUiFileRequest,
    params?: PostApiBotProviderCustomUiRenameFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/RenameFile`,
      renameCustomUiFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiRenameFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>, TError,{data: RenameCustomUiFileRequest;params?: PostApiBotProviderCustomUiRenameFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>, TError,{data: RenameCustomUiFileRequest;params?: PostApiBotProviderCustomUiRenameFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiRenameFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>, {data: RenameCustomUiFileRequest;params?: PostApiBotProviderCustomUiRenameFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiRenameFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiRenameFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>>
    export type PostApiBotProviderCustomUiRenameFileMutationBody = RenameCustomUiFileRequest
    export type PostApiBotProviderCustomUiRenameFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiRenameFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>, TError,{data: RenameCustomUiFileRequest;params?: PostApiBotProviderCustomUiRenameFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFile>>,
        TError,
        {data: RenameCustomUiFileRequest;params?: PostApiBotProviderCustomUiRenameFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiRenameFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiDuplicateFile = (
    duplicateCustomUiFileRequest: DuplicateCustomUiFileRequest,
    params?: PostApiBotProviderCustomUiDuplicateFileParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/DuplicateFile`,
      duplicateCustomUiFileRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiDuplicateFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>, TError,{data: DuplicateCustomUiFileRequest;params?: PostApiBotProviderCustomUiDuplicateFileParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>, TError,{data: DuplicateCustomUiFileRequest;params?: PostApiBotProviderCustomUiDuplicateFileParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiDuplicateFile'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>, {data: DuplicateCustomUiFileRequest;params?: PostApiBotProviderCustomUiDuplicateFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiDuplicateFile(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiDuplicateFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>>
    export type PostApiBotProviderCustomUiDuplicateFileMutationBody = DuplicateCustomUiFileRequest
    export type PostApiBotProviderCustomUiDuplicateFileMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiDuplicateFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>, TError,{data: DuplicateCustomUiFileRequest;params?: PostApiBotProviderCustomUiDuplicateFileParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFile>>,
        TError,
        {data: DuplicateCustomUiFileRequest;params?: PostApiBotProviderCustomUiDuplicateFileParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiDuplicateFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiRenameFolder = (
    renameCustomUiFolderRequest: RenameCustomUiFolderRequest,
    params?: PostApiBotProviderCustomUiRenameFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/RenameFolder`,
      renameCustomUiFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiRenameFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>, TError,{data: RenameCustomUiFolderRequest;params?: PostApiBotProviderCustomUiRenameFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>, TError,{data: RenameCustomUiFolderRequest;params?: PostApiBotProviderCustomUiRenameFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiRenameFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>, {data: RenameCustomUiFolderRequest;params?: PostApiBotProviderCustomUiRenameFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiRenameFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiRenameFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>>
    export type PostApiBotProviderCustomUiRenameFolderMutationBody = RenameCustomUiFolderRequest
    export type PostApiBotProviderCustomUiRenameFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiRenameFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>, TError,{data: RenameCustomUiFolderRequest;params?: PostApiBotProviderCustomUiRenameFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiRenameFolder>>,
        TError,
        {data: RenameCustomUiFolderRequest;params?: PostApiBotProviderCustomUiRenameFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiRenameFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderCustomUiDuplicateFolder = (
    duplicateCustomUiFolderRequest: DuplicateCustomUiFolderRequest,
    params?: PostApiBotProviderCustomUiDuplicateFolderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomUiFileItem[]>> => {
    
    
    return axios.post(
      `/api/BotProviderCustomUi/DuplicateFolder`,
      duplicateCustomUiFolderRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderCustomUiDuplicateFolderMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>, TError,{data: DuplicateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiDuplicateFolderParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>, TError,{data: DuplicateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiDuplicateFolderParams}, TContext> => {

const mutationKey = ['postApiBotProviderCustomUiDuplicateFolder'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>, {data: DuplicateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiDuplicateFolderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderCustomUiDuplicateFolder(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderCustomUiDuplicateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>>
    export type PostApiBotProviderCustomUiDuplicateFolderMutationBody = DuplicateCustomUiFolderRequest
    export type PostApiBotProviderCustomUiDuplicateFolderMutationError = AxiosError<unknown>

    export const usePostApiBotProviderCustomUiDuplicateFolder = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>, TError,{data: DuplicateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiDuplicateFolderParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderCustomUiDuplicateFolder>>,
        TError,
        {data: DuplicateCustomUiFolderRequest;params?: PostApiBotProviderCustomUiDuplicateFolderParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderCustomUiDuplicateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderCustomUiReset = (
    params?: DeleteApiBotProviderCustomUiResetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderCustomUi/Reset`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderCustomUiResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>, TError,{params?: DeleteApiBotProviderCustomUiResetParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>, TError,{params?: DeleteApiBotProviderCustomUiResetParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderCustomUiReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>, {params?: DeleteApiBotProviderCustomUiResetParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderCustomUiReset(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderCustomUiResetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>>
    
    export type DeleteApiBotProviderCustomUiResetMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderCustomUiReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>, TError,{params?: DeleteApiBotProviderCustomUiResetParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderCustomUiReset>>,
        TError,
        {params?: DeleteApiBotProviderCustomUiResetParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderCustomUiResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderStatisticsGetByBotProviderId = (
    params?: GetApiBotProviderStatisticsGetByBotProviderIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProviderStatistics>> => {
    
    
    return axios.get(
      `/api/BotProviderStatistics/GetByBotProviderId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderStatisticsGetByBotProviderIdQueryKey = (params?: GetApiBotProviderStatisticsGetByBotProviderIdParams,) => {
    return [
    `/api/BotProviderStatistics/GetByBotProviderId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderStatisticsGetByBotProviderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderStatisticsGetByBotProviderIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderStatisticsGetByBotProviderIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>> = ({ signal }) => getApiBotProviderStatisticsGetByBotProviderId(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderStatisticsGetByBotProviderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>>
export type GetApiBotProviderStatisticsGetByBotProviderIdQueryError = AxiosError<unknown>



export function useGetApiBotProviderStatisticsGetByBotProviderId<TData = Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderStatisticsGetByBotProviderIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderStatisticsGetByBotProviderId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderStatisticsGetByBotProviderIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiBotProviderUploadUploadAvatarIcon = (
    postApiBotProviderUploadUploadAvatarIconBody: PostApiBotProviderUploadUploadAvatarIconBody,
    params?: PostApiBotProviderUploadUploadAvatarIconParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiBotProviderUploadUploadAvatarIconBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderUploadUploadAvatarIconBody.file)
 }

    return axios.post(
      `/api/BotProviderUpload/UploadAvatarIcon`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderUploadUploadAvatarIconMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>, TError,{data: PostApiBotProviderUploadUploadAvatarIconBody;params?: PostApiBotProviderUploadUploadAvatarIconParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>, TError,{data: PostApiBotProviderUploadUploadAvatarIconBody;params?: PostApiBotProviderUploadUploadAvatarIconParams}, TContext> => {

const mutationKey = ['postApiBotProviderUploadUploadAvatarIcon'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>, {data: PostApiBotProviderUploadUploadAvatarIconBody;params?: PostApiBotProviderUploadUploadAvatarIconParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderUploadUploadAvatarIcon(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderUploadUploadAvatarIconMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>>
    export type PostApiBotProviderUploadUploadAvatarIconMutationBody = PostApiBotProviderUploadUploadAvatarIconBody
    export type PostApiBotProviderUploadUploadAvatarIconMutationError = AxiosError<unknown>

    export const usePostApiBotProviderUploadUploadAvatarIcon = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>, TError,{data: PostApiBotProviderUploadUploadAvatarIconBody;params?: PostApiBotProviderUploadUploadAvatarIconParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderUploadUploadAvatarIcon>>,
        TError,
        {data: PostApiBotProviderUploadUploadAvatarIconBody;params?: PostApiBotProviderUploadUploadAvatarIconParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderUploadUploadAvatarIconMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderUploadDeleteAvatarIcon = (
    params?: DeleteApiBotProviderUploadDeleteAvatarIconParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderUpload/DeleteAvatarIcon`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderUploadDeleteAvatarIconMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteAvatarIconParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteAvatarIconParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderUploadDeleteAvatarIcon'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>, {params?: DeleteApiBotProviderUploadDeleteAvatarIconParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderUploadDeleteAvatarIcon(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderUploadDeleteAvatarIconMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>>
    
    export type DeleteApiBotProviderUploadDeleteAvatarIconMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderUploadDeleteAvatarIcon = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteAvatarIconParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteAvatarIcon>>,
        TError,
        {params?: DeleteApiBotProviderUploadDeleteAvatarIconParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderUploadDeleteAvatarIconMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderUploadUploadWidgetIcon = (
    postApiBotProviderUploadUploadWidgetIconBody: PostApiBotProviderUploadUploadWidgetIconBody,
    params?: PostApiBotProviderUploadUploadWidgetIconParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiBotProviderUploadUploadWidgetIconBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderUploadUploadWidgetIconBody.file)
 }

    return axios.post(
      `/api/BotProviderUpload/UploadWidgetIcon`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderUploadUploadWidgetIconMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>, TError,{data: PostApiBotProviderUploadUploadWidgetIconBody;params?: PostApiBotProviderUploadUploadWidgetIconParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>, TError,{data: PostApiBotProviderUploadUploadWidgetIconBody;params?: PostApiBotProviderUploadUploadWidgetIconParams}, TContext> => {

const mutationKey = ['postApiBotProviderUploadUploadWidgetIcon'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>, {data: PostApiBotProviderUploadUploadWidgetIconBody;params?: PostApiBotProviderUploadUploadWidgetIconParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderUploadUploadWidgetIcon(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderUploadUploadWidgetIconMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>>
    export type PostApiBotProviderUploadUploadWidgetIconMutationBody = PostApiBotProviderUploadUploadWidgetIconBody
    export type PostApiBotProviderUploadUploadWidgetIconMutationError = AxiosError<unknown>

    export const usePostApiBotProviderUploadUploadWidgetIcon = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>, TError,{data: PostApiBotProviderUploadUploadWidgetIconBody;params?: PostApiBotProviderUploadUploadWidgetIconParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderUploadUploadWidgetIcon>>,
        TError,
        {data: PostApiBotProviderUploadUploadWidgetIconBody;params?: PostApiBotProviderUploadUploadWidgetIconParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderUploadUploadWidgetIconMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderUploadDeleteWidgetIcon = (
    params?: DeleteApiBotProviderUploadDeleteWidgetIconParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderUpload/DeleteWidgetIcon`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderUploadDeleteWidgetIconMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteWidgetIconParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteWidgetIconParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderUploadDeleteWidgetIcon'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>, {params?: DeleteApiBotProviderUploadDeleteWidgetIconParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderUploadDeleteWidgetIcon(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderUploadDeleteWidgetIconMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>>
    
    export type DeleteApiBotProviderUploadDeleteWidgetIconMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderUploadDeleteWidgetIcon = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>, TError,{params?: DeleteApiBotProviderUploadDeleteWidgetIconParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteWidgetIcon>>,
        TError,
        {params?: DeleteApiBotProviderUploadDeleteWidgetIconParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderUploadDeleteWidgetIconMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiBotProviderUploadUploadBackgroundImage = (
    postApiBotProviderUploadUploadBackgroundImageBody: PostApiBotProviderUploadUploadBackgroundImageBody,
    params?: PostApiBotProviderUploadUploadBackgroundImageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    const formData = new FormData();
if(postApiBotProviderUploadUploadBackgroundImageBody.file !== undefined) {
 formData.append(`file`, postApiBotProviderUploadUploadBackgroundImageBody.file)
 }

    return axios.post(
      `/api/BotProviderUpload/UploadBackgroundImage`,
      formData,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderUploadUploadBackgroundImageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>, TError,{data: PostApiBotProviderUploadUploadBackgroundImageBody;params?: PostApiBotProviderUploadUploadBackgroundImageParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>, TError,{data: PostApiBotProviderUploadUploadBackgroundImageBody;params?: PostApiBotProviderUploadUploadBackgroundImageParams}, TContext> => {

const mutationKey = ['postApiBotProviderUploadUploadBackgroundImage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>, {data: PostApiBotProviderUploadUploadBackgroundImageBody;params?: PostApiBotProviderUploadUploadBackgroundImageParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderUploadUploadBackgroundImage(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderUploadUploadBackgroundImageMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>>
    export type PostApiBotProviderUploadUploadBackgroundImageMutationBody = PostApiBotProviderUploadUploadBackgroundImageBody
    export type PostApiBotProviderUploadUploadBackgroundImageMutationError = AxiosError<unknown>

    export const usePostApiBotProviderUploadUploadBackgroundImage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>, TError,{data: PostApiBotProviderUploadUploadBackgroundImageBody;params?: PostApiBotProviderUploadUploadBackgroundImageParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderUploadUploadBackgroundImage>>,
        TError,
        {data: PostApiBotProviderUploadUploadBackgroundImageBody;params?: PostApiBotProviderUploadUploadBackgroundImageParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderUploadUploadBackgroundImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiBotProviderUploadDeleteBackgroundImage = (
    params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/BotProviderUpload/DeleteBackgroundImage`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiBotProviderUploadDeleteBackgroundImageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>, TError,{params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>, TError,{params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams}, TContext> => {

const mutationKey = ['deleteApiBotProviderUploadDeleteBackgroundImage'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>, {params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiBotProviderUploadDeleteBackgroundImage(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiBotProviderUploadDeleteBackgroundImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>>
    
    export type DeleteApiBotProviderUploadDeleteBackgroundImageMutationError = AxiosError<unknown>

    export const useDeleteApiBotProviderUploadDeleteBackgroundImage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>, TError,{params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiBotProviderUploadDeleteBackgroundImage>>,
        TError,
        {params?: DeleteApiBotProviderUploadDeleteBackgroundImageParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiBotProviderUploadDeleteBackgroundImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiBotProviderUserSettingsGet = (
    params?: GetApiBotProviderUserSettingsGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProviderUserSettings>> => {
    
    
    return axios.get(
      `/api/BotProviderUserSettings/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderUserSettingsGetQueryKey = (params?: GetApiBotProviderUserSettingsGetParams,) => {
    return [
    `/api/BotProviderUserSettings/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderUserSettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderUserSettingsGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderUserSettingsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>> = ({ signal }) => getApiBotProviderUserSettingsGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderUserSettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>>
export type GetApiBotProviderUserSettingsGetQueryError = AxiosError<unknown>



export function useGetApiBotProviderUserSettingsGet<TData = Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderUserSettingsGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderUserSettingsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiBotProviderUserSettingsGetBotProviderTags = (
    params?: GetApiBotProviderUserSettingsGetBotProviderTagsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.get(
      `/api/BotProviderUserSettings/GetBotProviderTags`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiBotProviderUserSettingsGetBotProviderTagsQueryKey = (params?: GetApiBotProviderUserSettingsGetBotProviderTagsParams,) => {
    return [
    `/api/BotProviderUserSettings/GetBotProviderTags`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiBotProviderUserSettingsGetBotProviderTagsQueryOptions = <TData = Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>, TError = AxiosError<unknown>>(params?: GetApiBotProviderUserSettingsGetBotProviderTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiBotProviderUserSettingsGetBotProviderTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>> = ({ signal }) => getApiBotProviderUserSettingsGetBotProviderTags(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiBotProviderUserSettingsGetBotProviderTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>>
export type GetApiBotProviderUserSettingsGetBotProviderTagsQueryError = AxiosError<unknown>



export function useGetApiBotProviderUserSettingsGetBotProviderTags<TData = Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>, TError = AxiosError<unknown>>(
 params?: GetApiBotProviderUserSettingsGetBotProviderTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiBotProviderUserSettingsGetBotProviderTags>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiBotProviderUserSettingsGetBotProviderTagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiBotProviderUserSettingsUpsert = (
    botProviderUserSettings: BotProviderUserSettings,
    params?: PostApiBotProviderUserSettingsUpsertParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BotProviderUserSettings>> => {
    
    
    return axios.post(
      `/api/BotProviderUserSettings/Upsert`,
      botProviderUserSettings,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiBotProviderUserSettingsUpsertMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>, TError,{data: BotProviderUserSettings;params?: PostApiBotProviderUserSettingsUpsertParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>, TError,{data: BotProviderUserSettings;params?: PostApiBotProviderUserSettingsUpsertParams}, TContext> => {

const mutationKey = ['postApiBotProviderUserSettingsUpsert'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>, {data: BotProviderUserSettings;params?: PostApiBotProviderUserSettingsUpsertParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiBotProviderUserSettingsUpsert(data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiBotProviderUserSettingsUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>>
    export type PostApiBotProviderUserSettingsUpsertMutationBody = BotProviderUserSettings
    export type PostApiBotProviderUserSettingsUpsertMutationError = AxiosError<unknown>

    export const usePostApiBotProviderUserSettingsUpsert = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>, TError,{data: BotProviderUserSettings;params?: PostApiBotProviderUserSettingsUpsertParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiBotProviderUserSettingsUpsert>>,
        TError,
        {data: BotProviderUserSettings;params?: PostApiBotProviderUserSettingsUpsertParams},
        TContext
      > => {

      const mutationOptions = getPostApiBotProviderUserSettingsUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiAdminAuthLogin = (
    authViewModel: AuthViewModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {
    
    
    return axios.post(
      `/api/Admin/Auth/Login`,
      authViewModel,options
    );
  }



export const getPostApiAdminAuthLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext> => {

const mutationKey = ['postApiAdminAuthLogin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, {data: AuthViewModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminAuthLogin(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminAuthLogin>>>
    export type PostApiAdminAuthLoginMutationBody = AuthViewModel
    export type PostApiAdminAuthLoginMutationError = AxiosError<unknown>

    export const usePostApiAdminAuthLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminAuthLogin>>,
        TError,
        {data: AuthViewModel},
        TContext
      > => {

      const mutationOptions = getPostApiAdminAuthLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAdminChatCreditKeyGet = (
    params?: GetApiAdminChatCreditKeyGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatCreditKey>> => {
    
    
    return axios.get(
      `/api/admin/ChatCreditKey/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminChatCreditKeyGetQueryKey = (params?: GetApiAdminChatCreditKeyGetParams,) => {
    return [
    `/api/admin/ChatCreditKey/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminChatCreditKeyGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>, TError = AxiosError<unknown>>(params?: GetApiAdminChatCreditKeyGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminChatCreditKeyGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>> = ({ signal }) => getApiAdminChatCreditKeyGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminChatCreditKeyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>>
export type GetApiAdminChatCreditKeyGetQueryError = AxiosError<unknown>



export function useGetApiAdminChatCreditKeyGet<TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminChatCreditKeyGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminChatCreditKeyGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminChatCreditKeyListByUserId = (
    params?: GetApiAdminChatCreditKeyListByUserIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfChatCreditKey>> => {
    
    
    return axios.get(
      `/api/admin/ChatCreditKey/ListByUserId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminChatCreditKeyListByUserIdQueryKey = (params?: GetApiAdminChatCreditKeyListByUserIdParams,) => {
    return [
    `/api/admin/ChatCreditKey/ListByUserId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminChatCreditKeyListByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>, TError = AxiosError<unknown>>(params?: GetApiAdminChatCreditKeyListByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminChatCreditKeyListByUserIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>> = ({ signal }) => getApiAdminChatCreditKeyListByUserId(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminChatCreditKeyListByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>>
export type GetApiAdminChatCreditKeyListByUserIdQueryError = AxiosError<unknown>



export function useGetApiAdminChatCreditKeyListByUserId<TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminChatCreditKeyListByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyListByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminChatCreditKeyListByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminChatCreditKeyGetValidCreditByUserId = (
    params?: GetApiAdminChatCreditKeyGetValidCreditByUserIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    
    return axios.get(
      `/api/admin/ChatCreditKey/GetValidCreditByUserId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminChatCreditKeyGetValidCreditByUserIdQueryKey = (params?: GetApiAdminChatCreditKeyGetValidCreditByUserIdParams,) => {
    return [
    `/api/admin/ChatCreditKey/GetValidCreditByUserId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminChatCreditKeyGetValidCreditByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>, TError = AxiosError<unknown>>(params?: GetApiAdminChatCreditKeyGetValidCreditByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminChatCreditKeyGetValidCreditByUserIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>> = ({ signal }) => getApiAdminChatCreditKeyGetValidCreditByUserId(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminChatCreditKeyGetValidCreditByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>>
export type GetApiAdminChatCreditKeyGetValidCreditByUserIdQueryError = AxiosError<unknown>



export function useGetApiAdminChatCreditKeyGetValidCreditByUserId<TData = Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminChatCreditKeyGetValidCreditByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatCreditKeyGetValidCreditByUserId>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminChatCreditKeyGetValidCreditByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiAdminChatCreditKeyCreate = (
    chatCreditKey: ChatCreditKey, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/admin/ChatCreditKey/Create`,
      chatCreditKey,options
    );
  }



export const getPostApiAdminChatCreditKeyCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>, TError,{data: ChatCreditKey}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>, TError,{data: ChatCreditKey}, TContext> => {

const mutationKey = ['postApiAdminChatCreditKeyCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>, {data: ChatCreditKey}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminChatCreditKeyCreate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminChatCreditKeyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>>
    export type PostApiAdminChatCreditKeyCreateMutationBody = ChatCreditKey
    export type PostApiAdminChatCreditKeyCreateMutationError = AxiosError<unknown>

    export const usePostApiAdminChatCreditKeyCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>, TError,{data: ChatCreditKey}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminChatCreditKeyCreate>>,
        TError,
        {data: ChatCreditKey},
        TContext
      > => {

      const mutationOptions = getPostApiAdminChatCreditKeyCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiAdminChatCreditKeyUpdate = (
    chatCreditKey: ChatCreditKey, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.put(
      `/api/admin/ChatCreditKey/Update`,
      chatCreditKey,options
    );
  }



export const getPutApiAdminChatCreditKeyUpdateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>, TError,{data: ChatCreditKey}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>, TError,{data: ChatCreditKey}, TContext> => {

const mutationKey = ['putApiAdminChatCreditKeyUpdate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>, {data: ChatCreditKey}> = (props) => {
          const {data} = props ?? {};

          return  putApiAdminChatCreditKeyUpdate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiAdminChatCreditKeyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>>
    export type PutApiAdminChatCreditKeyUpdateMutationBody = ChatCreditKey
    export type PutApiAdminChatCreditKeyUpdateMutationError = AxiosError<unknown>

    export const usePutApiAdminChatCreditKeyUpdate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>, TError,{data: ChatCreditKey}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiAdminChatCreditKeyUpdate>>,
        TError,
        {data: ChatCreditKey},
        TContext
      > => {

      const mutationOptions = getPutApiAdminChatCreditKeyUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiAdminChatCreditKeyDelete = (
    params?: DeleteApiAdminChatCreditKeyDeleteParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/admin/ChatCreditKey/Delete`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiAdminChatCreditKeyDeleteMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>, TError,{params?: DeleteApiAdminChatCreditKeyDeleteParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>, TError,{params?: DeleteApiAdminChatCreditKeyDeleteParams}, TContext> => {

const mutationKey = ['deleteApiAdminChatCreditKeyDelete'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>, {params?: DeleteApiAdminChatCreditKeyDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiAdminChatCreditKeyDelete(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdminChatCreditKeyDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>>
    
    export type DeleteApiAdminChatCreditKeyDeleteMutationError = AxiosError<unknown>

    export const useDeleteApiAdminChatCreditKeyDelete = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>, TError,{params?: DeleteApiAdminChatCreditKeyDeleteParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdminChatCreditKeyDelete>>,
        TError,
        {params?: DeleteApiAdminChatCreditKeyDeleteParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiAdminChatCreditKeyDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAdminUserManagerListUsers = (
    params?: GetApiAdminUserManagerListUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserPagingList>> => {
    
    
    return axios.get(
      `/api/admin/UserManager/ListUsers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminUserManagerListUsersQueryKey = (params?: GetApiAdminUserManagerListUsersParams,) => {
    return [
    `/api/admin/UserManager/ListUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminUserManagerListUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>, TError = AxiosError<unknown>>(params?: GetApiAdminUserManagerListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminUserManagerListUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>> = ({ signal }) => getApiAdminUserManagerListUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminUserManagerListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>>
export type GetApiAdminUserManagerListUsersQueryError = AxiosError<unknown>



export function useGetApiAdminUserManagerListUsers<TData = Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminUserManagerListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerListUsers>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminUserManagerListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminUserManagerGetUser = (
    params?: GetApiAdminUserManagerGetUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    
    return axios.get(
      `/api/admin/UserManager/GetUser`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminUserManagerGetUserQueryKey = (params?: GetApiAdminUserManagerGetUserParams,) => {
    return [
    `/api/admin/UserManager/GetUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminUserManagerGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>, TError = AxiosError<unknown>>(params?: GetApiAdminUserManagerGetUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminUserManagerGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>> = ({ signal }) => getApiAdminUserManagerGetUser(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminUserManagerGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>>
export type GetApiAdminUserManagerGetUserQueryError = AxiosError<unknown>



export function useGetApiAdminUserManagerGetUser<TData = Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminUserManagerGetUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUser>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminUserManagerGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminUserManagerGetUserByName = (
    params?: GetApiAdminUserManagerGetUserByNameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    
    return axios.get(
      `/api/admin/UserManager/GetUserByName`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminUserManagerGetUserByNameQueryKey = (params?: GetApiAdminUserManagerGetUserByNameParams,) => {
    return [
    `/api/admin/UserManager/GetUserByName`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminUserManagerGetUserByNameQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>, TError = AxiosError<unknown>>(params?: GetApiAdminUserManagerGetUserByNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminUserManagerGetUserByNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>> = ({ signal }) => getApiAdminUserManagerGetUserByName(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminUserManagerGetUserByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>>
export type GetApiAdminUserManagerGetUserByNameQueryError = AxiosError<unknown>



export function useGetApiAdminUserManagerGetUserByName<TData = Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminUserManagerGetUserByNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminUserManagerGetUserByName>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminUserManagerGetUserByNameQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiAdminUserManagerCreateUser = (
    userPasswordViewModel: UserPasswordViewModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.post(
      `/api/admin/UserManager/CreateUser`,
      userPasswordViewModel,options
    );
  }



export const getPostApiAdminUserManagerCreateUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>, TError,{data: UserPasswordViewModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>, TError,{data: UserPasswordViewModel}, TContext> => {

const mutationKey = ['postApiAdminUserManagerCreateUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>, {data: UserPasswordViewModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminUserManagerCreateUser(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminUserManagerCreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>>
    export type PostApiAdminUserManagerCreateUserMutationBody = UserPasswordViewModel
    export type PostApiAdminUserManagerCreateUserMutationError = AxiosError<unknown>

    export const usePostApiAdminUserManagerCreateUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>, TError,{data: UserPasswordViewModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminUserManagerCreateUser>>,
        TError,
        {data: UserPasswordViewModel},
        TContext
      > => {

      const mutationOptions = getPostApiAdminUserManagerCreateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchApiAdminUserManagerChangeUserPassword = (
    userIdPasswordViewModel: UserIdPasswordViewModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.patch(
      `/api/admin/UserManager/ChangeUserPassword`,
      userIdPasswordViewModel,options
    );
  }



export const getPatchApiAdminUserManagerChangeUserPasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>, TError,{data: UserIdPasswordViewModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>, TError,{data: UserIdPasswordViewModel}, TContext> => {

const mutationKey = ['patchApiAdminUserManagerChangeUserPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>, {data: UserIdPasswordViewModel}> = (props) => {
          const {data} = props ?? {};

          return  patchApiAdminUserManagerChangeUserPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAdminUserManagerChangeUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>>
    export type PatchApiAdminUserManagerChangeUserPasswordMutationBody = UserIdPasswordViewModel
    export type PatchApiAdminUserManagerChangeUserPasswordMutationError = AxiosError<unknown>

    export const usePatchApiAdminUserManagerChangeUserPassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>, TError,{data: UserIdPasswordViewModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserPassword>>,
        TError,
        {data: UserIdPasswordViewModel},
        TContext
      > => {

      const mutationOptions = getPatchApiAdminUserManagerChangeUserPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchApiAdminUserManagerChangeUserDisplayName = (
    params?: PatchApiAdminUserManagerChangeUserDisplayNameParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.patch(
      `/api/admin/UserManager/ChangeUserDisplayName`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPatchApiAdminUserManagerChangeUserDisplayNameMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>, TError,{params?: PatchApiAdminUserManagerChangeUserDisplayNameParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>, TError,{params?: PatchApiAdminUserManagerChangeUserDisplayNameParams}, TContext> => {

const mutationKey = ['patchApiAdminUserManagerChangeUserDisplayName'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>, {params?: PatchApiAdminUserManagerChangeUserDisplayNameParams}> = (props) => {
          const {params} = props ?? {};

          return  patchApiAdminUserManagerChangeUserDisplayName(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiAdminUserManagerChangeUserDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>>
    
    export type PatchApiAdminUserManagerChangeUserDisplayNameMutationError = AxiosError<unknown>

    export const usePatchApiAdminUserManagerChangeUserDisplayName = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>, TError,{params?: PatchApiAdminUserManagerChangeUserDisplayNameParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchApiAdminUserManagerChangeUserDisplayName>>,
        TError,
        {params?: PatchApiAdminUserManagerChangeUserDisplayNameParams},
        TContext
      > => {

      const mutationOptions = getPatchApiAdminUserManagerChangeUserDisplayNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiAdminUserManagerDeleteUser = (
    params?: DeleteApiAdminUserManagerDeleteUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.delete(
      `/api/admin/UserManager/DeleteUser`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getDeleteApiAdminUserManagerDeleteUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>, TError,{params?: DeleteApiAdminUserManagerDeleteUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>, TError,{params?: DeleteApiAdminUserManagerDeleteUserParams}, TContext> => {

const mutationKey = ['deleteApiAdminUserManagerDeleteUser'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>, {params?: DeleteApiAdminUserManagerDeleteUserParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteApiAdminUserManagerDeleteUser(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdminUserManagerDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>>
    
    export type DeleteApiAdminUserManagerDeleteUserMutationError = AxiosError<unknown>

    export const useDeleteApiAdminUserManagerDeleteUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>, TError,{params?: DeleteApiAdminUserManagerDeleteUserParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdminUserManagerDeleteUser>>,
        TError,
        {params?: DeleteApiAdminUserManagerDeleteUserParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiAdminUserManagerDeleteUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAdminWorkspaceGet = (
    params?: GetApiAdminWorkspaceGetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Workspace>> => {
    
    
    return axios.get(
      `/api/admin/Workspace/Get`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetApiAdminWorkspaceGetQueryKey = (params?: GetApiAdminWorkspaceGetParams,) => {
    return [
    `/api/admin/Workspace/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiAdminWorkspaceGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>, TError = AxiosError<unknown>>(params?: GetApiAdminWorkspaceGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminWorkspaceGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>> = ({ signal }) => getApiAdminWorkspaceGet(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminWorkspaceGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>>
export type GetApiAdminWorkspaceGetQueryError = AxiosError<unknown>



export function useGetApiAdminWorkspaceGet<TData = Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>, TError = AxiosError<unknown>>(
 params?: GetApiAdminWorkspaceGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminWorkspaceGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminWorkspaceGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiAdminWorkspaceListByIds = (
    postApiAdminWorkspaceListByIdsBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Workspace[]>> => {
    
    
    return axios.post(
      `/api/admin/Workspace/ListByIds`,
      postApiAdminWorkspaceListByIdsBody,options
    );
  }



export const getPostApiAdminWorkspaceListByIdsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>, TError,{data: string[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>, TError,{data: string[]}, TContext> => {

const mutationKey = ['postApiAdminWorkspaceListByIds'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminWorkspaceListByIds(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminWorkspaceListByIdsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>>
    export type PostApiAdminWorkspaceListByIdsMutationBody = string[]
    export type PostApiAdminWorkspaceListByIdsMutationError = AxiosError<unknown>

    export const usePostApiAdminWorkspaceListByIds = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>, TError,{data: string[]}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminWorkspaceListByIds>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getPostApiAdminWorkspaceListByIdsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiAdminWorkspaceCreate = (
    params?: PostApiAdminWorkspaceCreateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Workspace>> => {
    
    
    return axios.post(
      `/api/admin/Workspace/Create`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiAdminWorkspaceCreateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>, TError,{params?: PostApiAdminWorkspaceCreateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>, TError,{params?: PostApiAdminWorkspaceCreateParams}, TContext> => {

const mutationKey = ['postApiAdminWorkspaceCreate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>, {params?: PostApiAdminWorkspaceCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiAdminWorkspaceCreate(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminWorkspaceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>>
    
    export type PostApiAdminWorkspaceCreateMutationError = AxiosError<unknown>

    export const usePostApiAdminWorkspaceCreate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>, TError,{params?: PostApiAdminWorkspaceCreateParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminWorkspaceCreate>>,
        TError,
        {params?: PostApiAdminWorkspaceCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiAdminWorkspaceCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postApiAdminWorkspaceSearch = (
    params?: PostApiAdminWorkspaceSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchListResultOfWorkspace>> => {
    
    
    return axios.post(
      `/api/admin/Workspace/Search`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPostApiAdminWorkspaceSearchMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>, TError,{params?: PostApiAdminWorkspaceSearchParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>, TError,{params?: PostApiAdminWorkspaceSearchParams}, TContext> => {

const mutationKey = ['postApiAdminWorkspaceSearch'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>, {params?: PostApiAdminWorkspaceSearchParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiAdminWorkspaceSearch(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminWorkspaceSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>>
    
    export type PostApiAdminWorkspaceSearchMutationError = AxiosError<unknown>

    export const usePostApiAdminWorkspaceSearch = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>, TError,{params?: PostApiAdminWorkspaceSearchParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminWorkspaceSearch>>,
        TError,
        {params?: PostApiAdminWorkspaceSearchParams},
        TContext
      > => {

      const mutationOptions = getPostApiAdminWorkspaceSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiAdminWorkspaceSetOwner = (
    params?: PutApiAdminWorkspaceSetOwnerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    
    return axios.put(
      `/api/admin/Workspace/SetOwner`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getPutApiAdminWorkspaceSetOwnerMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>, TError,{params?: PutApiAdminWorkspaceSetOwnerParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>, TError,{params?: PutApiAdminWorkspaceSetOwnerParams}, TContext> => {

const mutationKey = ['putApiAdminWorkspaceSetOwner'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>, {params?: PutApiAdminWorkspaceSetOwnerParams}> = (props) => {
          const {params} = props ?? {};

          return  putApiAdminWorkspaceSetOwner(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiAdminWorkspaceSetOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>>
    
    export type PutApiAdminWorkspaceSetOwnerMutationError = AxiosError<unknown>

    export const usePutApiAdminWorkspaceSetOwner = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>, TError,{params?: PutApiAdminWorkspaceSetOwnerParams}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiAdminWorkspaceSetOwner>>,
        TError,
        {params?: PutApiAdminWorkspaceSetOwnerParams},
        TContext
      > => {

      const mutationOptions = getPutApiAdminWorkspaceSetOwnerMutationOptions(options);

      return useMutation(mutationOptions);
    }
